
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireaec4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireaec4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("l1JKY", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $f4ed2f49b78487c2$export$ffb0004e005737fa; }, function (v) { return $f4ed2f49b78487c2$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $f4ed2f49b78487c2$export$34b9dba7ce09269b; }, function (v) { return $f4ed2f49b78487c2$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $f4ed2f49b78487c2$export$25062201e9e25d76; }, function (v) { return $f4ed2f49b78487c2$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f4ed2f49b78487c2$export$ffb0004e005737fa;
var $f4ed2f49b78487c2$export$34b9dba7ce09269b;
var $f4ed2f49b78487c2$export$25062201e9e25d76;
'use strict';

var $iQhxf = parcelRequire("iQhxf");
var $f4ed2f49b78487c2$var$k = Symbol.for("react.element"), $f4ed2f49b78487c2$var$l = Symbol.for("react.fragment"), $f4ed2f49b78487c2$var$m = Object.prototype.hasOwnProperty, $f4ed2f49b78487c2$var$n = $iQhxf.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $f4ed2f49b78487c2$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $f4ed2f49b78487c2$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$f4ed2f49b78487c2$var$m.call(a, b) && !$f4ed2f49b78487c2$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $f4ed2f49b78487c2$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $f4ed2f49b78487c2$var$n.current
    };
}
$f4ed2f49b78487c2$export$ffb0004e005737fa = $f4ed2f49b78487c2$var$l;
$f4ed2f49b78487c2$export$34b9dba7ce09269b = $f4ed2f49b78487c2$var$q;
$f4ed2f49b78487c2$export$25062201e9e25d76 = $f4ed2f49b78487c2$var$q;

});
parcelRegister("iQhxf", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hdyhx"));

});
parcelRegister("hdyhx", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $c88e3e35cb8dcee8$export$dca3b0875bd9a954; }, function (v) { return $c88e3e35cb8dcee8$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $c88e3e35cb8dcee8$export$16fa2f45be04daa8; }, function (v) { return $c88e3e35cb8dcee8$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $c88e3e35cb8dcee8$export$ffb0004e005737fa; }, function (v) { return $c88e3e35cb8dcee8$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $c88e3e35cb8dcee8$export$e2c29f18771995cb; }, function (v) { return $c88e3e35cb8dcee8$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $c88e3e35cb8dcee8$export$221d75b3f55bb0bd; }, function (v) { return $c88e3e35cb8dcee8$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $c88e3e35cb8dcee8$export$5f8d39834fd61797; }, function (v) { return $c88e3e35cb8dcee8$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $c88e3e35cb8dcee8$export$74bf444e3cd11ea5; }, function (v) { return $c88e3e35cb8dcee8$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c88e3e35cb8dcee8$export$ae55be85d98224ed; }, function (v) { return $c88e3e35cb8dcee8$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $c88e3e35cb8dcee8$export$e530037191fcd5d7; }, function (v) { return $c88e3e35cb8dcee8$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $c88e3e35cb8dcee8$export$fd42f52fd3ae1109; }, function (v) { return $c88e3e35cb8dcee8$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $c88e3e35cb8dcee8$export$c8a8987d4410bf2d; }, function (v) { return $c88e3e35cb8dcee8$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $c88e3e35cb8dcee8$export$d38cd72104c1f0e9; }, function (v) { return $c88e3e35cb8dcee8$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $c88e3e35cb8dcee8$export$7d1e3a5e95ceca43; }, function (v) { return $c88e3e35cb8dcee8$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $c88e3e35cb8dcee8$export$257a8862b851cb5b; }, function (v) { return $c88e3e35cb8dcee8$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $c88e3e35cb8dcee8$export$a8257692ac88316c; }, function (v) { return $c88e3e35cb8dcee8$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $c88e3e35cb8dcee8$export$488013bae63b21da; }, function (v) { return $c88e3e35cb8dcee8$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $c88e3e35cb8dcee8$export$7c73462e0d25e514; }, function (v) { return $c88e3e35cb8dcee8$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $c88e3e35cb8dcee8$export$7568632d0d33d16d; }, function (v) { return $c88e3e35cb8dcee8$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $c88e3e35cb8dcee8$export$88948ce120ea2619; }, function (v) { return $c88e3e35cb8dcee8$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $c88e3e35cb8dcee8$export$35808ee640e87ca7; }, function (v) { return $c88e3e35cb8dcee8$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $c88e3e35cb8dcee8$export$fae74005e78b1a27; }, function (v) { return $c88e3e35cb8dcee8$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $c88e3e35cb8dcee8$export$dc8fbce3eb94dc1e; }, function (v) { return $c88e3e35cb8dcee8$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $c88e3e35cb8dcee8$export$6a7bc4e911dc01cf; }, function (v) { return $c88e3e35cb8dcee8$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $c88e3e35cb8dcee8$export$6d9c69b0de29b591; }, function (v) { return $c88e3e35cb8dcee8$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $c88e3e35cb8dcee8$export$f680877a34711e37; }, function (v) { return $c88e3e35cb8dcee8$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $c88e3e35cb8dcee8$export$d5a552a76deda3c2; }, function (v) { return $c88e3e35cb8dcee8$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $c88e3e35cb8dcee8$export$aaabe4eda9ed9969; }, function (v) { return $c88e3e35cb8dcee8$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $c88e3e35cb8dcee8$export$e5c5a5f917a5871c; }, function (v) { return $c88e3e35cb8dcee8$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $c88e3e35cb8dcee8$export$1538c33de8887b59; }, function (v) { return $c88e3e35cb8dcee8$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $c88e3e35cb8dcee8$export$13e3392192263954; }, function (v) { return $c88e3e35cb8dcee8$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $c88e3e35cb8dcee8$export$b8f5890fc79d6aca; }, function (v) { return $c88e3e35cb8dcee8$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $c88e3e35cb8dcee8$export$60241385465d0a34; }, function (v) { return $c88e3e35cb8dcee8$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $c88e3e35cb8dcee8$export$306c0aa65ff9ec16; }, function (v) { return $c88e3e35cb8dcee8$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $c88e3e35cb8dcee8$export$7b286972b8d8ccbf; }, function (v) { return $c88e3e35cb8dcee8$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $c88e3e35cb8dcee8$export$83d89fbfd8236492; }, function (v) { return $c88e3e35cb8dcee8$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c88e3e35cb8dcee8$export$dca3b0875bd9a954;
var $c88e3e35cb8dcee8$export$16fa2f45be04daa8;
var $c88e3e35cb8dcee8$export$ffb0004e005737fa;
var $c88e3e35cb8dcee8$export$e2c29f18771995cb;
var $c88e3e35cb8dcee8$export$221d75b3f55bb0bd;
var $c88e3e35cb8dcee8$export$5f8d39834fd61797;
var $c88e3e35cb8dcee8$export$74bf444e3cd11ea5;
var $c88e3e35cb8dcee8$export$ae55be85d98224ed;
var $c88e3e35cb8dcee8$export$e530037191fcd5d7;
var $c88e3e35cb8dcee8$export$fd42f52fd3ae1109;
var $c88e3e35cb8dcee8$export$c8a8987d4410bf2d;
var $c88e3e35cb8dcee8$export$d38cd72104c1f0e9;
var $c88e3e35cb8dcee8$export$7d1e3a5e95ceca43;
var $c88e3e35cb8dcee8$export$257a8862b851cb5b;
var $c88e3e35cb8dcee8$export$a8257692ac88316c;
var $c88e3e35cb8dcee8$export$488013bae63b21da;
var $c88e3e35cb8dcee8$export$7c73462e0d25e514;
var $c88e3e35cb8dcee8$export$7568632d0d33d16d;
var $c88e3e35cb8dcee8$export$88948ce120ea2619;
var $c88e3e35cb8dcee8$export$35808ee640e87ca7;
var $c88e3e35cb8dcee8$export$fae74005e78b1a27;
var $c88e3e35cb8dcee8$export$dc8fbce3eb94dc1e;
var $c88e3e35cb8dcee8$export$6a7bc4e911dc01cf;
var $c88e3e35cb8dcee8$export$6d9c69b0de29b591;
var $c88e3e35cb8dcee8$export$f680877a34711e37;
var $c88e3e35cb8dcee8$export$d5a552a76deda3c2;
var $c88e3e35cb8dcee8$export$aaabe4eda9ed9969;
var $c88e3e35cb8dcee8$export$e5c5a5f917a5871c;
var $c88e3e35cb8dcee8$export$1538c33de8887b59;
var $c88e3e35cb8dcee8$export$13e3392192263954;
var $c88e3e35cb8dcee8$export$b8f5890fc79d6aca;
var $c88e3e35cb8dcee8$export$60241385465d0a34;
var $c88e3e35cb8dcee8$export$306c0aa65ff9ec16;
var $c88e3e35cb8dcee8$export$7b286972b8d8ccbf;
var $c88e3e35cb8dcee8$export$83d89fbfd8236492;
'use strict';
var $c88e3e35cb8dcee8$var$l = Symbol.for("react.element"), $c88e3e35cb8dcee8$var$n = Symbol.for("react.portal"), $c88e3e35cb8dcee8$var$p = Symbol.for("react.fragment"), $c88e3e35cb8dcee8$var$q = Symbol.for("react.strict_mode"), $c88e3e35cb8dcee8$var$r = Symbol.for("react.profiler"), $c88e3e35cb8dcee8$var$t = Symbol.for("react.provider"), $c88e3e35cb8dcee8$var$u = Symbol.for("react.context"), $c88e3e35cb8dcee8$var$v = Symbol.for("react.forward_ref"), $c88e3e35cb8dcee8$var$w = Symbol.for("react.suspense"), $c88e3e35cb8dcee8$var$x = Symbol.for("react.memo"), $c88e3e35cb8dcee8$var$y = Symbol.for("react.lazy"), $c88e3e35cb8dcee8$var$z = Symbol.iterator;
function $c88e3e35cb8dcee8$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c88e3e35cb8dcee8$var$z && a[$c88e3e35cb8dcee8$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c88e3e35cb8dcee8$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $c88e3e35cb8dcee8$var$C = Object.assign, $c88e3e35cb8dcee8$var$D = {};
function $c88e3e35cb8dcee8$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c88e3e35cb8dcee8$var$D;
    this.updater = e || $c88e3e35cb8dcee8$var$B;
}
$c88e3e35cb8dcee8$var$E.prototype.isReactComponent = {};
$c88e3e35cb8dcee8$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$c88e3e35cb8dcee8$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $c88e3e35cb8dcee8$var$F() {}
$c88e3e35cb8dcee8$var$F.prototype = $c88e3e35cb8dcee8$var$E.prototype;
function $c88e3e35cb8dcee8$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c88e3e35cb8dcee8$var$D;
    this.updater = e || $c88e3e35cb8dcee8$var$B;
}
var $c88e3e35cb8dcee8$var$H = $c88e3e35cb8dcee8$var$G.prototype = new $c88e3e35cb8dcee8$var$F;
$c88e3e35cb8dcee8$var$H.constructor = $c88e3e35cb8dcee8$var$G;
$c88e3e35cb8dcee8$var$C($c88e3e35cb8dcee8$var$H, $c88e3e35cb8dcee8$var$E.prototype);
$c88e3e35cb8dcee8$var$H.isPureReactComponent = !0;
var $c88e3e35cb8dcee8$var$I = Array.isArray, $c88e3e35cb8dcee8$var$J = Object.prototype.hasOwnProperty, $c88e3e35cb8dcee8$var$K = {
    current: null
}, $c88e3e35cb8dcee8$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $c88e3e35cb8dcee8$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$c88e3e35cb8dcee8$var$J.call(b, d) && !$c88e3e35cb8dcee8$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $c88e3e35cb8dcee8$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $c88e3e35cb8dcee8$var$K.current
    };
}
function $c88e3e35cb8dcee8$var$N(a, b) {
    return {
        $$typeof: $c88e3e35cb8dcee8$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $c88e3e35cb8dcee8$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $c88e3e35cb8dcee8$var$l;
}
function $c88e3e35cb8dcee8$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $c88e3e35cb8dcee8$var$P = /\/+/g;
function $c88e3e35cb8dcee8$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $c88e3e35cb8dcee8$var$escape("" + a.key) : b.toString(36);
}
function $c88e3e35cb8dcee8$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $c88e3e35cb8dcee8$var$l:
                case $c88e3e35cb8dcee8$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $c88e3e35cb8dcee8$var$Q(h, 0) : d, $c88e3e35cb8dcee8$var$I(c) ? (e = "", null != a && (e = a.replace($c88e3e35cb8dcee8$var$P, "$&/") + "/"), $c88e3e35cb8dcee8$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($c88e3e35cb8dcee8$var$O(c) && (c = $c88e3e35cb8dcee8$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($c88e3e35cb8dcee8$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($c88e3e35cb8dcee8$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $c88e3e35cb8dcee8$var$Q(k, g);
        h += $c88e3e35cb8dcee8$var$R(k, b, e, f, c);
    }
    else if (f = $c88e3e35cb8dcee8$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $c88e3e35cb8dcee8$var$Q(k, g++), h += $c88e3e35cb8dcee8$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $c88e3e35cb8dcee8$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $c88e3e35cb8dcee8$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $c88e3e35cb8dcee8$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $c88e3e35cb8dcee8$var$U = {
    current: null
}, $c88e3e35cb8dcee8$var$V = {
    transition: null
}, $c88e3e35cb8dcee8$var$W = {
    ReactCurrentDispatcher: $c88e3e35cb8dcee8$var$U,
    ReactCurrentBatchConfig: $c88e3e35cb8dcee8$var$V,
    ReactCurrentOwner: $c88e3e35cb8dcee8$var$K
};
$c88e3e35cb8dcee8$export$dca3b0875bd9a954 = {
    map: $c88e3e35cb8dcee8$var$S,
    forEach: function(a, b, e) {
        $c88e3e35cb8dcee8$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $c88e3e35cb8dcee8$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $c88e3e35cb8dcee8$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$c88e3e35cb8dcee8$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$c88e3e35cb8dcee8$export$16fa2f45be04daa8 = $c88e3e35cb8dcee8$var$E;
$c88e3e35cb8dcee8$export$ffb0004e005737fa = $c88e3e35cb8dcee8$var$p;
$c88e3e35cb8dcee8$export$e2c29f18771995cb = $c88e3e35cb8dcee8$var$r;
$c88e3e35cb8dcee8$export$221d75b3f55bb0bd = $c88e3e35cb8dcee8$var$G;
$c88e3e35cb8dcee8$export$5f8d39834fd61797 = $c88e3e35cb8dcee8$var$q;
$c88e3e35cb8dcee8$export$74bf444e3cd11ea5 = $c88e3e35cb8dcee8$var$w;
$c88e3e35cb8dcee8$export$ae55be85d98224ed = $c88e3e35cb8dcee8$var$W;
$c88e3e35cb8dcee8$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $c88e3e35cb8dcee8$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $c88e3e35cb8dcee8$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$c88e3e35cb8dcee8$var$J.call(b, f) && !$c88e3e35cb8dcee8$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $c88e3e35cb8dcee8$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$c88e3e35cb8dcee8$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $c88e3e35cb8dcee8$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $c88e3e35cb8dcee8$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$c88e3e35cb8dcee8$export$c8a8987d4410bf2d = $c88e3e35cb8dcee8$var$M;
$c88e3e35cb8dcee8$export$d38cd72104c1f0e9 = function(a) {
    var b = $c88e3e35cb8dcee8$var$M.bind(null, a);
    b.type = a;
    return b;
};
$c88e3e35cb8dcee8$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$c88e3e35cb8dcee8$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $c88e3e35cb8dcee8$var$v,
        render: a
    };
};
$c88e3e35cb8dcee8$export$a8257692ac88316c = $c88e3e35cb8dcee8$var$O;
$c88e3e35cb8dcee8$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $c88e3e35cb8dcee8$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $c88e3e35cb8dcee8$var$T
    };
};
$c88e3e35cb8dcee8$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $c88e3e35cb8dcee8$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$c88e3e35cb8dcee8$export$7568632d0d33d16d = function(a) {
    var b = $c88e3e35cb8dcee8$var$V.transition;
    $c88e3e35cb8dcee8$var$V.transition = {};
    try {
        a();
    } finally{
        $c88e3e35cb8dcee8$var$V.transition = b;
    }
};
$c88e3e35cb8dcee8$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$c88e3e35cb8dcee8$export$35808ee640e87ca7 = function(a, b) {
    return $c88e3e35cb8dcee8$var$U.current.useCallback(a, b);
};
$c88e3e35cb8dcee8$export$fae74005e78b1a27 = function(a) {
    return $c88e3e35cb8dcee8$var$U.current.useContext(a);
};
$c88e3e35cb8dcee8$export$dc8fbce3eb94dc1e = function() {};
$c88e3e35cb8dcee8$export$6a7bc4e911dc01cf = function(a) {
    return $c88e3e35cb8dcee8$var$U.current.useDeferredValue(a);
};
$c88e3e35cb8dcee8$export$6d9c69b0de29b591 = function(a, b) {
    return $c88e3e35cb8dcee8$var$U.current.useEffect(a, b);
};
$c88e3e35cb8dcee8$export$f680877a34711e37 = function() {
    return $c88e3e35cb8dcee8$var$U.current.useId();
};
$c88e3e35cb8dcee8$export$d5a552a76deda3c2 = function(a, b, e) {
    return $c88e3e35cb8dcee8$var$U.current.useImperativeHandle(a, b, e);
};
$c88e3e35cb8dcee8$export$aaabe4eda9ed9969 = function(a, b) {
    return $c88e3e35cb8dcee8$var$U.current.useInsertionEffect(a, b);
};
$c88e3e35cb8dcee8$export$e5c5a5f917a5871c = function(a, b) {
    return $c88e3e35cb8dcee8$var$U.current.useLayoutEffect(a, b);
};
$c88e3e35cb8dcee8$export$1538c33de8887b59 = function(a, b) {
    return $c88e3e35cb8dcee8$var$U.current.useMemo(a, b);
};
$c88e3e35cb8dcee8$export$13e3392192263954 = function(a, b, e) {
    return $c88e3e35cb8dcee8$var$U.current.useReducer(a, b, e);
};
$c88e3e35cb8dcee8$export$b8f5890fc79d6aca = function(a) {
    return $c88e3e35cb8dcee8$var$U.current.useRef(a);
};
$c88e3e35cb8dcee8$export$60241385465d0a34 = function(a) {
    return $c88e3e35cb8dcee8$var$U.current.useState(a);
};
$c88e3e35cb8dcee8$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $c88e3e35cb8dcee8$var$U.current.useSyncExternalStore(a, b, e);
};
$c88e3e35cb8dcee8$export$7b286972b8d8ccbf = function() {
    return $c88e3e35cb8dcee8$var$U.current.useTransition();
};
$c88e3e35cb8dcee8$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("66379", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $4705b8143ca2ee62$export$ae55be85d98224ed; }, function (v) { return $4705b8143ca2ee62$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $4705b8143ca2ee62$export$d39a5bbd09211389; }, function (v) { return $4705b8143ca2ee62$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $4705b8143ca2ee62$export$882461b6382ed46c; }, function (v) { return $4705b8143ca2ee62$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $4705b8143ca2ee62$export$466bfc07425424d5; }, function (v) { return $4705b8143ca2ee62$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $4705b8143ca2ee62$export$cd75ccfd720a3cd4; }, function (v) { return $4705b8143ca2ee62$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $4705b8143ca2ee62$export$fa8d919ba61d84db; }, function (v) { return $4705b8143ca2ee62$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $4705b8143ca2ee62$export$757ceba2d55c277e; }, function (v) { return $4705b8143ca2ee62$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $4705b8143ca2ee62$export$b3890eb0ae9dca99; }, function (v) { return $4705b8143ca2ee62$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $4705b8143ca2ee62$export$502457920280e6be; }, function (v) { return $4705b8143ca2ee62$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $4705b8143ca2ee62$export$c78a37762a8d58e1; }, function (v) { return $4705b8143ca2ee62$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $4705b8143ca2ee62$export$dc54d992c10e8a18; }, function (v) { return $4705b8143ca2ee62$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $4705b8143ca2ee62$export$83d89fbfd8236492; }, function (v) { return $4705b8143ca2ee62$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $4705b8143ca2ee62$export$ae55be85d98224ed;
var $4705b8143ca2ee62$export$d39a5bbd09211389;
var $4705b8143ca2ee62$export$882461b6382ed46c;
var $4705b8143ca2ee62$export$466bfc07425424d5;
var $4705b8143ca2ee62$export$cd75ccfd720a3cd4;
var $4705b8143ca2ee62$export$fa8d919ba61d84db;
var $4705b8143ca2ee62$export$757ceba2d55c277e;
var $4705b8143ca2ee62$export$b3890eb0ae9dca99;
var $4705b8143ca2ee62$export$502457920280e6be;
var $4705b8143ca2ee62$export$c78a37762a8d58e1;
var $4705b8143ca2ee62$export$dc54d992c10e8a18;
var $4705b8143ca2ee62$export$83d89fbfd8236492;
'use strict';

var $iQhxf = parcelRequire("iQhxf");

var $3ob6t = parcelRequire("3ob6t");
function $4705b8143ca2ee62$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $4705b8143ca2ee62$var$da = new Set, $4705b8143ca2ee62$var$ea = {};
function $4705b8143ca2ee62$var$fa(a, b) {
    $4705b8143ca2ee62$var$ha(a, b);
    $4705b8143ca2ee62$var$ha(a + "Capture", b);
}
function $4705b8143ca2ee62$var$ha(a, b) {
    $4705b8143ca2ee62$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$4705b8143ca2ee62$var$da.add(b[a]);
}
var $4705b8143ca2ee62$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $4705b8143ca2ee62$var$ja = Object.prototype.hasOwnProperty, $4705b8143ca2ee62$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $4705b8143ca2ee62$var$la = {}, $4705b8143ca2ee62$var$ma = {};
function $4705b8143ca2ee62$var$oa(a) {
    if ($4705b8143ca2ee62$var$ja.call($4705b8143ca2ee62$var$ma, a)) return !0;
    if ($4705b8143ca2ee62$var$ja.call($4705b8143ca2ee62$var$la, a)) return !1;
    if ($4705b8143ca2ee62$var$ka.test(a)) return $4705b8143ca2ee62$var$ma[a] = !0;
    $4705b8143ca2ee62$var$la[a] = !0;
    return !1;
}
function $4705b8143ca2ee62$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $4705b8143ca2ee62$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $4705b8143ca2ee62$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $4705b8143ca2ee62$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $4705b8143ca2ee62$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $4705b8143ca2ee62$var$z[a] = new $4705b8143ca2ee62$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $4705b8143ca2ee62$var$z[b] = new $4705b8143ca2ee62$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $4705b8143ca2ee62$var$z[a] = new $4705b8143ca2ee62$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $4705b8143ca2ee62$var$z[a] = new $4705b8143ca2ee62$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $4705b8143ca2ee62$var$z[a] = new $4705b8143ca2ee62$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $4705b8143ca2ee62$var$z[a] = new $4705b8143ca2ee62$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $4705b8143ca2ee62$var$z[a] = new $4705b8143ca2ee62$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $4705b8143ca2ee62$var$z[a] = new $4705b8143ca2ee62$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $4705b8143ca2ee62$var$z[a] = new $4705b8143ca2ee62$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $4705b8143ca2ee62$var$ra = /[\-:]([a-z])/g;
function $4705b8143ca2ee62$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($4705b8143ca2ee62$var$ra, $4705b8143ca2ee62$var$sa);
    $4705b8143ca2ee62$var$z[b] = new $4705b8143ca2ee62$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($4705b8143ca2ee62$var$ra, $4705b8143ca2ee62$var$sa);
    $4705b8143ca2ee62$var$z[b] = new $4705b8143ca2ee62$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($4705b8143ca2ee62$var$ra, $4705b8143ca2ee62$var$sa);
    $4705b8143ca2ee62$var$z[b] = new $4705b8143ca2ee62$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $4705b8143ca2ee62$var$z[a] = new $4705b8143ca2ee62$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$4705b8143ca2ee62$var$z.xlinkHref = new $4705b8143ca2ee62$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $4705b8143ca2ee62$var$z[a] = new $4705b8143ca2ee62$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $4705b8143ca2ee62$var$ta(a, b, c, d) {
    var e = $4705b8143ca2ee62$var$z.hasOwnProperty(b) ? $4705b8143ca2ee62$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $4705b8143ca2ee62$var$qa(b, c, e, d) && (c = null), d || null === e ? $4705b8143ca2ee62$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $4705b8143ca2ee62$var$ua = $iQhxf.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $4705b8143ca2ee62$var$va = Symbol.for("react.element"), $4705b8143ca2ee62$var$wa = Symbol.for("react.portal"), $4705b8143ca2ee62$var$ya = Symbol.for("react.fragment"), $4705b8143ca2ee62$var$za = Symbol.for("react.strict_mode"), $4705b8143ca2ee62$var$Aa = Symbol.for("react.profiler"), $4705b8143ca2ee62$var$Ba = Symbol.for("react.provider"), $4705b8143ca2ee62$var$Ca = Symbol.for("react.context"), $4705b8143ca2ee62$var$Da = Symbol.for("react.forward_ref"), $4705b8143ca2ee62$var$Ea = Symbol.for("react.suspense"), $4705b8143ca2ee62$var$Fa = Symbol.for("react.suspense_list"), $4705b8143ca2ee62$var$Ga = Symbol.for("react.memo"), $4705b8143ca2ee62$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $4705b8143ca2ee62$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $4705b8143ca2ee62$var$Ja = Symbol.iterator;
function $4705b8143ca2ee62$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $4705b8143ca2ee62$var$Ja && a[$4705b8143ca2ee62$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $4705b8143ca2ee62$var$A = Object.assign, $4705b8143ca2ee62$var$La;
function $4705b8143ca2ee62$var$Ma(a) {
    if (void 0 === $4705b8143ca2ee62$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $4705b8143ca2ee62$var$La = b && b[1] || "";
    }
    return "\n" + $4705b8143ca2ee62$var$La + a;
}
var $4705b8143ca2ee62$var$Na = !1;
function $4705b8143ca2ee62$var$Oa(a, b) {
    if (!a || $4705b8143ca2ee62$var$Na) return "";
    $4705b8143ca2ee62$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $4705b8143ca2ee62$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $4705b8143ca2ee62$var$Ma(a) : "";
}
function $4705b8143ca2ee62$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $4705b8143ca2ee62$var$Ma(a.type);
        case 16:
            return $4705b8143ca2ee62$var$Ma("Lazy");
        case 13:
            return $4705b8143ca2ee62$var$Ma("Suspense");
        case 19:
            return $4705b8143ca2ee62$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $4705b8143ca2ee62$var$Oa(a.type, !1), a;
        case 11:
            return a = $4705b8143ca2ee62$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $4705b8143ca2ee62$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $4705b8143ca2ee62$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $4705b8143ca2ee62$var$ya:
            return "Fragment";
        case $4705b8143ca2ee62$var$wa:
            return "Portal";
        case $4705b8143ca2ee62$var$Aa:
            return "Profiler";
        case $4705b8143ca2ee62$var$za:
            return "StrictMode";
        case $4705b8143ca2ee62$var$Ea:
            return "Suspense";
        case $4705b8143ca2ee62$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $4705b8143ca2ee62$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $4705b8143ca2ee62$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $4705b8143ca2ee62$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $4705b8143ca2ee62$var$Ga:
            return b = a.displayName || null, null !== b ? b : $4705b8143ca2ee62$var$Qa(a.type) || "Memo";
        case $4705b8143ca2ee62$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $4705b8143ca2ee62$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $4705b8143ca2ee62$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $4705b8143ca2ee62$var$Qa(b);
        case 8:
            return b === $4705b8143ca2ee62$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $4705b8143ca2ee62$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $4705b8143ca2ee62$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $4705b8143ca2ee62$var$Ua(a) {
    var b = $4705b8143ca2ee62$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $4705b8143ca2ee62$var$Va(a) {
    a._valueTracker || (a._valueTracker = $4705b8143ca2ee62$var$Ua(a));
}
function $4705b8143ca2ee62$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $4705b8143ca2ee62$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $4705b8143ca2ee62$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $4705b8143ca2ee62$var$Ya(a, b) {
    var c = b.checked;
    return $4705b8143ca2ee62$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $4705b8143ca2ee62$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $4705b8143ca2ee62$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $4705b8143ca2ee62$var$ab(a, b) {
    b = b.checked;
    null != b && $4705b8143ca2ee62$var$ta(a, "checked", b, !1);
}
function $4705b8143ca2ee62$var$bb(a, b) {
    $4705b8143ca2ee62$var$ab(a, b);
    var c = $4705b8143ca2ee62$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $4705b8143ca2ee62$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $4705b8143ca2ee62$var$cb(a, b.type, $4705b8143ca2ee62$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $4705b8143ca2ee62$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $4705b8143ca2ee62$var$cb(a, b, c) {
    if ("number" !== b || $4705b8143ca2ee62$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $4705b8143ca2ee62$var$eb = Array.isArray;
function $4705b8143ca2ee62$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $4705b8143ca2ee62$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $4705b8143ca2ee62$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($4705b8143ca2ee62$var$p(91));
    return $4705b8143ca2ee62$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $4705b8143ca2ee62$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($4705b8143ca2ee62$var$p(92));
            if ($4705b8143ca2ee62$var$eb(c)) {
                if (1 < c.length) throw Error($4705b8143ca2ee62$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $4705b8143ca2ee62$var$Sa(c)
    };
}
function $4705b8143ca2ee62$var$ib(a, b) {
    var c = $4705b8143ca2ee62$var$Sa(b.value), d = $4705b8143ca2ee62$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $4705b8143ca2ee62$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $4705b8143ca2ee62$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $4705b8143ca2ee62$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $4705b8143ca2ee62$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $4705b8143ca2ee62$var$mb, $4705b8143ca2ee62$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $4705b8143ca2ee62$var$mb = $4705b8143ca2ee62$var$mb || document.createElement("div");
        $4705b8143ca2ee62$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $4705b8143ca2ee62$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $4705b8143ca2ee62$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $4705b8143ca2ee62$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $4705b8143ca2ee62$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($4705b8143ca2ee62$var$pb).forEach(function(a) {
    $4705b8143ca2ee62$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $4705b8143ca2ee62$var$pb[b] = $4705b8143ca2ee62$var$pb[a];
    });
});
function $4705b8143ca2ee62$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $4705b8143ca2ee62$var$pb.hasOwnProperty(a) && $4705b8143ca2ee62$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $4705b8143ca2ee62$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $4705b8143ca2ee62$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $4705b8143ca2ee62$var$tb = $4705b8143ca2ee62$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $4705b8143ca2ee62$var$ub(a, b) {
    if (b) {
        if ($4705b8143ca2ee62$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($4705b8143ca2ee62$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($4705b8143ca2ee62$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($4705b8143ca2ee62$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($4705b8143ca2ee62$var$p(62));
    }
}
function $4705b8143ca2ee62$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $4705b8143ca2ee62$var$wb = null;
function $4705b8143ca2ee62$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $4705b8143ca2ee62$var$yb = null, $4705b8143ca2ee62$var$zb = null, $4705b8143ca2ee62$var$Ab = null;
function $4705b8143ca2ee62$var$Bb(a) {
    if (a = $4705b8143ca2ee62$var$Cb(a)) {
        if ("function" !== typeof $4705b8143ca2ee62$var$yb) throw Error($4705b8143ca2ee62$var$p(280));
        var b = a.stateNode;
        b && (b = $4705b8143ca2ee62$var$Db(b), $4705b8143ca2ee62$var$yb(a.stateNode, a.type, b));
    }
}
function $4705b8143ca2ee62$var$Eb(a) {
    $4705b8143ca2ee62$var$zb ? $4705b8143ca2ee62$var$Ab ? $4705b8143ca2ee62$var$Ab.push(a) : $4705b8143ca2ee62$var$Ab = [
        a
    ] : $4705b8143ca2ee62$var$zb = a;
}
function $4705b8143ca2ee62$var$Fb() {
    if ($4705b8143ca2ee62$var$zb) {
        var a = $4705b8143ca2ee62$var$zb, b = $4705b8143ca2ee62$var$Ab;
        $4705b8143ca2ee62$var$Ab = $4705b8143ca2ee62$var$zb = null;
        $4705b8143ca2ee62$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$4705b8143ca2ee62$var$Bb(b[a]);
    }
}
function $4705b8143ca2ee62$var$Gb(a, b) {
    return a(b);
}
function $4705b8143ca2ee62$var$Hb() {}
var $4705b8143ca2ee62$var$Ib = !1;
function $4705b8143ca2ee62$var$Jb(a, b, c) {
    if ($4705b8143ca2ee62$var$Ib) return a(b, c);
    $4705b8143ca2ee62$var$Ib = !0;
    try {
        return $4705b8143ca2ee62$var$Gb(a, b, c);
    } finally{
        if ($4705b8143ca2ee62$var$Ib = !1, null !== $4705b8143ca2ee62$var$zb || null !== $4705b8143ca2ee62$var$Ab) $4705b8143ca2ee62$var$Hb(), $4705b8143ca2ee62$var$Fb();
    }
}
function $4705b8143ca2ee62$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $4705b8143ca2ee62$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($4705b8143ca2ee62$var$p(231, b, typeof c));
    return c;
}
var $4705b8143ca2ee62$var$Lb = !1;
if ($4705b8143ca2ee62$var$ia) try {
    var $4705b8143ca2ee62$var$Mb = {};
    Object.defineProperty($4705b8143ca2ee62$var$Mb, "passive", {
        get: function() {
            $4705b8143ca2ee62$var$Lb = !0;
        }
    });
    window.addEventListener("test", $4705b8143ca2ee62$var$Mb, $4705b8143ca2ee62$var$Mb);
    window.removeEventListener("test", $4705b8143ca2ee62$var$Mb, $4705b8143ca2ee62$var$Mb);
} catch (a) {
    $4705b8143ca2ee62$var$Lb = !1;
}
function $4705b8143ca2ee62$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $4705b8143ca2ee62$var$Ob = !1, $4705b8143ca2ee62$var$Pb = null, $4705b8143ca2ee62$var$Qb = !1, $4705b8143ca2ee62$var$Rb = null, $4705b8143ca2ee62$var$Sb = {
    onError: function(a) {
        $4705b8143ca2ee62$var$Ob = !0;
        $4705b8143ca2ee62$var$Pb = a;
    }
};
function $4705b8143ca2ee62$var$Tb(a, b, c, d, e, f, g, h, k) {
    $4705b8143ca2ee62$var$Ob = !1;
    $4705b8143ca2ee62$var$Pb = null;
    $4705b8143ca2ee62$var$Nb.apply($4705b8143ca2ee62$var$Sb, arguments);
}
function $4705b8143ca2ee62$var$Ub(a, b, c, d, e, f, g, h, k) {
    $4705b8143ca2ee62$var$Tb.apply(this, arguments);
    if ($4705b8143ca2ee62$var$Ob) {
        if ($4705b8143ca2ee62$var$Ob) {
            var l = $4705b8143ca2ee62$var$Pb;
            $4705b8143ca2ee62$var$Ob = !1;
            $4705b8143ca2ee62$var$Pb = null;
        } else throw Error($4705b8143ca2ee62$var$p(198));
        $4705b8143ca2ee62$var$Qb || ($4705b8143ca2ee62$var$Qb = !0, $4705b8143ca2ee62$var$Rb = l);
    }
}
function $4705b8143ca2ee62$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $4705b8143ca2ee62$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $4705b8143ca2ee62$var$Xb(a) {
    if ($4705b8143ca2ee62$var$Vb(a) !== a) throw Error($4705b8143ca2ee62$var$p(188));
}
function $4705b8143ca2ee62$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $4705b8143ca2ee62$var$Vb(a);
        if (null === b) throw Error($4705b8143ca2ee62$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $4705b8143ca2ee62$var$Xb(e), a;
                if (f === d) return $4705b8143ca2ee62$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($4705b8143ca2ee62$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($4705b8143ca2ee62$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($4705b8143ca2ee62$var$p(190));
    }
    if (3 !== c.tag) throw Error($4705b8143ca2ee62$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $4705b8143ca2ee62$var$Zb(a) {
    a = $4705b8143ca2ee62$var$Yb(a);
    return null !== a ? $4705b8143ca2ee62$var$$b(a) : null;
}
function $4705b8143ca2ee62$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $4705b8143ca2ee62$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $4705b8143ca2ee62$var$ac = $3ob6t.unstable_scheduleCallback, $4705b8143ca2ee62$var$bc = $3ob6t.unstable_cancelCallback, $4705b8143ca2ee62$var$cc = $3ob6t.unstable_shouldYield, $4705b8143ca2ee62$var$dc = $3ob6t.unstable_requestPaint, $4705b8143ca2ee62$var$B = $3ob6t.unstable_now, $4705b8143ca2ee62$var$ec = $3ob6t.unstable_getCurrentPriorityLevel, $4705b8143ca2ee62$var$fc = $3ob6t.unstable_ImmediatePriority, $4705b8143ca2ee62$var$gc = $3ob6t.unstable_UserBlockingPriority, $4705b8143ca2ee62$var$hc = $3ob6t.unstable_NormalPriority, $4705b8143ca2ee62$var$ic = $3ob6t.unstable_LowPriority, $4705b8143ca2ee62$var$jc = $3ob6t.unstable_IdlePriority, $4705b8143ca2ee62$var$kc = null, $4705b8143ca2ee62$var$lc = null;
function $4705b8143ca2ee62$var$mc(a) {
    if ($4705b8143ca2ee62$var$lc && "function" === typeof $4705b8143ca2ee62$var$lc.onCommitFiberRoot) try {
        $4705b8143ca2ee62$var$lc.onCommitFiberRoot($4705b8143ca2ee62$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $4705b8143ca2ee62$var$oc = Math.clz32 ? Math.clz32 : $4705b8143ca2ee62$var$nc, $4705b8143ca2ee62$var$pc = Math.log, $4705b8143ca2ee62$var$qc = Math.LN2;
function $4705b8143ca2ee62$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($4705b8143ca2ee62$var$pc(a) / $4705b8143ca2ee62$var$qc | 0) | 0;
}
var $4705b8143ca2ee62$var$rc = 64, $4705b8143ca2ee62$var$sc = 4194304;
function $4705b8143ca2ee62$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $4705b8143ca2ee62$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $4705b8143ca2ee62$var$tc(h) : (f &= g, 0 !== f && (d = $4705b8143ca2ee62$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $4705b8143ca2ee62$var$tc(g) : 0 !== f && (d = $4705b8143ca2ee62$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $4705b8143ca2ee62$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $4705b8143ca2ee62$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $4705b8143ca2ee62$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $4705b8143ca2ee62$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $4705b8143ca2ee62$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $4705b8143ca2ee62$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $4705b8143ca2ee62$var$yc() {
    var a = $4705b8143ca2ee62$var$rc;
    $4705b8143ca2ee62$var$rc <<= 1;
    0 === ($4705b8143ca2ee62$var$rc & 4194240) && ($4705b8143ca2ee62$var$rc = 64);
    return a;
}
function $4705b8143ca2ee62$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $4705b8143ca2ee62$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $4705b8143ca2ee62$var$oc(b);
    a[b] = c;
}
function $4705b8143ca2ee62$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $4705b8143ca2ee62$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $4705b8143ca2ee62$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $4705b8143ca2ee62$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $4705b8143ca2ee62$var$C = 0;
function $4705b8143ca2ee62$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $4705b8143ca2ee62$var$Ec, $4705b8143ca2ee62$var$Fc, $4705b8143ca2ee62$var$Gc, $4705b8143ca2ee62$var$Hc, $4705b8143ca2ee62$var$Ic, $4705b8143ca2ee62$var$Jc = !1, $4705b8143ca2ee62$var$Kc = [], $4705b8143ca2ee62$var$Lc = null, $4705b8143ca2ee62$var$Mc = null, $4705b8143ca2ee62$var$Nc = null, $4705b8143ca2ee62$var$Oc = new Map, $4705b8143ca2ee62$var$Pc = new Map, $4705b8143ca2ee62$var$Qc = [], $4705b8143ca2ee62$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $4705b8143ca2ee62$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $4705b8143ca2ee62$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $4705b8143ca2ee62$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $4705b8143ca2ee62$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $4705b8143ca2ee62$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $4705b8143ca2ee62$var$Pc.delete(b.pointerId);
    }
}
function $4705b8143ca2ee62$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $4705b8143ca2ee62$var$Cb(b), null !== b && $4705b8143ca2ee62$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $4705b8143ca2ee62$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $4705b8143ca2ee62$var$Lc = $4705b8143ca2ee62$var$Tc($4705b8143ca2ee62$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $4705b8143ca2ee62$var$Mc = $4705b8143ca2ee62$var$Tc($4705b8143ca2ee62$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $4705b8143ca2ee62$var$Nc = $4705b8143ca2ee62$var$Tc($4705b8143ca2ee62$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $4705b8143ca2ee62$var$Oc.set(f, $4705b8143ca2ee62$var$Tc($4705b8143ca2ee62$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $4705b8143ca2ee62$var$Pc.set(f, $4705b8143ca2ee62$var$Tc($4705b8143ca2ee62$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $4705b8143ca2ee62$var$Vc(a) {
    var b = $4705b8143ca2ee62$var$Wc(a.target);
    if (null !== b) {
        var c = $4705b8143ca2ee62$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $4705b8143ca2ee62$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $4705b8143ca2ee62$var$Ic(a.priority, function() {
                        $4705b8143ca2ee62$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $4705b8143ca2ee62$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $4705b8143ca2ee62$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $4705b8143ca2ee62$var$wb = d;
            c.target.dispatchEvent(d);
            $4705b8143ca2ee62$var$wb = null;
        } else return b = $4705b8143ca2ee62$var$Cb(c), null !== b && $4705b8143ca2ee62$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $4705b8143ca2ee62$var$Zc(a, b, c) {
    $4705b8143ca2ee62$var$Xc(a) && c.delete(b);
}
function $4705b8143ca2ee62$var$$c() {
    $4705b8143ca2ee62$var$Jc = !1;
    null !== $4705b8143ca2ee62$var$Lc && $4705b8143ca2ee62$var$Xc($4705b8143ca2ee62$var$Lc) && ($4705b8143ca2ee62$var$Lc = null);
    null !== $4705b8143ca2ee62$var$Mc && $4705b8143ca2ee62$var$Xc($4705b8143ca2ee62$var$Mc) && ($4705b8143ca2ee62$var$Mc = null);
    null !== $4705b8143ca2ee62$var$Nc && $4705b8143ca2ee62$var$Xc($4705b8143ca2ee62$var$Nc) && ($4705b8143ca2ee62$var$Nc = null);
    $4705b8143ca2ee62$var$Oc.forEach($4705b8143ca2ee62$var$Zc);
    $4705b8143ca2ee62$var$Pc.forEach($4705b8143ca2ee62$var$Zc);
}
function $4705b8143ca2ee62$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $4705b8143ca2ee62$var$Jc || ($4705b8143ca2ee62$var$Jc = !0, $3ob6t.unstable_scheduleCallback($3ob6t.unstable_NormalPriority, $4705b8143ca2ee62$var$$c)));
}
function $4705b8143ca2ee62$var$bd(a) {
    function b(b) {
        return $4705b8143ca2ee62$var$ad(b, a);
    }
    if (0 < $4705b8143ca2ee62$var$Kc.length) {
        $4705b8143ca2ee62$var$ad($4705b8143ca2ee62$var$Kc[0], a);
        for(var c = 1; c < $4705b8143ca2ee62$var$Kc.length; c++){
            var d = $4705b8143ca2ee62$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $4705b8143ca2ee62$var$Lc && $4705b8143ca2ee62$var$ad($4705b8143ca2ee62$var$Lc, a);
    null !== $4705b8143ca2ee62$var$Mc && $4705b8143ca2ee62$var$ad($4705b8143ca2ee62$var$Mc, a);
    null !== $4705b8143ca2ee62$var$Nc && $4705b8143ca2ee62$var$ad($4705b8143ca2ee62$var$Nc, a);
    $4705b8143ca2ee62$var$Oc.forEach(b);
    $4705b8143ca2ee62$var$Pc.forEach(b);
    for(c = 0; c < $4705b8143ca2ee62$var$Qc.length; c++)d = $4705b8143ca2ee62$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $4705b8143ca2ee62$var$Qc.length && (c = $4705b8143ca2ee62$var$Qc[0], null === c.blockedOn);)$4705b8143ca2ee62$var$Vc(c), null === c.blockedOn && $4705b8143ca2ee62$var$Qc.shift();
}
var $4705b8143ca2ee62$var$cd = $4705b8143ca2ee62$var$ua.ReactCurrentBatchConfig, $4705b8143ca2ee62$var$dd = !0;
function $4705b8143ca2ee62$var$ed(a, b, c, d) {
    var e = $4705b8143ca2ee62$var$C, f = $4705b8143ca2ee62$var$cd.transition;
    $4705b8143ca2ee62$var$cd.transition = null;
    try {
        $4705b8143ca2ee62$var$C = 1, $4705b8143ca2ee62$var$fd(a, b, c, d);
    } finally{
        $4705b8143ca2ee62$var$C = e, $4705b8143ca2ee62$var$cd.transition = f;
    }
}
function $4705b8143ca2ee62$var$gd(a, b, c, d) {
    var e = $4705b8143ca2ee62$var$C, f = $4705b8143ca2ee62$var$cd.transition;
    $4705b8143ca2ee62$var$cd.transition = null;
    try {
        $4705b8143ca2ee62$var$C = 4, $4705b8143ca2ee62$var$fd(a, b, c, d);
    } finally{
        $4705b8143ca2ee62$var$C = e, $4705b8143ca2ee62$var$cd.transition = f;
    }
}
function $4705b8143ca2ee62$var$fd(a, b, c, d) {
    if ($4705b8143ca2ee62$var$dd) {
        var e = $4705b8143ca2ee62$var$Yc(a, b, c, d);
        if (null === e) $4705b8143ca2ee62$var$hd(a, b, d, $4705b8143ca2ee62$var$id, c), $4705b8143ca2ee62$var$Sc(a, d);
        else if ($4705b8143ca2ee62$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($4705b8143ca2ee62$var$Sc(a, d), b & 4 && -1 < $4705b8143ca2ee62$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $4705b8143ca2ee62$var$Cb(e);
                null !== f && $4705b8143ca2ee62$var$Ec(f);
                f = $4705b8143ca2ee62$var$Yc(a, b, c, d);
                null === f && $4705b8143ca2ee62$var$hd(a, b, d, $4705b8143ca2ee62$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $4705b8143ca2ee62$var$hd(a, b, d, null, c);
    }
}
var $4705b8143ca2ee62$var$id = null;
function $4705b8143ca2ee62$var$Yc(a, b, c, d) {
    $4705b8143ca2ee62$var$id = null;
    a = $4705b8143ca2ee62$var$xb(d);
    a = $4705b8143ca2ee62$var$Wc(a);
    if (null !== a) {
        if (b = $4705b8143ca2ee62$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $4705b8143ca2ee62$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $4705b8143ca2ee62$var$id = a;
    return null;
}
function $4705b8143ca2ee62$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($4705b8143ca2ee62$var$ec()){
                case $4705b8143ca2ee62$var$fc:
                    return 1;
                case $4705b8143ca2ee62$var$gc:
                    return 4;
                case $4705b8143ca2ee62$var$hc:
                case $4705b8143ca2ee62$var$ic:
                    return 16;
                case $4705b8143ca2ee62$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $4705b8143ca2ee62$var$kd = null, $4705b8143ca2ee62$var$ld = null, $4705b8143ca2ee62$var$md = null;
function $4705b8143ca2ee62$var$nd() {
    if ($4705b8143ca2ee62$var$md) return $4705b8143ca2ee62$var$md;
    var a, b = $4705b8143ca2ee62$var$ld, c = b.length, d, e = "value" in $4705b8143ca2ee62$var$kd ? $4705b8143ca2ee62$var$kd.value : $4705b8143ca2ee62$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $4705b8143ca2ee62$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $4705b8143ca2ee62$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $4705b8143ca2ee62$var$pd() {
    return !0;
}
function $4705b8143ca2ee62$var$qd() {
    return !1;
}
function $4705b8143ca2ee62$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $4705b8143ca2ee62$var$pd : $4705b8143ca2ee62$var$qd;
        this.isPropagationStopped = $4705b8143ca2ee62$var$qd;
        return this;
    }
    $4705b8143ca2ee62$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $4705b8143ca2ee62$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $4705b8143ca2ee62$var$pd);
        },
        persist: function() {},
        isPersistent: $4705b8143ca2ee62$var$pd
    });
    return b;
}
var $4705b8143ca2ee62$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $4705b8143ca2ee62$var$td = $4705b8143ca2ee62$var$rd($4705b8143ca2ee62$var$sd), $4705b8143ca2ee62$var$ud = $4705b8143ca2ee62$var$A({}, $4705b8143ca2ee62$var$sd, {
    view: 0,
    detail: 0
}), $4705b8143ca2ee62$var$vd = $4705b8143ca2ee62$var$rd($4705b8143ca2ee62$var$ud), $4705b8143ca2ee62$var$wd, $4705b8143ca2ee62$var$xd, $4705b8143ca2ee62$var$yd, $4705b8143ca2ee62$var$Ad = $4705b8143ca2ee62$var$A({}, $4705b8143ca2ee62$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $4705b8143ca2ee62$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $4705b8143ca2ee62$var$yd && ($4705b8143ca2ee62$var$yd && "mousemove" === a.type ? ($4705b8143ca2ee62$var$wd = a.screenX - $4705b8143ca2ee62$var$yd.screenX, $4705b8143ca2ee62$var$xd = a.screenY - $4705b8143ca2ee62$var$yd.screenY) : $4705b8143ca2ee62$var$xd = $4705b8143ca2ee62$var$wd = 0, $4705b8143ca2ee62$var$yd = a);
        return $4705b8143ca2ee62$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $4705b8143ca2ee62$var$xd;
    }
}), $4705b8143ca2ee62$var$Bd = $4705b8143ca2ee62$var$rd($4705b8143ca2ee62$var$Ad), $4705b8143ca2ee62$var$Cd = $4705b8143ca2ee62$var$A({}, $4705b8143ca2ee62$var$Ad, {
    dataTransfer: 0
}), $4705b8143ca2ee62$var$Dd = $4705b8143ca2ee62$var$rd($4705b8143ca2ee62$var$Cd), $4705b8143ca2ee62$var$Ed = $4705b8143ca2ee62$var$A({}, $4705b8143ca2ee62$var$ud, {
    relatedTarget: 0
}), $4705b8143ca2ee62$var$Fd = $4705b8143ca2ee62$var$rd($4705b8143ca2ee62$var$Ed), $4705b8143ca2ee62$var$Gd = $4705b8143ca2ee62$var$A({}, $4705b8143ca2ee62$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4705b8143ca2ee62$var$Hd = $4705b8143ca2ee62$var$rd($4705b8143ca2ee62$var$Gd), $4705b8143ca2ee62$var$Id = $4705b8143ca2ee62$var$A({}, $4705b8143ca2ee62$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $4705b8143ca2ee62$var$Jd = $4705b8143ca2ee62$var$rd($4705b8143ca2ee62$var$Id), $4705b8143ca2ee62$var$Kd = $4705b8143ca2ee62$var$A({}, $4705b8143ca2ee62$var$sd, {
    data: 0
}), $4705b8143ca2ee62$var$Ld = $4705b8143ca2ee62$var$rd($4705b8143ca2ee62$var$Kd), $4705b8143ca2ee62$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $4705b8143ca2ee62$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $4705b8143ca2ee62$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $4705b8143ca2ee62$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $4705b8143ca2ee62$var$Od[a]) ? !!b[a] : !1;
}
function $4705b8143ca2ee62$var$zd() {
    return $4705b8143ca2ee62$var$Pd;
}
var $4705b8143ca2ee62$var$Qd = $4705b8143ca2ee62$var$A({}, $4705b8143ca2ee62$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $4705b8143ca2ee62$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $4705b8143ca2ee62$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $4705b8143ca2ee62$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $4705b8143ca2ee62$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $4705b8143ca2ee62$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $4705b8143ca2ee62$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $4705b8143ca2ee62$var$Rd = $4705b8143ca2ee62$var$rd($4705b8143ca2ee62$var$Qd), $4705b8143ca2ee62$var$Sd = $4705b8143ca2ee62$var$A({}, $4705b8143ca2ee62$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $4705b8143ca2ee62$var$Td = $4705b8143ca2ee62$var$rd($4705b8143ca2ee62$var$Sd), $4705b8143ca2ee62$var$Ud = $4705b8143ca2ee62$var$A({}, $4705b8143ca2ee62$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $4705b8143ca2ee62$var$zd
}), $4705b8143ca2ee62$var$Vd = $4705b8143ca2ee62$var$rd($4705b8143ca2ee62$var$Ud), $4705b8143ca2ee62$var$Wd = $4705b8143ca2ee62$var$A({}, $4705b8143ca2ee62$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4705b8143ca2ee62$var$Xd = $4705b8143ca2ee62$var$rd($4705b8143ca2ee62$var$Wd), $4705b8143ca2ee62$var$Yd = $4705b8143ca2ee62$var$A({}, $4705b8143ca2ee62$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $4705b8143ca2ee62$var$Zd = $4705b8143ca2ee62$var$rd($4705b8143ca2ee62$var$Yd), $4705b8143ca2ee62$var$$d = [
    9,
    13,
    27,
    32
], $4705b8143ca2ee62$var$ae = $4705b8143ca2ee62$var$ia && "CompositionEvent" in window, $4705b8143ca2ee62$var$be = null;
$4705b8143ca2ee62$var$ia && "documentMode" in document && ($4705b8143ca2ee62$var$be = document.documentMode);
var $4705b8143ca2ee62$var$ce = $4705b8143ca2ee62$var$ia && "TextEvent" in window && !$4705b8143ca2ee62$var$be, $4705b8143ca2ee62$var$de = $4705b8143ca2ee62$var$ia && (!$4705b8143ca2ee62$var$ae || $4705b8143ca2ee62$var$be && 8 < $4705b8143ca2ee62$var$be && 11 >= $4705b8143ca2ee62$var$be), $4705b8143ca2ee62$var$ee = String.fromCharCode(32), $4705b8143ca2ee62$var$fe = !1;
function $4705b8143ca2ee62$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $4705b8143ca2ee62$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $4705b8143ca2ee62$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $4705b8143ca2ee62$var$ie = !1;
function $4705b8143ca2ee62$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $4705b8143ca2ee62$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $4705b8143ca2ee62$var$fe = !0;
            return $4705b8143ca2ee62$var$ee;
        case "textInput":
            return a = b.data, a === $4705b8143ca2ee62$var$ee && $4705b8143ca2ee62$var$fe ? null : a;
        default:
            return null;
    }
}
function $4705b8143ca2ee62$var$ke(a, b) {
    if ($4705b8143ca2ee62$var$ie) return "compositionend" === a || !$4705b8143ca2ee62$var$ae && $4705b8143ca2ee62$var$ge(a, b) ? (a = $4705b8143ca2ee62$var$nd(), $4705b8143ca2ee62$var$md = $4705b8143ca2ee62$var$ld = $4705b8143ca2ee62$var$kd = null, $4705b8143ca2ee62$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $4705b8143ca2ee62$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $4705b8143ca2ee62$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $4705b8143ca2ee62$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$4705b8143ca2ee62$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $4705b8143ca2ee62$var$ne(a, b, c, d) {
    $4705b8143ca2ee62$var$Eb(d);
    b = $4705b8143ca2ee62$var$oe(b, "onChange");
    0 < b.length && (c = new $4705b8143ca2ee62$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $4705b8143ca2ee62$var$pe = null, $4705b8143ca2ee62$var$qe = null;
function $4705b8143ca2ee62$var$re(a) {
    $4705b8143ca2ee62$var$se(a, 0);
}
function $4705b8143ca2ee62$var$te(a) {
    var b = $4705b8143ca2ee62$var$ue(a);
    if ($4705b8143ca2ee62$var$Wa(b)) return a;
}
function $4705b8143ca2ee62$var$ve(a, b) {
    if ("change" === a) return b;
}
var $4705b8143ca2ee62$var$we = !1;
if ($4705b8143ca2ee62$var$ia) {
    var $4705b8143ca2ee62$var$xe;
    if ($4705b8143ca2ee62$var$ia) {
        var $4705b8143ca2ee62$var$ye = "oninput" in document;
        if (!$4705b8143ca2ee62$var$ye) {
            var $4705b8143ca2ee62$var$ze = document.createElement("div");
            $4705b8143ca2ee62$var$ze.setAttribute("oninput", "return;");
            $4705b8143ca2ee62$var$ye = "function" === typeof $4705b8143ca2ee62$var$ze.oninput;
        }
        $4705b8143ca2ee62$var$xe = $4705b8143ca2ee62$var$ye;
    } else $4705b8143ca2ee62$var$xe = !1;
    $4705b8143ca2ee62$var$we = $4705b8143ca2ee62$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $4705b8143ca2ee62$var$Ae() {
    $4705b8143ca2ee62$var$pe && ($4705b8143ca2ee62$var$pe.detachEvent("onpropertychange", $4705b8143ca2ee62$var$Be), $4705b8143ca2ee62$var$qe = $4705b8143ca2ee62$var$pe = null);
}
function $4705b8143ca2ee62$var$Be(a) {
    if ("value" === a.propertyName && $4705b8143ca2ee62$var$te($4705b8143ca2ee62$var$qe)) {
        var b = [];
        $4705b8143ca2ee62$var$ne(b, $4705b8143ca2ee62$var$qe, a, $4705b8143ca2ee62$var$xb(a));
        $4705b8143ca2ee62$var$Jb($4705b8143ca2ee62$var$re, b);
    }
}
function $4705b8143ca2ee62$var$Ce(a, b, c) {
    "focusin" === a ? ($4705b8143ca2ee62$var$Ae(), $4705b8143ca2ee62$var$pe = b, $4705b8143ca2ee62$var$qe = c, $4705b8143ca2ee62$var$pe.attachEvent("onpropertychange", $4705b8143ca2ee62$var$Be)) : "focusout" === a && $4705b8143ca2ee62$var$Ae();
}
function $4705b8143ca2ee62$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $4705b8143ca2ee62$var$te($4705b8143ca2ee62$var$qe);
}
function $4705b8143ca2ee62$var$Ee(a, b) {
    if ("click" === a) return $4705b8143ca2ee62$var$te(b);
}
function $4705b8143ca2ee62$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $4705b8143ca2ee62$var$te(b);
}
function $4705b8143ca2ee62$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $4705b8143ca2ee62$var$He = "function" === typeof Object.is ? Object.is : $4705b8143ca2ee62$var$Ge;
function $4705b8143ca2ee62$var$Ie(a, b) {
    if ($4705b8143ca2ee62$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$4705b8143ca2ee62$var$ja.call(b, e) || !$4705b8143ca2ee62$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $4705b8143ca2ee62$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $4705b8143ca2ee62$var$Ke(a, b) {
    var c = $4705b8143ca2ee62$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $4705b8143ca2ee62$var$Je(c);
    }
}
function $4705b8143ca2ee62$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $4705b8143ca2ee62$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $4705b8143ca2ee62$var$Me() {
    for(var a = window, b = $4705b8143ca2ee62$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $4705b8143ca2ee62$var$Xa(a.document);
    }
    return b;
}
function $4705b8143ca2ee62$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $4705b8143ca2ee62$var$Oe(a) {
    var b = $4705b8143ca2ee62$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $4705b8143ca2ee62$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $4705b8143ca2ee62$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $4705b8143ca2ee62$var$Ke(c, f);
                var g = $4705b8143ca2ee62$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $4705b8143ca2ee62$var$Pe = $4705b8143ca2ee62$var$ia && "documentMode" in document && 11 >= document.documentMode, $4705b8143ca2ee62$var$Qe = null, $4705b8143ca2ee62$var$Re = null, $4705b8143ca2ee62$var$Se = null, $4705b8143ca2ee62$var$Te = !1;
function $4705b8143ca2ee62$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $4705b8143ca2ee62$var$Te || null == $4705b8143ca2ee62$var$Qe || $4705b8143ca2ee62$var$Qe !== $4705b8143ca2ee62$var$Xa(d) || (d = $4705b8143ca2ee62$var$Qe, "selectionStart" in d && $4705b8143ca2ee62$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $4705b8143ca2ee62$var$Se && $4705b8143ca2ee62$var$Ie($4705b8143ca2ee62$var$Se, d) || ($4705b8143ca2ee62$var$Se = d, d = $4705b8143ca2ee62$var$oe($4705b8143ca2ee62$var$Re, "onSelect"), 0 < d.length && (b = new $4705b8143ca2ee62$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $4705b8143ca2ee62$var$Qe)));
}
function $4705b8143ca2ee62$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $4705b8143ca2ee62$var$We = {
    animationend: $4705b8143ca2ee62$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $4705b8143ca2ee62$var$Ve("Animation", "AnimationIteration"),
    animationstart: $4705b8143ca2ee62$var$Ve("Animation", "AnimationStart"),
    transitionend: $4705b8143ca2ee62$var$Ve("Transition", "TransitionEnd")
}, $4705b8143ca2ee62$var$Xe = {}, $4705b8143ca2ee62$var$Ye = {};
$4705b8143ca2ee62$var$ia && ($4705b8143ca2ee62$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $4705b8143ca2ee62$var$We.animationend.animation, delete $4705b8143ca2ee62$var$We.animationiteration.animation, delete $4705b8143ca2ee62$var$We.animationstart.animation), "TransitionEvent" in window || delete $4705b8143ca2ee62$var$We.transitionend.transition);
function $4705b8143ca2ee62$var$Ze(a) {
    if ($4705b8143ca2ee62$var$Xe[a]) return $4705b8143ca2ee62$var$Xe[a];
    if (!$4705b8143ca2ee62$var$We[a]) return a;
    var b = $4705b8143ca2ee62$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $4705b8143ca2ee62$var$Ye) return $4705b8143ca2ee62$var$Xe[a] = b[c];
    return a;
}
var $4705b8143ca2ee62$var$$e = $4705b8143ca2ee62$var$Ze("animationend"), $4705b8143ca2ee62$var$af = $4705b8143ca2ee62$var$Ze("animationiteration"), $4705b8143ca2ee62$var$bf = $4705b8143ca2ee62$var$Ze("animationstart"), $4705b8143ca2ee62$var$cf = $4705b8143ca2ee62$var$Ze("transitionend"), $4705b8143ca2ee62$var$df = new Map, $4705b8143ca2ee62$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $4705b8143ca2ee62$var$ff(a, b) {
    $4705b8143ca2ee62$var$df.set(a, b);
    $4705b8143ca2ee62$var$fa(b, [
        a
    ]);
}
for(var $4705b8143ca2ee62$var$gf = 0; $4705b8143ca2ee62$var$gf < $4705b8143ca2ee62$var$ef.length; $4705b8143ca2ee62$var$gf++){
    var $4705b8143ca2ee62$var$hf = $4705b8143ca2ee62$var$ef[$4705b8143ca2ee62$var$gf], $4705b8143ca2ee62$var$jf = $4705b8143ca2ee62$var$hf.toLowerCase(), $4705b8143ca2ee62$var$kf = $4705b8143ca2ee62$var$hf[0].toUpperCase() + $4705b8143ca2ee62$var$hf.slice(1);
    $4705b8143ca2ee62$var$ff($4705b8143ca2ee62$var$jf, "on" + $4705b8143ca2ee62$var$kf);
}
$4705b8143ca2ee62$var$ff($4705b8143ca2ee62$var$$e, "onAnimationEnd");
$4705b8143ca2ee62$var$ff($4705b8143ca2ee62$var$af, "onAnimationIteration");
$4705b8143ca2ee62$var$ff($4705b8143ca2ee62$var$bf, "onAnimationStart");
$4705b8143ca2ee62$var$ff("dblclick", "onDoubleClick");
$4705b8143ca2ee62$var$ff("focusin", "onFocus");
$4705b8143ca2ee62$var$ff("focusout", "onBlur");
$4705b8143ca2ee62$var$ff($4705b8143ca2ee62$var$cf, "onTransitionEnd");
$4705b8143ca2ee62$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$4705b8143ca2ee62$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$4705b8143ca2ee62$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$4705b8143ca2ee62$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$4705b8143ca2ee62$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$4705b8143ca2ee62$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$4705b8143ca2ee62$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$4705b8143ca2ee62$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$4705b8143ca2ee62$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$4705b8143ca2ee62$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $4705b8143ca2ee62$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $4705b8143ca2ee62$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($4705b8143ca2ee62$var$lf));
function $4705b8143ca2ee62$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $4705b8143ca2ee62$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $4705b8143ca2ee62$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4705b8143ca2ee62$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4705b8143ca2ee62$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($4705b8143ca2ee62$var$Qb) throw a = $4705b8143ca2ee62$var$Rb, $4705b8143ca2ee62$var$Qb = !1, $4705b8143ca2ee62$var$Rb = null, a;
}
function $4705b8143ca2ee62$var$D(a, b) {
    var c = b[$4705b8143ca2ee62$var$of];
    void 0 === c && (c = b[$4705b8143ca2ee62$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($4705b8143ca2ee62$var$pf(b, a, 2, !1), c.add(d));
}
function $4705b8143ca2ee62$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $4705b8143ca2ee62$var$pf(c, a, d, b);
}
var $4705b8143ca2ee62$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $4705b8143ca2ee62$var$sf(a) {
    if (!a[$4705b8143ca2ee62$var$rf]) {
        a[$4705b8143ca2ee62$var$rf] = !0;
        $4705b8143ca2ee62$var$da.forEach(function(b) {
            "selectionchange" !== b && ($4705b8143ca2ee62$var$mf.has(b) || $4705b8143ca2ee62$var$qf(b, !1, a), $4705b8143ca2ee62$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$4705b8143ca2ee62$var$rf] || (b[$4705b8143ca2ee62$var$rf] = !0, $4705b8143ca2ee62$var$qf("selectionchange", !1, b));
    }
}
function $4705b8143ca2ee62$var$pf(a, b, c, d) {
    switch($4705b8143ca2ee62$var$jd(b)){
        case 1:
            var e = $4705b8143ca2ee62$var$ed;
            break;
        case 4:
            e = $4705b8143ca2ee62$var$gd;
            break;
        default:
            e = $4705b8143ca2ee62$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$4705b8143ca2ee62$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $4705b8143ca2ee62$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $4705b8143ca2ee62$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $4705b8143ca2ee62$var$Jb(function() {
        var d = f, e = $4705b8143ca2ee62$var$xb(c), g = [];
        a: {
            var h = $4705b8143ca2ee62$var$df.get(a);
            if (void 0 !== h) {
                var k = $4705b8143ca2ee62$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $4705b8143ca2ee62$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $4705b8143ca2ee62$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $4705b8143ca2ee62$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $4705b8143ca2ee62$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $4705b8143ca2ee62$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $4705b8143ca2ee62$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $4705b8143ca2ee62$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $4705b8143ca2ee62$var$Vd;
                        break;
                    case $4705b8143ca2ee62$var$$e:
                    case $4705b8143ca2ee62$var$af:
                    case $4705b8143ca2ee62$var$bf:
                        k = $4705b8143ca2ee62$var$Hd;
                        break;
                    case $4705b8143ca2ee62$var$cf:
                        k = $4705b8143ca2ee62$var$Xd;
                        break;
                    case "scroll":
                        k = $4705b8143ca2ee62$var$vd;
                        break;
                    case "wheel":
                        k = $4705b8143ca2ee62$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $4705b8143ca2ee62$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $4705b8143ca2ee62$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $4705b8143ca2ee62$var$Kb(w, x), null != F && t.push($4705b8143ca2ee62$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $4705b8143ca2ee62$var$wb && (n = c.relatedTarget || c.fromElement) && ($4705b8143ca2ee62$var$Wc(n) || n[$4705b8143ca2ee62$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $4705b8143ca2ee62$var$Wc(n) : null, null !== n && (J = $4705b8143ca2ee62$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $4705b8143ca2ee62$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $4705b8143ca2ee62$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $4705b8143ca2ee62$var$ue(k);
                        u = null == n ? h : $4705b8143ca2ee62$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $4705b8143ca2ee62$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $4705b8143ca2ee62$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $4705b8143ca2ee62$var$vf(F))u++;
                            for(; 0 < w - u;)t = $4705b8143ca2ee62$var$vf(t), w--;
                            for(; 0 < u - w;)x = $4705b8143ca2ee62$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $4705b8143ca2ee62$var$vf(t);
                                x = $4705b8143ca2ee62$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $4705b8143ca2ee62$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $4705b8143ca2ee62$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $4705b8143ca2ee62$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $4705b8143ca2ee62$var$ve;
                else if ($4705b8143ca2ee62$var$me(h)) {
                    if ($4705b8143ca2ee62$var$we) na = $4705b8143ca2ee62$var$Fe;
                    else {
                        na = $4705b8143ca2ee62$var$De;
                        var xa = $4705b8143ca2ee62$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $4705b8143ca2ee62$var$Ee);
                if (na && (na = na(a, d))) {
                    $4705b8143ca2ee62$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $4705b8143ca2ee62$var$cb(h, "number", h.value);
            }
            xa = d ? $4705b8143ca2ee62$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($4705b8143ca2ee62$var$me(xa) || "true" === xa.contentEditable) $4705b8143ca2ee62$var$Qe = xa, $4705b8143ca2ee62$var$Re = d, $4705b8143ca2ee62$var$Se = null;
                    break;
                case "focusout":
                    $4705b8143ca2ee62$var$Se = $4705b8143ca2ee62$var$Re = $4705b8143ca2ee62$var$Qe = null;
                    break;
                case "mousedown":
                    $4705b8143ca2ee62$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $4705b8143ca2ee62$var$Te = !1;
                    $4705b8143ca2ee62$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($4705b8143ca2ee62$var$Pe) break;
                case "keydown":
                case "keyup":
                    $4705b8143ca2ee62$var$Ue(g, c, e);
            }
            var $a;
            if ($4705b8143ca2ee62$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $4705b8143ca2ee62$var$ie ? $4705b8143ca2ee62$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($4705b8143ca2ee62$var$de && "ko" !== c.locale && ($4705b8143ca2ee62$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $4705b8143ca2ee62$var$ie && ($a = $4705b8143ca2ee62$var$nd()) : ($4705b8143ca2ee62$var$kd = e, $4705b8143ca2ee62$var$ld = "value" in $4705b8143ca2ee62$var$kd ? $4705b8143ca2ee62$var$kd.value : $4705b8143ca2ee62$var$kd.textContent, $4705b8143ca2ee62$var$ie = !0)), xa = $4705b8143ca2ee62$var$oe(d, ba), 0 < xa.length && (ba = new $4705b8143ca2ee62$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $4705b8143ca2ee62$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $4705b8143ca2ee62$var$ce ? $4705b8143ca2ee62$var$je(a, c) : $4705b8143ca2ee62$var$ke(a, c)) d = $4705b8143ca2ee62$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $4705b8143ca2ee62$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $4705b8143ca2ee62$var$se(g, b);
    });
}
function $4705b8143ca2ee62$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $4705b8143ca2ee62$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $4705b8143ca2ee62$var$Kb(a, c), null != f && d.unshift($4705b8143ca2ee62$var$tf(a, f, e)), f = $4705b8143ca2ee62$var$Kb(a, b), null != f && d.push($4705b8143ca2ee62$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $4705b8143ca2ee62$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $4705b8143ca2ee62$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $4705b8143ca2ee62$var$Kb(c, f), null != k && g.unshift($4705b8143ca2ee62$var$tf(c, k, h))) : e || (k = $4705b8143ca2ee62$var$Kb(c, f), null != k && g.push($4705b8143ca2ee62$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $4705b8143ca2ee62$var$xf = /\r\n?/g, $4705b8143ca2ee62$var$yf = /\u0000|\uFFFD/g;
function $4705b8143ca2ee62$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($4705b8143ca2ee62$var$xf, "\n").replace($4705b8143ca2ee62$var$yf, "");
}
function $4705b8143ca2ee62$var$Af(a, b, c) {
    b = $4705b8143ca2ee62$var$zf(b);
    if ($4705b8143ca2ee62$var$zf(a) !== b && c) throw Error($4705b8143ca2ee62$var$p(425));
}
function $4705b8143ca2ee62$var$Bf() {}
var $4705b8143ca2ee62$var$Cf = null, $4705b8143ca2ee62$var$Df = null;
function $4705b8143ca2ee62$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $4705b8143ca2ee62$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $4705b8143ca2ee62$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $4705b8143ca2ee62$var$Hf = "function" === typeof Promise ? Promise : void 0, $4705b8143ca2ee62$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $4705b8143ca2ee62$var$Hf ? function(a) {
    return $4705b8143ca2ee62$var$Hf.resolve(null).then(a).catch($4705b8143ca2ee62$var$If);
} : $4705b8143ca2ee62$var$Ff;
function $4705b8143ca2ee62$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $4705b8143ca2ee62$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $4705b8143ca2ee62$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $4705b8143ca2ee62$var$bd(b);
}
function $4705b8143ca2ee62$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $4705b8143ca2ee62$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $4705b8143ca2ee62$var$Nf = Math.random().toString(36).slice(2), $4705b8143ca2ee62$var$Of = "__reactFiber$" + $4705b8143ca2ee62$var$Nf, $4705b8143ca2ee62$var$Pf = "__reactProps$" + $4705b8143ca2ee62$var$Nf, $4705b8143ca2ee62$var$uf = "__reactContainer$" + $4705b8143ca2ee62$var$Nf, $4705b8143ca2ee62$var$of = "__reactEvents$" + $4705b8143ca2ee62$var$Nf, $4705b8143ca2ee62$var$Qf = "__reactListeners$" + $4705b8143ca2ee62$var$Nf, $4705b8143ca2ee62$var$Rf = "__reactHandles$" + $4705b8143ca2ee62$var$Nf;
function $4705b8143ca2ee62$var$Wc(a) {
    var b = a[$4705b8143ca2ee62$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$4705b8143ca2ee62$var$uf] || c[$4705b8143ca2ee62$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $4705b8143ca2ee62$var$Mf(a); null !== a;){
                if (c = a[$4705b8143ca2ee62$var$Of]) return c;
                a = $4705b8143ca2ee62$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $4705b8143ca2ee62$var$Cb(a) {
    a = a[$4705b8143ca2ee62$var$Of] || a[$4705b8143ca2ee62$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $4705b8143ca2ee62$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($4705b8143ca2ee62$var$p(33));
}
function $4705b8143ca2ee62$var$Db(a) {
    return a[$4705b8143ca2ee62$var$Pf] || null;
}
var $4705b8143ca2ee62$var$Sf = [], $4705b8143ca2ee62$var$Tf = -1;
function $4705b8143ca2ee62$var$Uf(a) {
    return {
        current: a
    };
}
function $4705b8143ca2ee62$var$E(a) {
    0 > $4705b8143ca2ee62$var$Tf || (a.current = $4705b8143ca2ee62$var$Sf[$4705b8143ca2ee62$var$Tf], $4705b8143ca2ee62$var$Sf[$4705b8143ca2ee62$var$Tf] = null, $4705b8143ca2ee62$var$Tf--);
}
function $4705b8143ca2ee62$var$G(a, b) {
    $4705b8143ca2ee62$var$Tf++;
    $4705b8143ca2ee62$var$Sf[$4705b8143ca2ee62$var$Tf] = a.current;
    a.current = b;
}
var $4705b8143ca2ee62$var$Vf = {}, $4705b8143ca2ee62$var$H = $4705b8143ca2ee62$var$Uf($4705b8143ca2ee62$var$Vf), $4705b8143ca2ee62$var$Wf = $4705b8143ca2ee62$var$Uf(!1), $4705b8143ca2ee62$var$Xf = $4705b8143ca2ee62$var$Vf;
function $4705b8143ca2ee62$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $4705b8143ca2ee62$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $4705b8143ca2ee62$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $4705b8143ca2ee62$var$$f() {
    $4705b8143ca2ee62$var$E($4705b8143ca2ee62$var$Wf);
    $4705b8143ca2ee62$var$E($4705b8143ca2ee62$var$H);
}
function $4705b8143ca2ee62$var$ag(a, b, c) {
    if ($4705b8143ca2ee62$var$H.current !== $4705b8143ca2ee62$var$Vf) throw Error($4705b8143ca2ee62$var$p(168));
    $4705b8143ca2ee62$var$G($4705b8143ca2ee62$var$H, b);
    $4705b8143ca2ee62$var$G($4705b8143ca2ee62$var$Wf, c);
}
function $4705b8143ca2ee62$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($4705b8143ca2ee62$var$p(108, $4705b8143ca2ee62$var$Ra(a) || "Unknown", e));
    return $4705b8143ca2ee62$var$A({}, c, d);
}
function $4705b8143ca2ee62$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $4705b8143ca2ee62$var$Vf;
    $4705b8143ca2ee62$var$Xf = $4705b8143ca2ee62$var$H.current;
    $4705b8143ca2ee62$var$G($4705b8143ca2ee62$var$H, a);
    $4705b8143ca2ee62$var$G($4705b8143ca2ee62$var$Wf, $4705b8143ca2ee62$var$Wf.current);
    return !0;
}
function $4705b8143ca2ee62$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($4705b8143ca2ee62$var$p(169));
    c ? (a = $4705b8143ca2ee62$var$bg(a, b, $4705b8143ca2ee62$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $4705b8143ca2ee62$var$E($4705b8143ca2ee62$var$Wf), $4705b8143ca2ee62$var$E($4705b8143ca2ee62$var$H), $4705b8143ca2ee62$var$G($4705b8143ca2ee62$var$H, a)) : $4705b8143ca2ee62$var$E($4705b8143ca2ee62$var$Wf);
    $4705b8143ca2ee62$var$G($4705b8143ca2ee62$var$Wf, c);
}
var $4705b8143ca2ee62$var$eg = null, $4705b8143ca2ee62$var$fg = !1, $4705b8143ca2ee62$var$gg = !1;
function $4705b8143ca2ee62$var$hg(a) {
    null === $4705b8143ca2ee62$var$eg ? $4705b8143ca2ee62$var$eg = [
        a
    ] : $4705b8143ca2ee62$var$eg.push(a);
}
function $4705b8143ca2ee62$var$ig(a) {
    $4705b8143ca2ee62$var$fg = !0;
    $4705b8143ca2ee62$var$hg(a);
}
function $4705b8143ca2ee62$var$jg() {
    if (!$4705b8143ca2ee62$var$gg && null !== $4705b8143ca2ee62$var$eg) {
        $4705b8143ca2ee62$var$gg = !0;
        var a = 0, b = $4705b8143ca2ee62$var$C;
        try {
            var c = $4705b8143ca2ee62$var$eg;
            for($4705b8143ca2ee62$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $4705b8143ca2ee62$var$eg = null;
            $4705b8143ca2ee62$var$fg = !1;
        } catch (e) {
            throw null !== $4705b8143ca2ee62$var$eg && ($4705b8143ca2ee62$var$eg = $4705b8143ca2ee62$var$eg.slice(a + 1)), $4705b8143ca2ee62$var$ac($4705b8143ca2ee62$var$fc, $4705b8143ca2ee62$var$jg), e;
        } finally{
            $4705b8143ca2ee62$var$C = b, $4705b8143ca2ee62$var$gg = !1;
        }
    }
    return null;
}
var $4705b8143ca2ee62$var$kg = [], $4705b8143ca2ee62$var$lg = 0, $4705b8143ca2ee62$var$mg = null, $4705b8143ca2ee62$var$ng = 0, $4705b8143ca2ee62$var$og = [], $4705b8143ca2ee62$var$pg = 0, $4705b8143ca2ee62$var$qg = null, $4705b8143ca2ee62$var$rg = 1, $4705b8143ca2ee62$var$sg = "";
function $4705b8143ca2ee62$var$tg(a, b) {
    $4705b8143ca2ee62$var$kg[$4705b8143ca2ee62$var$lg++] = $4705b8143ca2ee62$var$ng;
    $4705b8143ca2ee62$var$kg[$4705b8143ca2ee62$var$lg++] = $4705b8143ca2ee62$var$mg;
    $4705b8143ca2ee62$var$mg = a;
    $4705b8143ca2ee62$var$ng = b;
}
function $4705b8143ca2ee62$var$ug(a, b, c) {
    $4705b8143ca2ee62$var$og[$4705b8143ca2ee62$var$pg++] = $4705b8143ca2ee62$var$rg;
    $4705b8143ca2ee62$var$og[$4705b8143ca2ee62$var$pg++] = $4705b8143ca2ee62$var$sg;
    $4705b8143ca2ee62$var$og[$4705b8143ca2ee62$var$pg++] = $4705b8143ca2ee62$var$qg;
    $4705b8143ca2ee62$var$qg = a;
    var d = $4705b8143ca2ee62$var$rg;
    a = $4705b8143ca2ee62$var$sg;
    var e = 32 - $4705b8143ca2ee62$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $4705b8143ca2ee62$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $4705b8143ca2ee62$var$rg = 1 << 32 - $4705b8143ca2ee62$var$oc(b) + e | c << e | d;
        $4705b8143ca2ee62$var$sg = f + a;
    } else $4705b8143ca2ee62$var$rg = 1 << f | c << e | d, $4705b8143ca2ee62$var$sg = a;
}
function $4705b8143ca2ee62$var$vg(a) {
    null !== a.return && ($4705b8143ca2ee62$var$tg(a, 1), $4705b8143ca2ee62$var$ug(a, 1, 0));
}
function $4705b8143ca2ee62$var$wg(a) {
    for(; a === $4705b8143ca2ee62$var$mg;)$4705b8143ca2ee62$var$mg = $4705b8143ca2ee62$var$kg[--$4705b8143ca2ee62$var$lg], $4705b8143ca2ee62$var$kg[$4705b8143ca2ee62$var$lg] = null, $4705b8143ca2ee62$var$ng = $4705b8143ca2ee62$var$kg[--$4705b8143ca2ee62$var$lg], $4705b8143ca2ee62$var$kg[$4705b8143ca2ee62$var$lg] = null;
    for(; a === $4705b8143ca2ee62$var$qg;)$4705b8143ca2ee62$var$qg = $4705b8143ca2ee62$var$og[--$4705b8143ca2ee62$var$pg], $4705b8143ca2ee62$var$og[$4705b8143ca2ee62$var$pg] = null, $4705b8143ca2ee62$var$sg = $4705b8143ca2ee62$var$og[--$4705b8143ca2ee62$var$pg], $4705b8143ca2ee62$var$og[$4705b8143ca2ee62$var$pg] = null, $4705b8143ca2ee62$var$rg = $4705b8143ca2ee62$var$og[--$4705b8143ca2ee62$var$pg], $4705b8143ca2ee62$var$og[$4705b8143ca2ee62$var$pg] = null;
}
var $4705b8143ca2ee62$var$xg = null, $4705b8143ca2ee62$var$yg = null, $4705b8143ca2ee62$var$I = !1, $4705b8143ca2ee62$var$zg = null;
function $4705b8143ca2ee62$var$Ag(a, b) {
    var c = $4705b8143ca2ee62$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $4705b8143ca2ee62$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $4705b8143ca2ee62$var$xg = a, $4705b8143ca2ee62$var$yg = $4705b8143ca2ee62$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $4705b8143ca2ee62$var$xg = a, $4705b8143ca2ee62$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $4705b8143ca2ee62$var$qg ? {
                id: $4705b8143ca2ee62$var$rg,
                overflow: $4705b8143ca2ee62$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $4705b8143ca2ee62$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $4705b8143ca2ee62$var$xg = a, $4705b8143ca2ee62$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $4705b8143ca2ee62$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $4705b8143ca2ee62$var$Eg(a) {
    if ($4705b8143ca2ee62$var$I) {
        var b = $4705b8143ca2ee62$var$yg;
        if (b) {
            var c = b;
            if (!$4705b8143ca2ee62$var$Cg(a, b)) {
                if ($4705b8143ca2ee62$var$Dg(a)) throw Error($4705b8143ca2ee62$var$p(418));
                b = $4705b8143ca2ee62$var$Lf(c.nextSibling);
                var d = $4705b8143ca2ee62$var$xg;
                b && $4705b8143ca2ee62$var$Cg(a, b) ? $4705b8143ca2ee62$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $4705b8143ca2ee62$var$I = !1, $4705b8143ca2ee62$var$xg = a);
            }
        } else {
            if ($4705b8143ca2ee62$var$Dg(a)) throw Error($4705b8143ca2ee62$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $4705b8143ca2ee62$var$I = !1;
            $4705b8143ca2ee62$var$xg = a;
        }
    }
}
function $4705b8143ca2ee62$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $4705b8143ca2ee62$var$xg = a;
}
function $4705b8143ca2ee62$var$Gg(a) {
    if (a !== $4705b8143ca2ee62$var$xg) return !1;
    if (!$4705b8143ca2ee62$var$I) return $4705b8143ca2ee62$var$Fg(a), $4705b8143ca2ee62$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$4705b8143ca2ee62$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $4705b8143ca2ee62$var$yg)) {
        if ($4705b8143ca2ee62$var$Dg(a)) throw $4705b8143ca2ee62$var$Hg(), Error($4705b8143ca2ee62$var$p(418));
        for(; b;)$4705b8143ca2ee62$var$Ag(a, b), b = $4705b8143ca2ee62$var$Lf(b.nextSibling);
    }
    $4705b8143ca2ee62$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($4705b8143ca2ee62$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $4705b8143ca2ee62$var$yg = $4705b8143ca2ee62$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $4705b8143ca2ee62$var$yg = null;
        }
    } else $4705b8143ca2ee62$var$yg = $4705b8143ca2ee62$var$xg ? $4705b8143ca2ee62$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $4705b8143ca2ee62$var$Hg() {
    for(var a = $4705b8143ca2ee62$var$yg; a;)a = $4705b8143ca2ee62$var$Lf(a.nextSibling);
}
function $4705b8143ca2ee62$var$Ig() {
    $4705b8143ca2ee62$var$yg = $4705b8143ca2ee62$var$xg = null;
    $4705b8143ca2ee62$var$I = !1;
}
function $4705b8143ca2ee62$var$Jg(a) {
    null === $4705b8143ca2ee62$var$zg ? $4705b8143ca2ee62$var$zg = [
        a
    ] : $4705b8143ca2ee62$var$zg.push(a);
}
var $4705b8143ca2ee62$var$Kg = $4705b8143ca2ee62$var$ua.ReactCurrentBatchConfig;
function $4705b8143ca2ee62$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $4705b8143ca2ee62$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $4705b8143ca2ee62$var$Mg = $4705b8143ca2ee62$var$Uf(null), $4705b8143ca2ee62$var$Ng = null, $4705b8143ca2ee62$var$Og = null, $4705b8143ca2ee62$var$Pg = null;
function $4705b8143ca2ee62$var$Qg() {
    $4705b8143ca2ee62$var$Pg = $4705b8143ca2ee62$var$Og = $4705b8143ca2ee62$var$Ng = null;
}
function $4705b8143ca2ee62$var$Rg(a) {
    var b = $4705b8143ca2ee62$var$Mg.current;
    $4705b8143ca2ee62$var$E($4705b8143ca2ee62$var$Mg);
    a._currentValue = b;
}
function $4705b8143ca2ee62$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $4705b8143ca2ee62$var$Tg(a, b) {
    $4705b8143ca2ee62$var$Ng = a;
    $4705b8143ca2ee62$var$Pg = $4705b8143ca2ee62$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($4705b8143ca2ee62$var$Ug = !0), a.firstContext = null);
}
function $4705b8143ca2ee62$var$Vg(a) {
    var b = a._currentValue;
    if ($4705b8143ca2ee62$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $4705b8143ca2ee62$var$Og) {
            if (null === $4705b8143ca2ee62$var$Ng) throw Error($4705b8143ca2ee62$var$p(308));
            $4705b8143ca2ee62$var$Og = a;
            $4705b8143ca2ee62$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $4705b8143ca2ee62$var$Og = $4705b8143ca2ee62$var$Og.next = a;
    }
    return b;
}
var $4705b8143ca2ee62$var$Wg = null;
function $4705b8143ca2ee62$var$Xg(a) {
    null === $4705b8143ca2ee62$var$Wg ? $4705b8143ca2ee62$var$Wg = [
        a
    ] : $4705b8143ca2ee62$var$Wg.push(a);
}
function $4705b8143ca2ee62$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $4705b8143ca2ee62$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $4705b8143ca2ee62$var$Zg(a, d);
}
function $4705b8143ca2ee62$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $4705b8143ca2ee62$var$$g = !1;
function $4705b8143ca2ee62$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $4705b8143ca2ee62$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $4705b8143ca2ee62$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $4705b8143ca2ee62$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($4705b8143ca2ee62$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $4705b8143ca2ee62$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $4705b8143ca2ee62$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $4705b8143ca2ee62$var$Zg(a, c);
}
function $4705b8143ca2ee62$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4705b8143ca2ee62$var$Cc(a, c);
    }
}
function $4705b8143ca2ee62$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $4705b8143ca2ee62$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $4705b8143ca2ee62$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $4705b8143ca2ee62$var$A({}, q, r);
                            break a;
                        case 2:
                            $4705b8143ca2ee62$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $4705b8143ca2ee62$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $4705b8143ca2ee62$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($4705b8143ca2ee62$var$p(191, e));
            e.call(d);
        }
    }
}
var $4705b8143ca2ee62$var$jh = (new $iQhxf.Component).refs;
function $4705b8143ca2ee62$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $4705b8143ca2ee62$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $4705b8143ca2ee62$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $4705b8143ca2ee62$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4705b8143ca2ee62$var$L(), e = $4705b8143ca2ee62$var$lh(a), f = $4705b8143ca2ee62$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4705b8143ca2ee62$var$dh(a, f, e);
        null !== b && ($4705b8143ca2ee62$var$mh(b, a, e, d), $4705b8143ca2ee62$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4705b8143ca2ee62$var$L(), e = $4705b8143ca2ee62$var$lh(a), f = $4705b8143ca2ee62$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4705b8143ca2ee62$var$dh(a, f, e);
        null !== b && ($4705b8143ca2ee62$var$mh(b, a, e, d), $4705b8143ca2ee62$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $4705b8143ca2ee62$var$L(), d = $4705b8143ca2ee62$var$lh(a), e = $4705b8143ca2ee62$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $4705b8143ca2ee62$var$dh(a, e, d);
        null !== b && ($4705b8143ca2ee62$var$mh(b, a, d, c), $4705b8143ca2ee62$var$eh(b, a, d));
    }
};
function $4705b8143ca2ee62$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$4705b8143ca2ee62$var$Ie(c, d) || !$4705b8143ca2ee62$var$Ie(e, f) : !0;
}
function $4705b8143ca2ee62$var$ph(a, b, c) {
    var d = !1, e = $4705b8143ca2ee62$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $4705b8143ca2ee62$var$Vg(f) : (e = $4705b8143ca2ee62$var$Zf(b) ? $4705b8143ca2ee62$var$Xf : $4705b8143ca2ee62$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $4705b8143ca2ee62$var$Yf(a, e) : $4705b8143ca2ee62$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $4705b8143ca2ee62$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $4705b8143ca2ee62$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $4705b8143ca2ee62$var$nh.enqueueReplaceState(b, b.state, null);
}
function $4705b8143ca2ee62$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $4705b8143ca2ee62$var$jh;
    $4705b8143ca2ee62$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $4705b8143ca2ee62$var$Vg(f) : (f = $4705b8143ca2ee62$var$Zf(b) ? $4705b8143ca2ee62$var$Xf : $4705b8143ca2ee62$var$H.current, e.context = $4705b8143ca2ee62$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($4705b8143ca2ee62$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $4705b8143ca2ee62$var$nh.enqueueReplaceState(e, e.state, null), $4705b8143ca2ee62$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $4705b8143ca2ee62$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($4705b8143ca2ee62$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($4705b8143ca2ee62$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $4705b8143ca2ee62$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($4705b8143ca2ee62$var$p(284));
        if (!c._owner) throw Error($4705b8143ca2ee62$var$p(290, a));
    }
    return a;
}
function $4705b8143ca2ee62$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($4705b8143ca2ee62$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $4705b8143ca2ee62$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $4705b8143ca2ee62$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $4705b8143ca2ee62$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $4705b8143ca2ee62$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $4705b8143ca2ee62$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $4705b8143ca2ee62$var$Ha && $4705b8143ca2ee62$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $4705b8143ca2ee62$var$sh(a, b, c), d.return = a, d;
        d = $4705b8143ca2ee62$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $4705b8143ca2ee62$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $4705b8143ca2ee62$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $4705b8143ca2ee62$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $4705b8143ca2ee62$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $4705b8143ca2ee62$var$va:
                    return c = $4705b8143ca2ee62$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $4705b8143ca2ee62$var$sh(a, null, b), c.return = a, c;
                case $4705b8143ca2ee62$var$wa:
                    return b = $4705b8143ca2ee62$var$zh(b, a.mode, c), b.return = a, b;
                case $4705b8143ca2ee62$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($4705b8143ca2ee62$var$eb(b) || $4705b8143ca2ee62$var$Ka(b)) return b = $4705b8143ca2ee62$var$Ah(b, a.mode, c, null), b.return = a, b;
            $4705b8143ca2ee62$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $4705b8143ca2ee62$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $4705b8143ca2ee62$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $4705b8143ca2ee62$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($4705b8143ca2ee62$var$eb(c) || $4705b8143ca2ee62$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $4705b8143ca2ee62$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $4705b8143ca2ee62$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $4705b8143ca2ee62$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $4705b8143ca2ee62$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($4705b8143ca2ee62$var$eb(d) || $4705b8143ca2ee62$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $4705b8143ca2ee62$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $4705b8143ca2ee62$var$I && $4705b8143ca2ee62$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $4705b8143ca2ee62$var$I && $4705b8143ca2ee62$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $4705b8143ca2ee62$var$I && $4705b8143ca2ee62$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $4705b8143ca2ee62$var$Ka(h);
        if ("function" !== typeof l) throw Error($4705b8143ca2ee62$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($4705b8143ca2ee62$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $4705b8143ca2ee62$var$I && $4705b8143ca2ee62$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $4705b8143ca2ee62$var$I && $4705b8143ca2ee62$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $4705b8143ca2ee62$var$I && $4705b8143ca2ee62$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $4705b8143ca2ee62$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $4705b8143ca2ee62$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $4705b8143ca2ee62$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $4705b8143ca2ee62$var$Ha && $4705b8143ca2ee62$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $4705b8143ca2ee62$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $4705b8143ca2ee62$var$ya ? (d = $4705b8143ca2ee62$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $4705b8143ca2ee62$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $4705b8143ca2ee62$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $4705b8143ca2ee62$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $4705b8143ca2ee62$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $4705b8143ca2ee62$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($4705b8143ca2ee62$var$eb(f)) return n(a, d, f, h);
            if ($4705b8143ca2ee62$var$Ka(f)) return t(a, d, f, h);
            $4705b8143ca2ee62$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $4705b8143ca2ee62$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $4705b8143ca2ee62$var$Bh = $4705b8143ca2ee62$var$vh(!0), $4705b8143ca2ee62$var$Ch = $4705b8143ca2ee62$var$vh(!1), $4705b8143ca2ee62$var$Dh = {}, $4705b8143ca2ee62$var$Eh = $4705b8143ca2ee62$var$Uf($4705b8143ca2ee62$var$Dh), $4705b8143ca2ee62$var$Fh = $4705b8143ca2ee62$var$Uf($4705b8143ca2ee62$var$Dh), $4705b8143ca2ee62$var$Gh = $4705b8143ca2ee62$var$Uf($4705b8143ca2ee62$var$Dh);
function $4705b8143ca2ee62$var$Hh(a) {
    if (a === $4705b8143ca2ee62$var$Dh) throw Error($4705b8143ca2ee62$var$p(174));
    return a;
}
function $4705b8143ca2ee62$var$Ih(a, b) {
    $4705b8143ca2ee62$var$G($4705b8143ca2ee62$var$Gh, b);
    $4705b8143ca2ee62$var$G($4705b8143ca2ee62$var$Fh, a);
    $4705b8143ca2ee62$var$G($4705b8143ca2ee62$var$Eh, $4705b8143ca2ee62$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $4705b8143ca2ee62$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $4705b8143ca2ee62$var$lb(b, a);
    }
    $4705b8143ca2ee62$var$E($4705b8143ca2ee62$var$Eh);
    $4705b8143ca2ee62$var$G($4705b8143ca2ee62$var$Eh, b);
}
function $4705b8143ca2ee62$var$Jh() {
    $4705b8143ca2ee62$var$E($4705b8143ca2ee62$var$Eh);
    $4705b8143ca2ee62$var$E($4705b8143ca2ee62$var$Fh);
    $4705b8143ca2ee62$var$E($4705b8143ca2ee62$var$Gh);
}
function $4705b8143ca2ee62$var$Kh(a) {
    $4705b8143ca2ee62$var$Hh($4705b8143ca2ee62$var$Gh.current);
    var b = $4705b8143ca2ee62$var$Hh($4705b8143ca2ee62$var$Eh.current);
    var c = $4705b8143ca2ee62$var$lb(b, a.type);
    b !== c && ($4705b8143ca2ee62$var$G($4705b8143ca2ee62$var$Fh, a), $4705b8143ca2ee62$var$G($4705b8143ca2ee62$var$Eh, c));
}
function $4705b8143ca2ee62$var$Lh(a) {
    $4705b8143ca2ee62$var$Fh.current === a && ($4705b8143ca2ee62$var$E($4705b8143ca2ee62$var$Eh), $4705b8143ca2ee62$var$E($4705b8143ca2ee62$var$Fh));
}
var $4705b8143ca2ee62$var$M = $4705b8143ca2ee62$var$Uf(0);
function $4705b8143ca2ee62$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $4705b8143ca2ee62$var$Nh = [];
function $4705b8143ca2ee62$var$Oh() {
    for(var a = 0; a < $4705b8143ca2ee62$var$Nh.length; a++)$4705b8143ca2ee62$var$Nh[a]._workInProgressVersionPrimary = null;
    $4705b8143ca2ee62$var$Nh.length = 0;
}
var $4705b8143ca2ee62$var$Ph = $4705b8143ca2ee62$var$ua.ReactCurrentDispatcher, $4705b8143ca2ee62$var$Qh = $4705b8143ca2ee62$var$ua.ReactCurrentBatchConfig, $4705b8143ca2ee62$var$Rh = 0, $4705b8143ca2ee62$var$N = null, $4705b8143ca2ee62$var$O = null, $4705b8143ca2ee62$var$P = null, $4705b8143ca2ee62$var$Sh = !1, $4705b8143ca2ee62$var$Th = !1, $4705b8143ca2ee62$var$Uh = 0, $4705b8143ca2ee62$var$Vh = 0;
function $4705b8143ca2ee62$var$Q() {
    throw Error($4705b8143ca2ee62$var$p(321));
}
function $4705b8143ca2ee62$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$4705b8143ca2ee62$var$He(a[c], b[c])) return !1;
    return !0;
}
function $4705b8143ca2ee62$var$Xh(a, b, c, d, e, f) {
    $4705b8143ca2ee62$var$Rh = f;
    $4705b8143ca2ee62$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $4705b8143ca2ee62$var$Ph.current = null === a || null === a.memoizedState ? $4705b8143ca2ee62$var$Yh : $4705b8143ca2ee62$var$Zh;
    a = c(d, e);
    if ($4705b8143ca2ee62$var$Th) {
        f = 0;
        do {
            $4705b8143ca2ee62$var$Th = !1;
            $4705b8143ca2ee62$var$Uh = 0;
            if (25 <= f) throw Error($4705b8143ca2ee62$var$p(301));
            f += 1;
            $4705b8143ca2ee62$var$P = $4705b8143ca2ee62$var$O = null;
            b.updateQueue = null;
            $4705b8143ca2ee62$var$Ph.current = $4705b8143ca2ee62$var$$h;
            a = c(d, e);
        }while ($4705b8143ca2ee62$var$Th);
    }
    $4705b8143ca2ee62$var$Ph.current = $4705b8143ca2ee62$var$ai;
    b = null !== $4705b8143ca2ee62$var$O && null !== $4705b8143ca2ee62$var$O.next;
    $4705b8143ca2ee62$var$Rh = 0;
    $4705b8143ca2ee62$var$P = $4705b8143ca2ee62$var$O = $4705b8143ca2ee62$var$N = null;
    $4705b8143ca2ee62$var$Sh = !1;
    if (b) throw Error($4705b8143ca2ee62$var$p(300));
    return a;
}
function $4705b8143ca2ee62$var$bi() {
    var a = 0 !== $4705b8143ca2ee62$var$Uh;
    $4705b8143ca2ee62$var$Uh = 0;
    return a;
}
function $4705b8143ca2ee62$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $4705b8143ca2ee62$var$P ? $4705b8143ca2ee62$var$N.memoizedState = $4705b8143ca2ee62$var$P = a : $4705b8143ca2ee62$var$P = $4705b8143ca2ee62$var$P.next = a;
    return $4705b8143ca2ee62$var$P;
}
function $4705b8143ca2ee62$var$di() {
    if (null === $4705b8143ca2ee62$var$O) {
        var a = $4705b8143ca2ee62$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $4705b8143ca2ee62$var$O.next;
    var b = null === $4705b8143ca2ee62$var$P ? $4705b8143ca2ee62$var$N.memoizedState : $4705b8143ca2ee62$var$P.next;
    if (null !== b) $4705b8143ca2ee62$var$P = b, $4705b8143ca2ee62$var$O = a;
    else {
        if (null === a) throw Error($4705b8143ca2ee62$var$p(310));
        $4705b8143ca2ee62$var$O = a;
        a = {
            memoizedState: $4705b8143ca2ee62$var$O.memoizedState,
            baseState: $4705b8143ca2ee62$var$O.baseState,
            baseQueue: $4705b8143ca2ee62$var$O.baseQueue,
            queue: $4705b8143ca2ee62$var$O.queue,
            next: null
        };
        null === $4705b8143ca2ee62$var$P ? $4705b8143ca2ee62$var$N.memoizedState = $4705b8143ca2ee62$var$P = a : $4705b8143ca2ee62$var$P = $4705b8143ca2ee62$var$P.next = a;
    }
    return $4705b8143ca2ee62$var$P;
}
function $4705b8143ca2ee62$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $4705b8143ca2ee62$var$fi(a) {
    var b = $4705b8143ca2ee62$var$di(), c = b.queue;
    if (null === c) throw Error($4705b8143ca2ee62$var$p(311));
    c.lastRenderedReducer = a;
    var d = $4705b8143ca2ee62$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($4705b8143ca2ee62$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $4705b8143ca2ee62$var$N.lanes |= m;
                $4705b8143ca2ee62$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $4705b8143ca2ee62$var$He(d, b.memoizedState) || ($4705b8143ca2ee62$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $4705b8143ca2ee62$var$N.lanes |= f, $4705b8143ca2ee62$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $4705b8143ca2ee62$var$gi(a) {
    var b = $4705b8143ca2ee62$var$di(), c = b.queue;
    if (null === c) throw Error($4705b8143ca2ee62$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $4705b8143ca2ee62$var$He(f, b.memoizedState) || ($4705b8143ca2ee62$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $4705b8143ca2ee62$var$hi() {}
function $4705b8143ca2ee62$var$ii(a, b) {
    var c = $4705b8143ca2ee62$var$N, d = $4705b8143ca2ee62$var$di(), e = b(), f = !$4705b8143ca2ee62$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $4705b8143ca2ee62$var$Ug = !0);
    d = d.queue;
    $4705b8143ca2ee62$var$ji($4705b8143ca2ee62$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $4705b8143ca2ee62$var$P && $4705b8143ca2ee62$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $4705b8143ca2ee62$var$li(9, $4705b8143ca2ee62$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $4705b8143ca2ee62$var$R) throw Error($4705b8143ca2ee62$var$p(349));
        0 !== ($4705b8143ca2ee62$var$Rh & 30) || $4705b8143ca2ee62$var$ni(c, b, e);
    }
    return e;
}
function $4705b8143ca2ee62$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $4705b8143ca2ee62$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4705b8143ca2ee62$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $4705b8143ca2ee62$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $4705b8143ca2ee62$var$oi(b) && $4705b8143ca2ee62$var$pi(a);
}
function $4705b8143ca2ee62$var$ki(a, b, c) {
    return c(function() {
        $4705b8143ca2ee62$var$oi(b) && $4705b8143ca2ee62$var$pi(a);
    });
}
function $4705b8143ca2ee62$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$4705b8143ca2ee62$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $4705b8143ca2ee62$var$pi(a) {
    var b = $4705b8143ca2ee62$var$Zg(a, 1);
    null !== b && $4705b8143ca2ee62$var$mh(b, a, 1, -1);
}
function $4705b8143ca2ee62$var$qi(a) {
    var b = $4705b8143ca2ee62$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $4705b8143ca2ee62$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $4705b8143ca2ee62$var$ri.bind(null, $4705b8143ca2ee62$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $4705b8143ca2ee62$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $4705b8143ca2ee62$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4705b8143ca2ee62$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $4705b8143ca2ee62$var$si() {
    return $4705b8143ca2ee62$var$di().memoizedState;
}
function $4705b8143ca2ee62$var$ti(a, b, c, d) {
    var e = $4705b8143ca2ee62$var$ci();
    $4705b8143ca2ee62$var$N.flags |= a;
    e.memoizedState = $4705b8143ca2ee62$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $4705b8143ca2ee62$var$ui(a, b, c, d) {
    var e = $4705b8143ca2ee62$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $4705b8143ca2ee62$var$O) {
        var g = $4705b8143ca2ee62$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $4705b8143ca2ee62$var$Wh(d, g.deps)) {
            e.memoizedState = $4705b8143ca2ee62$var$li(b, c, f, d);
            return;
        }
    }
    $4705b8143ca2ee62$var$N.flags |= a;
    e.memoizedState = $4705b8143ca2ee62$var$li(1 | b, c, f, d);
}
function $4705b8143ca2ee62$var$vi(a, b) {
    return $4705b8143ca2ee62$var$ti(8390656, 8, a, b);
}
function $4705b8143ca2ee62$var$ji(a, b) {
    return $4705b8143ca2ee62$var$ui(2048, 8, a, b);
}
function $4705b8143ca2ee62$var$wi(a, b) {
    return $4705b8143ca2ee62$var$ui(4, 2, a, b);
}
function $4705b8143ca2ee62$var$xi(a, b) {
    return $4705b8143ca2ee62$var$ui(4, 4, a, b);
}
function $4705b8143ca2ee62$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $4705b8143ca2ee62$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $4705b8143ca2ee62$var$ui(4, 4, $4705b8143ca2ee62$var$yi.bind(null, b, a), c);
}
function $4705b8143ca2ee62$var$Ai() {}
function $4705b8143ca2ee62$var$Bi(a, b) {
    var c = $4705b8143ca2ee62$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4705b8143ca2ee62$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4705b8143ca2ee62$var$Ci(a, b) {
    var c = $4705b8143ca2ee62$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4705b8143ca2ee62$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4705b8143ca2ee62$var$Di(a, b, c) {
    if (0 === ($4705b8143ca2ee62$var$Rh & 21)) return a.baseState && (a.baseState = !1, $4705b8143ca2ee62$var$Ug = !0), a.memoizedState = c;
    $4705b8143ca2ee62$var$He(c, b) || (c = $4705b8143ca2ee62$var$yc(), $4705b8143ca2ee62$var$N.lanes |= c, $4705b8143ca2ee62$var$hh |= c, a.baseState = !0);
    return b;
}
function $4705b8143ca2ee62$var$Ei(a, b) {
    var c = $4705b8143ca2ee62$var$C;
    $4705b8143ca2ee62$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $4705b8143ca2ee62$var$Qh.transition;
    $4705b8143ca2ee62$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $4705b8143ca2ee62$var$C = c, $4705b8143ca2ee62$var$Qh.transition = d;
    }
}
function $4705b8143ca2ee62$var$Fi() {
    return $4705b8143ca2ee62$var$di().memoizedState;
}
function $4705b8143ca2ee62$var$Gi(a, b, c) {
    var d = $4705b8143ca2ee62$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4705b8143ca2ee62$var$Hi(a)) $4705b8143ca2ee62$var$Ii(b, c);
    else if (c = $4705b8143ca2ee62$var$Yg(a, b, c, d), null !== c) {
        var e = $4705b8143ca2ee62$var$L();
        $4705b8143ca2ee62$var$mh(c, a, d, e);
        $4705b8143ca2ee62$var$Ji(c, b, d);
    }
}
function $4705b8143ca2ee62$var$ri(a, b, c) {
    var d = $4705b8143ca2ee62$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4705b8143ca2ee62$var$Hi(a)) $4705b8143ca2ee62$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($4705b8143ca2ee62$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $4705b8143ca2ee62$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $4705b8143ca2ee62$var$Yg(a, b, e, d);
        null !== c && (e = $4705b8143ca2ee62$var$L(), $4705b8143ca2ee62$var$mh(c, a, d, e), $4705b8143ca2ee62$var$Ji(c, b, d));
    }
}
function $4705b8143ca2ee62$var$Hi(a) {
    var b = a.alternate;
    return a === $4705b8143ca2ee62$var$N || null !== b && b === $4705b8143ca2ee62$var$N;
}
function $4705b8143ca2ee62$var$Ii(a, b) {
    $4705b8143ca2ee62$var$Th = $4705b8143ca2ee62$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $4705b8143ca2ee62$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4705b8143ca2ee62$var$Cc(a, c);
    }
}
var $4705b8143ca2ee62$var$ai = {
    readContext: $4705b8143ca2ee62$var$Vg,
    useCallback: $4705b8143ca2ee62$var$Q,
    useContext: $4705b8143ca2ee62$var$Q,
    useEffect: $4705b8143ca2ee62$var$Q,
    useImperativeHandle: $4705b8143ca2ee62$var$Q,
    useInsertionEffect: $4705b8143ca2ee62$var$Q,
    useLayoutEffect: $4705b8143ca2ee62$var$Q,
    useMemo: $4705b8143ca2ee62$var$Q,
    useReducer: $4705b8143ca2ee62$var$Q,
    useRef: $4705b8143ca2ee62$var$Q,
    useState: $4705b8143ca2ee62$var$Q,
    useDebugValue: $4705b8143ca2ee62$var$Q,
    useDeferredValue: $4705b8143ca2ee62$var$Q,
    useTransition: $4705b8143ca2ee62$var$Q,
    useMutableSource: $4705b8143ca2ee62$var$Q,
    useSyncExternalStore: $4705b8143ca2ee62$var$Q,
    useId: $4705b8143ca2ee62$var$Q,
    unstable_isNewReconciler: !1
}, $4705b8143ca2ee62$var$Yh = {
    readContext: $4705b8143ca2ee62$var$Vg,
    useCallback: function(a, b) {
        $4705b8143ca2ee62$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $4705b8143ca2ee62$var$Vg,
    useEffect: $4705b8143ca2ee62$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $4705b8143ca2ee62$var$ti(4194308, 4, $4705b8143ca2ee62$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $4705b8143ca2ee62$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $4705b8143ca2ee62$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $4705b8143ca2ee62$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $4705b8143ca2ee62$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $4705b8143ca2ee62$var$Gi.bind(null, $4705b8143ca2ee62$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $4705b8143ca2ee62$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $4705b8143ca2ee62$var$qi,
    useDebugValue: $4705b8143ca2ee62$var$Ai,
    useDeferredValue: function(a) {
        return $4705b8143ca2ee62$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $4705b8143ca2ee62$var$qi(!1), b = a[0];
        a = $4705b8143ca2ee62$var$Ei.bind(null, a[1]);
        $4705b8143ca2ee62$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $4705b8143ca2ee62$var$N, e = $4705b8143ca2ee62$var$ci();
        if ($4705b8143ca2ee62$var$I) {
            if (void 0 === c) throw Error($4705b8143ca2ee62$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $4705b8143ca2ee62$var$R) throw Error($4705b8143ca2ee62$var$p(349));
            0 !== ($4705b8143ca2ee62$var$Rh & 30) || $4705b8143ca2ee62$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $4705b8143ca2ee62$var$vi($4705b8143ca2ee62$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $4705b8143ca2ee62$var$li(9, $4705b8143ca2ee62$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $4705b8143ca2ee62$var$ci(), b = $4705b8143ca2ee62$var$R.identifierPrefix;
        if ($4705b8143ca2ee62$var$I) {
            var c = $4705b8143ca2ee62$var$sg;
            var d = $4705b8143ca2ee62$var$rg;
            c = (d & ~(1 << 32 - $4705b8143ca2ee62$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $4705b8143ca2ee62$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $4705b8143ca2ee62$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $4705b8143ca2ee62$var$Zh = {
    readContext: $4705b8143ca2ee62$var$Vg,
    useCallback: $4705b8143ca2ee62$var$Bi,
    useContext: $4705b8143ca2ee62$var$Vg,
    useEffect: $4705b8143ca2ee62$var$ji,
    useImperativeHandle: $4705b8143ca2ee62$var$zi,
    useInsertionEffect: $4705b8143ca2ee62$var$wi,
    useLayoutEffect: $4705b8143ca2ee62$var$xi,
    useMemo: $4705b8143ca2ee62$var$Ci,
    useReducer: $4705b8143ca2ee62$var$fi,
    useRef: $4705b8143ca2ee62$var$si,
    useState: function() {
        return $4705b8143ca2ee62$var$fi($4705b8143ca2ee62$var$ei);
    },
    useDebugValue: $4705b8143ca2ee62$var$Ai,
    useDeferredValue: function(a) {
        var b = $4705b8143ca2ee62$var$di();
        return $4705b8143ca2ee62$var$Di(b, $4705b8143ca2ee62$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $4705b8143ca2ee62$var$fi($4705b8143ca2ee62$var$ei)[0], b = $4705b8143ca2ee62$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4705b8143ca2ee62$var$hi,
    useSyncExternalStore: $4705b8143ca2ee62$var$ii,
    useId: $4705b8143ca2ee62$var$Fi,
    unstable_isNewReconciler: !1
}, $4705b8143ca2ee62$var$$h = {
    readContext: $4705b8143ca2ee62$var$Vg,
    useCallback: $4705b8143ca2ee62$var$Bi,
    useContext: $4705b8143ca2ee62$var$Vg,
    useEffect: $4705b8143ca2ee62$var$ji,
    useImperativeHandle: $4705b8143ca2ee62$var$zi,
    useInsertionEffect: $4705b8143ca2ee62$var$wi,
    useLayoutEffect: $4705b8143ca2ee62$var$xi,
    useMemo: $4705b8143ca2ee62$var$Ci,
    useReducer: $4705b8143ca2ee62$var$gi,
    useRef: $4705b8143ca2ee62$var$si,
    useState: function() {
        return $4705b8143ca2ee62$var$gi($4705b8143ca2ee62$var$ei);
    },
    useDebugValue: $4705b8143ca2ee62$var$Ai,
    useDeferredValue: function(a) {
        var b = $4705b8143ca2ee62$var$di();
        return null === $4705b8143ca2ee62$var$O ? b.memoizedState = a : $4705b8143ca2ee62$var$Di(b, $4705b8143ca2ee62$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $4705b8143ca2ee62$var$gi($4705b8143ca2ee62$var$ei)[0], b = $4705b8143ca2ee62$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4705b8143ca2ee62$var$hi,
    useSyncExternalStore: $4705b8143ca2ee62$var$ii,
    useId: $4705b8143ca2ee62$var$Fi,
    unstable_isNewReconciler: !1
};
function $4705b8143ca2ee62$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $4705b8143ca2ee62$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $4705b8143ca2ee62$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $4705b8143ca2ee62$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $4705b8143ca2ee62$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $4705b8143ca2ee62$var$Oi(a, b, c) {
    c = $4705b8143ca2ee62$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $4705b8143ca2ee62$var$Pi || ($4705b8143ca2ee62$var$Pi = !0, $4705b8143ca2ee62$var$Qi = d);
        $4705b8143ca2ee62$var$Mi(a, b);
    };
    return c;
}
function $4705b8143ca2ee62$var$Ri(a, b, c) {
    c = $4705b8143ca2ee62$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $4705b8143ca2ee62$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $4705b8143ca2ee62$var$Mi(a, b);
        "function" !== typeof d && (null === $4705b8143ca2ee62$var$Si ? $4705b8143ca2ee62$var$Si = new Set([
            this
        ]) : $4705b8143ca2ee62$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $4705b8143ca2ee62$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $4705b8143ca2ee62$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $4705b8143ca2ee62$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $4705b8143ca2ee62$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $4705b8143ca2ee62$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $4705b8143ca2ee62$var$ch(-1, 1), b.tag = 2, $4705b8143ca2ee62$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $4705b8143ca2ee62$var$Xi = $4705b8143ca2ee62$var$ua.ReactCurrentOwner, $4705b8143ca2ee62$var$Ug = !1;
function $4705b8143ca2ee62$var$Yi(a, b, c, d) {
    b.child = null === a ? $4705b8143ca2ee62$var$Ch(b, null, c, d) : $4705b8143ca2ee62$var$Bh(b, a.child, c, d);
}
function $4705b8143ca2ee62$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $4705b8143ca2ee62$var$Tg(b, e);
    d = $4705b8143ca2ee62$var$Xh(a, b, c, d, f, e);
    c = $4705b8143ca2ee62$var$bi();
    if (null !== a && !$4705b8143ca2ee62$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4705b8143ca2ee62$var$$i(a, b, e);
    $4705b8143ca2ee62$var$I && c && $4705b8143ca2ee62$var$vg(b);
    b.flags |= 1;
    $4705b8143ca2ee62$var$Yi(a, b, d, e);
    return b.child;
}
function $4705b8143ca2ee62$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$4705b8143ca2ee62$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $4705b8143ca2ee62$var$cj(a, b, f, d, e);
        a = $4705b8143ca2ee62$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $4705b8143ca2ee62$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $4705b8143ca2ee62$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $4705b8143ca2ee62$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $4705b8143ca2ee62$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($4705b8143ca2ee62$var$Ie(f, d) && a.ref === b.ref) {
            if ($4705b8143ca2ee62$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($4705b8143ca2ee62$var$Ug = !0);
            else return b.lanes = a.lanes, $4705b8143ca2ee62$var$$i(a, b, e);
        }
    }
    return $4705b8143ca2ee62$var$dj(a, b, c, d, e);
}
function $4705b8143ca2ee62$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $4705b8143ca2ee62$var$G($4705b8143ca2ee62$var$fj, $4705b8143ca2ee62$var$gj), $4705b8143ca2ee62$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $4705b8143ca2ee62$var$G($4705b8143ca2ee62$var$fj, $4705b8143ca2ee62$var$gj), $4705b8143ca2ee62$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $4705b8143ca2ee62$var$G($4705b8143ca2ee62$var$fj, $4705b8143ca2ee62$var$gj);
            $4705b8143ca2ee62$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $4705b8143ca2ee62$var$G($4705b8143ca2ee62$var$fj, $4705b8143ca2ee62$var$gj), $4705b8143ca2ee62$var$gj |= d;
    $4705b8143ca2ee62$var$Yi(a, b, e, c);
    return b.child;
}
function $4705b8143ca2ee62$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $4705b8143ca2ee62$var$dj(a, b, c, d, e) {
    var f = $4705b8143ca2ee62$var$Zf(c) ? $4705b8143ca2ee62$var$Xf : $4705b8143ca2ee62$var$H.current;
    f = $4705b8143ca2ee62$var$Yf(b, f);
    $4705b8143ca2ee62$var$Tg(b, e);
    c = $4705b8143ca2ee62$var$Xh(a, b, c, d, f, e);
    d = $4705b8143ca2ee62$var$bi();
    if (null !== a && !$4705b8143ca2ee62$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4705b8143ca2ee62$var$$i(a, b, e);
    $4705b8143ca2ee62$var$I && d && $4705b8143ca2ee62$var$vg(b);
    b.flags |= 1;
    $4705b8143ca2ee62$var$Yi(a, b, c, e);
    return b.child;
}
function $4705b8143ca2ee62$var$ij(a, b, c, d, e) {
    if ($4705b8143ca2ee62$var$Zf(c)) {
        var f = !0;
        $4705b8143ca2ee62$var$cg(b);
    } else f = !1;
    $4705b8143ca2ee62$var$Tg(b, e);
    if (null === b.stateNode) $4705b8143ca2ee62$var$jj(a, b), $4705b8143ca2ee62$var$ph(b, c, d), $4705b8143ca2ee62$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $4705b8143ca2ee62$var$Vg(l) : (l = $4705b8143ca2ee62$var$Zf(c) ? $4705b8143ca2ee62$var$Xf : $4705b8143ca2ee62$var$H.current, l = $4705b8143ca2ee62$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $4705b8143ca2ee62$var$qh(b, g, d, l);
        $4705b8143ca2ee62$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $4705b8143ca2ee62$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $4705b8143ca2ee62$var$Wf.current || $4705b8143ca2ee62$var$$g ? ("function" === typeof m && ($4705b8143ca2ee62$var$kh(b, c, m, d), k = b.memoizedState), (h = $4705b8143ca2ee62$var$$g || $4705b8143ca2ee62$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $4705b8143ca2ee62$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $4705b8143ca2ee62$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $4705b8143ca2ee62$var$Vg(k) : (k = $4705b8143ca2ee62$var$Zf(c) ? $4705b8143ca2ee62$var$Xf : $4705b8143ca2ee62$var$H.current, k = $4705b8143ca2ee62$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $4705b8143ca2ee62$var$qh(b, g, d, k);
        $4705b8143ca2ee62$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $4705b8143ca2ee62$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $4705b8143ca2ee62$var$Wf.current || $4705b8143ca2ee62$var$$g ? ("function" === typeof y && ($4705b8143ca2ee62$var$kh(b, c, y, d), n = b.memoizedState), (l = $4705b8143ca2ee62$var$$g || $4705b8143ca2ee62$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $4705b8143ca2ee62$var$kj(a, b, c, d, f, e);
}
function $4705b8143ca2ee62$var$kj(a, b, c, d, e, f) {
    $4705b8143ca2ee62$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $4705b8143ca2ee62$var$dg(b, c, !1), $4705b8143ca2ee62$var$$i(a, b, f);
    d = b.stateNode;
    $4705b8143ca2ee62$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $4705b8143ca2ee62$var$Bh(b, a.child, null, f), b.child = $4705b8143ca2ee62$var$Bh(b, null, h, f)) : $4705b8143ca2ee62$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $4705b8143ca2ee62$var$dg(b, c, !0);
    return b.child;
}
function $4705b8143ca2ee62$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $4705b8143ca2ee62$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $4705b8143ca2ee62$var$ag(a, b.context, !1);
    $4705b8143ca2ee62$var$Ih(a, b.containerInfo);
}
function $4705b8143ca2ee62$var$mj(a, b, c, d, e) {
    $4705b8143ca2ee62$var$Ig();
    $4705b8143ca2ee62$var$Jg(e);
    b.flags |= 256;
    $4705b8143ca2ee62$var$Yi(a, b, c, d);
    return b.child;
}
var $4705b8143ca2ee62$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $4705b8143ca2ee62$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $4705b8143ca2ee62$var$pj(a, b, c) {
    var d = b.pendingProps, e = $4705b8143ca2ee62$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $4705b8143ca2ee62$var$G($4705b8143ca2ee62$var$M, e & 1);
    if (null === a) {
        $4705b8143ca2ee62$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $4705b8143ca2ee62$var$qj(g, d, 0, null), a = $4705b8143ca2ee62$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $4705b8143ca2ee62$var$oj(c), b.memoizedState = $4705b8143ca2ee62$var$nj, a) : $4705b8143ca2ee62$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $4705b8143ca2ee62$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $4705b8143ca2ee62$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $4705b8143ca2ee62$var$wh(h, f) : (f = $4705b8143ca2ee62$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $4705b8143ca2ee62$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $4705b8143ca2ee62$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $4705b8143ca2ee62$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $4705b8143ca2ee62$var$rj(a, b) {
    b = $4705b8143ca2ee62$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $4705b8143ca2ee62$var$tj(a, b, c, d) {
    null !== d && $4705b8143ca2ee62$var$Jg(d);
    $4705b8143ca2ee62$var$Bh(b, a.child, null, c);
    a = $4705b8143ca2ee62$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $4705b8143ca2ee62$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $4705b8143ca2ee62$var$Li(Error($4705b8143ca2ee62$var$p(422))), $4705b8143ca2ee62$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $4705b8143ca2ee62$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $4705b8143ca2ee62$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $4705b8143ca2ee62$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $4705b8143ca2ee62$var$oj(g);
        b.memoizedState = $4705b8143ca2ee62$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $4705b8143ca2ee62$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($4705b8143ca2ee62$var$p(419));
        d = $4705b8143ca2ee62$var$Li(f, d, void 0);
        return $4705b8143ca2ee62$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($4705b8143ca2ee62$var$Ug || h) {
        d = $4705b8143ca2ee62$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $4705b8143ca2ee62$var$Zg(a, e), $4705b8143ca2ee62$var$mh(d, a, e, -1));
        }
        $4705b8143ca2ee62$var$uj();
        d = $4705b8143ca2ee62$var$Li(Error($4705b8143ca2ee62$var$p(421)));
        return $4705b8143ca2ee62$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $4705b8143ca2ee62$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $4705b8143ca2ee62$var$yg = $4705b8143ca2ee62$var$Lf(e.nextSibling);
    $4705b8143ca2ee62$var$xg = b;
    $4705b8143ca2ee62$var$I = !0;
    $4705b8143ca2ee62$var$zg = null;
    null !== a && ($4705b8143ca2ee62$var$og[$4705b8143ca2ee62$var$pg++] = $4705b8143ca2ee62$var$rg, $4705b8143ca2ee62$var$og[$4705b8143ca2ee62$var$pg++] = $4705b8143ca2ee62$var$sg, $4705b8143ca2ee62$var$og[$4705b8143ca2ee62$var$pg++] = $4705b8143ca2ee62$var$qg, $4705b8143ca2ee62$var$rg = a.id, $4705b8143ca2ee62$var$sg = a.overflow, $4705b8143ca2ee62$var$qg = b);
    b = $4705b8143ca2ee62$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $4705b8143ca2ee62$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $4705b8143ca2ee62$var$Sg(a.return, b, c);
}
function $4705b8143ca2ee62$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $4705b8143ca2ee62$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $4705b8143ca2ee62$var$Yi(a, b, d.children, c);
    d = $4705b8143ca2ee62$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $4705b8143ca2ee62$var$wj(a, c, b);
            else if (19 === a.tag) $4705b8143ca2ee62$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $4705b8143ca2ee62$var$G($4705b8143ca2ee62$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $4705b8143ca2ee62$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $4705b8143ca2ee62$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $4705b8143ca2ee62$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $4705b8143ca2ee62$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $4705b8143ca2ee62$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $4705b8143ca2ee62$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $4705b8143ca2ee62$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $4705b8143ca2ee62$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($4705b8143ca2ee62$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $4705b8143ca2ee62$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $4705b8143ca2ee62$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $4705b8143ca2ee62$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $4705b8143ca2ee62$var$lj(b);
            $4705b8143ca2ee62$var$Ig();
            break;
        case 5:
            $4705b8143ca2ee62$var$Kh(b);
            break;
        case 1:
            $4705b8143ca2ee62$var$Zf(b.type) && $4705b8143ca2ee62$var$cg(b);
            break;
        case 4:
            $4705b8143ca2ee62$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $4705b8143ca2ee62$var$G($4705b8143ca2ee62$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $4705b8143ca2ee62$var$G($4705b8143ca2ee62$var$M, $4705b8143ca2ee62$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $4705b8143ca2ee62$var$pj(a, b, c);
                $4705b8143ca2ee62$var$G($4705b8143ca2ee62$var$M, $4705b8143ca2ee62$var$M.current & 1);
                a = $4705b8143ca2ee62$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $4705b8143ca2ee62$var$G($4705b8143ca2ee62$var$M, $4705b8143ca2ee62$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $4705b8143ca2ee62$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $4705b8143ca2ee62$var$G($4705b8143ca2ee62$var$M, $4705b8143ca2ee62$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $4705b8143ca2ee62$var$ej(a, b, c);
    }
    return $4705b8143ca2ee62$var$$i(a, b, c);
}
var $4705b8143ca2ee62$var$Aj, $4705b8143ca2ee62$var$Bj, $4705b8143ca2ee62$var$Cj, $4705b8143ca2ee62$var$Dj;
$4705b8143ca2ee62$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$4705b8143ca2ee62$var$Bj = function() {};
$4705b8143ca2ee62$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $4705b8143ca2ee62$var$Hh($4705b8143ca2ee62$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $4705b8143ca2ee62$var$Ya(a, e);
                d = $4705b8143ca2ee62$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $4705b8143ca2ee62$var$A({}, e, {
                    value: void 0
                });
                d = $4705b8143ca2ee62$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $4705b8143ca2ee62$var$gb(a, e);
                d = $4705b8143ca2ee62$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $4705b8143ca2ee62$var$Bf);
        }
        $4705b8143ca2ee62$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($4705b8143ca2ee62$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($4705b8143ca2ee62$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $4705b8143ca2ee62$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$4705b8143ca2ee62$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $4705b8143ca2ee62$var$Ej(a, b) {
    if (!$4705b8143ca2ee62$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $4705b8143ca2ee62$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $4705b8143ca2ee62$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $4705b8143ca2ee62$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $4705b8143ca2ee62$var$S(b), null;
        case 1:
            return $4705b8143ca2ee62$var$Zf(b.type) && $4705b8143ca2ee62$var$$f(), $4705b8143ca2ee62$var$S(b), null;
        case 3:
            d = b.stateNode;
            $4705b8143ca2ee62$var$Jh();
            $4705b8143ca2ee62$var$E($4705b8143ca2ee62$var$Wf);
            $4705b8143ca2ee62$var$E($4705b8143ca2ee62$var$H);
            $4705b8143ca2ee62$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $4705b8143ca2ee62$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $4705b8143ca2ee62$var$zg && ($4705b8143ca2ee62$var$Gj($4705b8143ca2ee62$var$zg), $4705b8143ca2ee62$var$zg = null));
            $4705b8143ca2ee62$var$Bj(a, b);
            $4705b8143ca2ee62$var$S(b);
            return null;
        case 5:
            $4705b8143ca2ee62$var$Lh(b);
            var e = $4705b8143ca2ee62$var$Hh($4705b8143ca2ee62$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $4705b8143ca2ee62$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($4705b8143ca2ee62$var$p(166));
                    $4705b8143ca2ee62$var$S(b);
                    return null;
                }
                a = $4705b8143ca2ee62$var$Hh($4705b8143ca2ee62$var$Eh.current);
                if ($4705b8143ca2ee62$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$4705b8143ca2ee62$var$Of] = b;
                    d[$4705b8143ca2ee62$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $4705b8143ca2ee62$var$D("cancel", d);
                            $4705b8143ca2ee62$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $4705b8143ca2ee62$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $4705b8143ca2ee62$var$lf.length; e++)$4705b8143ca2ee62$var$D($4705b8143ca2ee62$var$lf[e], d);
                            break;
                        case "source":
                            $4705b8143ca2ee62$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $4705b8143ca2ee62$var$D("error", d);
                            $4705b8143ca2ee62$var$D("load", d);
                            break;
                        case "details":
                            $4705b8143ca2ee62$var$D("toggle", d);
                            break;
                        case "input":
                            $4705b8143ca2ee62$var$Za(d, f);
                            $4705b8143ca2ee62$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $4705b8143ca2ee62$var$D("invalid", d);
                            break;
                        case "textarea":
                            $4705b8143ca2ee62$var$hb(d, f), $4705b8143ca2ee62$var$D("invalid", d);
                    }
                    $4705b8143ca2ee62$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $4705b8143ca2ee62$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $4705b8143ca2ee62$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $4705b8143ca2ee62$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $4705b8143ca2ee62$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $4705b8143ca2ee62$var$Va(d);
                            $4705b8143ca2ee62$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $4705b8143ca2ee62$var$Va(d);
                            $4705b8143ca2ee62$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $4705b8143ca2ee62$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $4705b8143ca2ee62$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$4705b8143ca2ee62$var$Of] = b;
                    a[$4705b8143ca2ee62$var$Pf] = d;
                    $4705b8143ca2ee62$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $4705b8143ca2ee62$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $4705b8143ca2ee62$var$D("cancel", a);
                                $4705b8143ca2ee62$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $4705b8143ca2ee62$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $4705b8143ca2ee62$var$lf.length; e++)$4705b8143ca2ee62$var$D($4705b8143ca2ee62$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $4705b8143ca2ee62$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $4705b8143ca2ee62$var$D("error", a);
                                $4705b8143ca2ee62$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $4705b8143ca2ee62$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $4705b8143ca2ee62$var$Za(a, d);
                                e = $4705b8143ca2ee62$var$Ya(a, d);
                                $4705b8143ca2ee62$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $4705b8143ca2ee62$var$A({}, d, {
                                    value: void 0
                                });
                                $4705b8143ca2ee62$var$D("invalid", a);
                                break;
                            case "textarea":
                                $4705b8143ca2ee62$var$hb(a, d);
                                e = $4705b8143ca2ee62$var$gb(a, d);
                                $4705b8143ca2ee62$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $4705b8143ca2ee62$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $4705b8143ca2ee62$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $4705b8143ca2ee62$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $4705b8143ca2ee62$var$ob(a, k) : "number" === typeof k && $4705b8143ca2ee62$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($4705b8143ca2ee62$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $4705b8143ca2ee62$var$D("scroll", a) : null != k && $4705b8143ca2ee62$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $4705b8143ca2ee62$var$Va(a);
                                $4705b8143ca2ee62$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $4705b8143ca2ee62$var$Va(a);
                                $4705b8143ca2ee62$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $4705b8143ca2ee62$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $4705b8143ca2ee62$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $4705b8143ca2ee62$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $4705b8143ca2ee62$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $4705b8143ca2ee62$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $4705b8143ca2ee62$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($4705b8143ca2ee62$var$p(166));
                c = $4705b8143ca2ee62$var$Hh($4705b8143ca2ee62$var$Gh.current);
                $4705b8143ca2ee62$var$Hh($4705b8143ca2ee62$var$Eh.current);
                if ($4705b8143ca2ee62$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$4705b8143ca2ee62$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $4705b8143ca2ee62$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $4705b8143ca2ee62$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $4705b8143ca2ee62$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$4705b8143ca2ee62$var$Of] = b, b.stateNode = d;
            }
            $4705b8143ca2ee62$var$S(b);
            return null;
        case 13:
            $4705b8143ca2ee62$var$E($4705b8143ca2ee62$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($4705b8143ca2ee62$var$I && null !== $4705b8143ca2ee62$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $4705b8143ca2ee62$var$Hg(), $4705b8143ca2ee62$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $4705b8143ca2ee62$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($4705b8143ca2ee62$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($4705b8143ca2ee62$var$p(317));
                        f[$4705b8143ca2ee62$var$Of] = b;
                    } else $4705b8143ca2ee62$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $4705b8143ca2ee62$var$S(b);
                    f = !1;
                } else null !== $4705b8143ca2ee62$var$zg && ($4705b8143ca2ee62$var$Gj($4705b8143ca2ee62$var$zg), $4705b8143ca2ee62$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($4705b8143ca2ee62$var$M.current & 1) ? 0 === $4705b8143ca2ee62$var$T && ($4705b8143ca2ee62$var$T = 3) : $4705b8143ca2ee62$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $4705b8143ca2ee62$var$S(b);
            return null;
        case 4:
            return $4705b8143ca2ee62$var$Jh(), $4705b8143ca2ee62$var$Bj(a, b), null === a && $4705b8143ca2ee62$var$sf(b.stateNode.containerInfo), $4705b8143ca2ee62$var$S(b), null;
        case 10:
            return $4705b8143ca2ee62$var$Rg(b.type._context), $4705b8143ca2ee62$var$S(b), null;
        case 17:
            return $4705b8143ca2ee62$var$Zf(b.type) && $4705b8143ca2ee62$var$$f(), $4705b8143ca2ee62$var$S(b), null;
        case 19:
            $4705b8143ca2ee62$var$E($4705b8143ca2ee62$var$M);
            f = b.memoizedState;
            if (null === f) return $4705b8143ca2ee62$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $4705b8143ca2ee62$var$Ej(f, !1);
                else {
                    if (0 !== $4705b8143ca2ee62$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $4705b8143ca2ee62$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $4705b8143ca2ee62$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $4705b8143ca2ee62$var$G($4705b8143ca2ee62$var$M, $4705b8143ca2ee62$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $4705b8143ca2ee62$var$B() > $4705b8143ca2ee62$var$Hj && (b.flags |= 128, d = !0, $4705b8143ca2ee62$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $4705b8143ca2ee62$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $4705b8143ca2ee62$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$4705b8143ca2ee62$var$I) return $4705b8143ca2ee62$var$S(b), null;
                    } else 2 * $4705b8143ca2ee62$var$B() - f.renderingStartTime > $4705b8143ca2ee62$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $4705b8143ca2ee62$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $4705b8143ca2ee62$var$B(), b.sibling = null, c = $4705b8143ca2ee62$var$M.current, $4705b8143ca2ee62$var$G($4705b8143ca2ee62$var$M, d ? c & 1 | 2 : c & 1), b;
            $4705b8143ca2ee62$var$S(b);
            return null;
        case 22:
        case 23:
            return $4705b8143ca2ee62$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($4705b8143ca2ee62$var$gj & 1073741824) && ($4705b8143ca2ee62$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $4705b8143ca2ee62$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($4705b8143ca2ee62$var$p(156, b.tag));
}
function $4705b8143ca2ee62$var$Jj(a, b) {
    $4705b8143ca2ee62$var$wg(b);
    switch(b.tag){
        case 1:
            return $4705b8143ca2ee62$var$Zf(b.type) && $4705b8143ca2ee62$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $4705b8143ca2ee62$var$Jh(), $4705b8143ca2ee62$var$E($4705b8143ca2ee62$var$Wf), $4705b8143ca2ee62$var$E($4705b8143ca2ee62$var$H), $4705b8143ca2ee62$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $4705b8143ca2ee62$var$Lh(b), null;
        case 13:
            $4705b8143ca2ee62$var$E($4705b8143ca2ee62$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($4705b8143ca2ee62$var$p(340));
                $4705b8143ca2ee62$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $4705b8143ca2ee62$var$E($4705b8143ca2ee62$var$M), null;
        case 4:
            return $4705b8143ca2ee62$var$Jh(), null;
        case 10:
            return $4705b8143ca2ee62$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $4705b8143ca2ee62$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $4705b8143ca2ee62$var$Kj = !1, $4705b8143ca2ee62$var$U = !1, $4705b8143ca2ee62$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $4705b8143ca2ee62$var$V = null;
function $4705b8143ca2ee62$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $4705b8143ca2ee62$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $4705b8143ca2ee62$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $4705b8143ca2ee62$var$W(a, b, d);
    }
}
var $4705b8143ca2ee62$var$Oj = !1;
function $4705b8143ca2ee62$var$Pj(a, b) {
    $4705b8143ca2ee62$var$Cf = $4705b8143ca2ee62$var$dd;
    a = $4705b8143ca2ee62$var$Me();
    if ($4705b8143ca2ee62$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $4705b8143ca2ee62$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $4705b8143ca2ee62$var$dd = !1;
    for($4705b8143ca2ee62$var$V = b; null !== $4705b8143ca2ee62$var$V;)if (b = $4705b8143ca2ee62$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $4705b8143ca2ee62$var$V = a;
    else for(; null !== $4705b8143ca2ee62$var$V;){
        b = $4705b8143ca2ee62$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $4705b8143ca2ee62$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($4705b8143ca2ee62$var$p(163));
            }
        } catch (F) {
            $4705b8143ca2ee62$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $4705b8143ca2ee62$var$V = a;
            break;
        }
        $4705b8143ca2ee62$var$V = b.return;
    }
    n = $4705b8143ca2ee62$var$Oj;
    $4705b8143ca2ee62$var$Oj = !1;
    return n;
}
function $4705b8143ca2ee62$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $4705b8143ca2ee62$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $4705b8143ca2ee62$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $4705b8143ca2ee62$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $4705b8143ca2ee62$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $4705b8143ca2ee62$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$4705b8143ca2ee62$var$Of], delete b[$4705b8143ca2ee62$var$Pf], delete b[$4705b8143ca2ee62$var$of], delete b[$4705b8143ca2ee62$var$Qf], delete b[$4705b8143ca2ee62$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $4705b8143ca2ee62$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $4705b8143ca2ee62$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $4705b8143ca2ee62$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $4705b8143ca2ee62$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $4705b8143ca2ee62$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($4705b8143ca2ee62$var$Wj(a, b, c), a = a.sibling; null !== a;)$4705b8143ca2ee62$var$Wj(a, b, c), a = a.sibling;
}
function $4705b8143ca2ee62$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($4705b8143ca2ee62$var$Xj(a, b, c), a = a.sibling; null !== a;)$4705b8143ca2ee62$var$Xj(a, b, c), a = a.sibling;
}
var $4705b8143ca2ee62$var$X = null, $4705b8143ca2ee62$var$Yj = !1;
function $4705b8143ca2ee62$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$4705b8143ca2ee62$var$ak(a, b, c), c = c.sibling;
}
function $4705b8143ca2ee62$var$ak(a, b, c) {
    if ($4705b8143ca2ee62$var$lc && "function" === typeof $4705b8143ca2ee62$var$lc.onCommitFiberUnmount) try {
        $4705b8143ca2ee62$var$lc.onCommitFiberUnmount($4705b8143ca2ee62$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $4705b8143ca2ee62$var$U || $4705b8143ca2ee62$var$Mj(c, b);
        case 6:
            var d = $4705b8143ca2ee62$var$X, e = $4705b8143ca2ee62$var$Yj;
            $4705b8143ca2ee62$var$X = null;
            $4705b8143ca2ee62$var$Zj(a, b, c);
            $4705b8143ca2ee62$var$X = d;
            $4705b8143ca2ee62$var$Yj = e;
            null !== $4705b8143ca2ee62$var$X && ($4705b8143ca2ee62$var$Yj ? (a = $4705b8143ca2ee62$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $4705b8143ca2ee62$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $4705b8143ca2ee62$var$X && ($4705b8143ca2ee62$var$Yj ? (a = $4705b8143ca2ee62$var$X, c = c.stateNode, 8 === a.nodeType ? $4705b8143ca2ee62$var$Kf(a.parentNode, c) : 1 === a.nodeType && $4705b8143ca2ee62$var$Kf(a, c), $4705b8143ca2ee62$var$bd(a)) : $4705b8143ca2ee62$var$Kf($4705b8143ca2ee62$var$X, c.stateNode));
            break;
        case 4:
            d = $4705b8143ca2ee62$var$X;
            e = $4705b8143ca2ee62$var$Yj;
            $4705b8143ca2ee62$var$X = c.stateNode.containerInfo;
            $4705b8143ca2ee62$var$Yj = !0;
            $4705b8143ca2ee62$var$Zj(a, b, c);
            $4705b8143ca2ee62$var$X = d;
            $4705b8143ca2ee62$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$4705b8143ca2ee62$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $4705b8143ca2ee62$var$Nj(c, b, g) : 0 !== (f & 4) && $4705b8143ca2ee62$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $4705b8143ca2ee62$var$Zj(a, b, c);
            break;
        case 1:
            if (!$4705b8143ca2ee62$var$U && ($4705b8143ca2ee62$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $4705b8143ca2ee62$var$W(c, b, h);
            }
            $4705b8143ca2ee62$var$Zj(a, b, c);
            break;
        case 21:
            $4705b8143ca2ee62$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($4705b8143ca2ee62$var$U = (d = $4705b8143ca2ee62$var$U) || null !== c.memoizedState, $4705b8143ca2ee62$var$Zj(a, b, c), $4705b8143ca2ee62$var$U = d) : $4705b8143ca2ee62$var$Zj(a, b, c);
            break;
        default:
            $4705b8143ca2ee62$var$Zj(a, b, c);
    }
}
function $4705b8143ca2ee62$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $4705b8143ca2ee62$var$Lj);
        b.forEach(function(b) {
            var d = $4705b8143ca2ee62$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $4705b8143ca2ee62$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $4705b8143ca2ee62$var$X = h.stateNode;
                        $4705b8143ca2ee62$var$Yj = !1;
                        break a;
                    case 3:
                        $4705b8143ca2ee62$var$X = h.stateNode.containerInfo;
                        $4705b8143ca2ee62$var$Yj = !0;
                        break a;
                    case 4:
                        $4705b8143ca2ee62$var$X = h.stateNode.containerInfo;
                        $4705b8143ca2ee62$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $4705b8143ca2ee62$var$X) throw Error($4705b8143ca2ee62$var$p(160));
            $4705b8143ca2ee62$var$ak(f, g, e);
            $4705b8143ca2ee62$var$X = null;
            $4705b8143ca2ee62$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $4705b8143ca2ee62$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$4705b8143ca2ee62$var$ek(b, a), b = b.sibling;
}
function $4705b8143ca2ee62$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $4705b8143ca2ee62$var$dk(b, a);
            $4705b8143ca2ee62$var$fk(a);
            if (d & 4) {
                try {
                    $4705b8143ca2ee62$var$Qj(3, a, a.return), $4705b8143ca2ee62$var$Rj(3, a);
                } catch (t) {
                    $4705b8143ca2ee62$var$W(a, a.return, t);
                }
                try {
                    $4705b8143ca2ee62$var$Qj(5, a, a.return);
                } catch (t) {
                    $4705b8143ca2ee62$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $4705b8143ca2ee62$var$dk(b, a);
            $4705b8143ca2ee62$var$fk(a);
            d & 512 && null !== c && $4705b8143ca2ee62$var$Mj(c, c.return);
            break;
        case 5:
            $4705b8143ca2ee62$var$dk(b, a);
            $4705b8143ca2ee62$var$fk(a);
            d & 512 && null !== c && $4705b8143ca2ee62$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $4705b8143ca2ee62$var$ob(e, "");
                } catch (t) {
                    $4705b8143ca2ee62$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $4705b8143ca2ee62$var$ab(e, f);
                    $4705b8143ca2ee62$var$vb(h, g);
                    var l = $4705b8143ca2ee62$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $4705b8143ca2ee62$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $4705b8143ca2ee62$var$nb(e, q) : "children" === m ? $4705b8143ca2ee62$var$ob(e, q) : $4705b8143ca2ee62$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $4705b8143ca2ee62$var$bb(e, f);
                            break;
                        case "textarea":
                            $4705b8143ca2ee62$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $4705b8143ca2ee62$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $4705b8143ca2ee62$var$fb(e, !!f.multiple, f.defaultValue, !0) : $4705b8143ca2ee62$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$4705b8143ca2ee62$var$Pf] = f;
                } catch (t) {
                    $4705b8143ca2ee62$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $4705b8143ca2ee62$var$dk(b, a);
            $4705b8143ca2ee62$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($4705b8143ca2ee62$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $4705b8143ca2ee62$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $4705b8143ca2ee62$var$dk(b, a);
            $4705b8143ca2ee62$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $4705b8143ca2ee62$var$bd(b.containerInfo);
            } catch (t) {
                $4705b8143ca2ee62$var$W(a, a.return, t);
            }
            break;
        case 4:
            $4705b8143ca2ee62$var$dk(b, a);
            $4705b8143ca2ee62$var$fk(a);
            break;
        case 13:
            $4705b8143ca2ee62$var$dk(b, a);
            $4705b8143ca2ee62$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($4705b8143ca2ee62$var$gk = $4705b8143ca2ee62$var$B()));
            d & 4 && $4705b8143ca2ee62$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($4705b8143ca2ee62$var$U = (l = $4705b8143ca2ee62$var$U) || m, $4705b8143ca2ee62$var$dk(b, a), $4705b8143ca2ee62$var$U = l) : $4705b8143ca2ee62$var$dk(b, a);
            $4705b8143ca2ee62$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($4705b8143ca2ee62$var$V = a, m = a.child; null !== m;){
                    for(q = $4705b8143ca2ee62$var$V = m; null !== $4705b8143ca2ee62$var$V;){
                        r = $4705b8143ca2ee62$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $4705b8143ca2ee62$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $4705b8143ca2ee62$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $4705b8143ca2ee62$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $4705b8143ca2ee62$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $4705b8143ca2ee62$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $4705b8143ca2ee62$var$V = y) : $4705b8143ca2ee62$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $4705b8143ca2ee62$var$rb("display", g));
                            } catch (t) {
                                $4705b8143ca2ee62$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $4705b8143ca2ee62$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $4705b8143ca2ee62$var$dk(b, a);
            $4705b8143ca2ee62$var$fk(a);
            d & 4 && $4705b8143ca2ee62$var$bk(a);
            break;
        case 21:
            break;
        default:
            $4705b8143ca2ee62$var$dk(b, a), $4705b8143ca2ee62$var$fk(a);
    }
}
function $4705b8143ca2ee62$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($4705b8143ca2ee62$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($4705b8143ca2ee62$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($4705b8143ca2ee62$var$ob(e, ""), d.flags &= -33);
                    var f = $4705b8143ca2ee62$var$Vj(a);
                    $4705b8143ca2ee62$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $4705b8143ca2ee62$var$Vj(a);
                    $4705b8143ca2ee62$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($4705b8143ca2ee62$var$p(161));
            }
        } catch (k) {
            $4705b8143ca2ee62$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $4705b8143ca2ee62$var$ik(a, b, c) {
    $4705b8143ca2ee62$var$V = a;
    $4705b8143ca2ee62$var$jk(a, b, c);
}
function $4705b8143ca2ee62$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $4705b8143ca2ee62$var$V;){
        var e = $4705b8143ca2ee62$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $4705b8143ca2ee62$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $4705b8143ca2ee62$var$U;
                h = $4705b8143ca2ee62$var$Kj;
                var l = $4705b8143ca2ee62$var$U;
                $4705b8143ca2ee62$var$Kj = g;
                if (($4705b8143ca2ee62$var$U = k) && !l) for($4705b8143ca2ee62$var$V = e; null !== $4705b8143ca2ee62$var$V;)g = $4705b8143ca2ee62$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $4705b8143ca2ee62$var$kk(e) : null !== k ? (k.return = g, $4705b8143ca2ee62$var$V = k) : $4705b8143ca2ee62$var$kk(e);
                for(; null !== f;)$4705b8143ca2ee62$var$V = f, $4705b8143ca2ee62$var$jk(f, b, c), f = f.sibling;
                $4705b8143ca2ee62$var$V = e;
                $4705b8143ca2ee62$var$Kj = h;
                $4705b8143ca2ee62$var$U = l;
            }
            $4705b8143ca2ee62$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $4705b8143ca2ee62$var$V = f) : $4705b8143ca2ee62$var$lk(a, b, c);
    }
}
function $4705b8143ca2ee62$var$lk(a) {
    for(; null !== $4705b8143ca2ee62$var$V;){
        var b = $4705b8143ca2ee62$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $4705b8143ca2ee62$var$U || $4705b8143ca2ee62$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$4705b8143ca2ee62$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $4705b8143ca2ee62$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $4705b8143ca2ee62$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $4705b8143ca2ee62$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $4705b8143ca2ee62$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($4705b8143ca2ee62$var$p(163));
                }
                $4705b8143ca2ee62$var$U || b.flags & 512 && $4705b8143ca2ee62$var$Sj(b);
            } catch (r) {
                $4705b8143ca2ee62$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $4705b8143ca2ee62$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $4705b8143ca2ee62$var$V = c;
            break;
        }
        $4705b8143ca2ee62$var$V = b.return;
    }
}
function $4705b8143ca2ee62$var$hk(a) {
    for(; null !== $4705b8143ca2ee62$var$V;){
        var b = $4705b8143ca2ee62$var$V;
        if (b === a) {
            $4705b8143ca2ee62$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $4705b8143ca2ee62$var$V = c;
            break;
        }
        $4705b8143ca2ee62$var$V = b.return;
    }
}
function $4705b8143ca2ee62$var$kk(a) {
    for(; null !== $4705b8143ca2ee62$var$V;){
        var b = $4705b8143ca2ee62$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $4705b8143ca2ee62$var$Rj(4, b);
                    } catch (k) {
                        $4705b8143ca2ee62$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $4705b8143ca2ee62$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $4705b8143ca2ee62$var$Sj(b);
                    } catch (k) {
                        $4705b8143ca2ee62$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $4705b8143ca2ee62$var$Sj(b);
                    } catch (k) {
                        $4705b8143ca2ee62$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $4705b8143ca2ee62$var$W(b, b.return, k);
        }
        if (b === a) {
            $4705b8143ca2ee62$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $4705b8143ca2ee62$var$V = h;
            break;
        }
        $4705b8143ca2ee62$var$V = b.return;
    }
}
var $4705b8143ca2ee62$var$mk = Math.ceil, $4705b8143ca2ee62$var$nk = $4705b8143ca2ee62$var$ua.ReactCurrentDispatcher, $4705b8143ca2ee62$var$ok = $4705b8143ca2ee62$var$ua.ReactCurrentOwner, $4705b8143ca2ee62$var$pk = $4705b8143ca2ee62$var$ua.ReactCurrentBatchConfig, $4705b8143ca2ee62$var$K = 0, $4705b8143ca2ee62$var$R = null, $4705b8143ca2ee62$var$Y = null, $4705b8143ca2ee62$var$Z = 0, $4705b8143ca2ee62$var$gj = 0, $4705b8143ca2ee62$var$fj = $4705b8143ca2ee62$var$Uf(0), $4705b8143ca2ee62$var$T = 0, $4705b8143ca2ee62$var$qk = null, $4705b8143ca2ee62$var$hh = 0, $4705b8143ca2ee62$var$rk = 0, $4705b8143ca2ee62$var$sk = 0, $4705b8143ca2ee62$var$tk = null, $4705b8143ca2ee62$var$uk = null, $4705b8143ca2ee62$var$gk = 0, $4705b8143ca2ee62$var$Hj = Infinity, $4705b8143ca2ee62$var$vk = null, $4705b8143ca2ee62$var$Pi = !1, $4705b8143ca2ee62$var$Qi = null, $4705b8143ca2ee62$var$Si = null, $4705b8143ca2ee62$var$wk = !1, $4705b8143ca2ee62$var$xk = null, $4705b8143ca2ee62$var$yk = 0, $4705b8143ca2ee62$var$zk = 0, $4705b8143ca2ee62$var$Ak = null, $4705b8143ca2ee62$var$Bk = -1, $4705b8143ca2ee62$var$Ck = 0;
function $4705b8143ca2ee62$var$L() {
    return 0 !== ($4705b8143ca2ee62$var$K & 6) ? $4705b8143ca2ee62$var$B() : -1 !== $4705b8143ca2ee62$var$Bk ? $4705b8143ca2ee62$var$Bk : $4705b8143ca2ee62$var$Bk = $4705b8143ca2ee62$var$B();
}
function $4705b8143ca2ee62$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($4705b8143ca2ee62$var$K & 2) && 0 !== $4705b8143ca2ee62$var$Z) return $4705b8143ca2ee62$var$Z & -$4705b8143ca2ee62$var$Z;
    if (null !== $4705b8143ca2ee62$var$Kg.transition) return 0 === $4705b8143ca2ee62$var$Ck && ($4705b8143ca2ee62$var$Ck = $4705b8143ca2ee62$var$yc()), $4705b8143ca2ee62$var$Ck;
    a = $4705b8143ca2ee62$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $4705b8143ca2ee62$var$jd(a.type);
    return a;
}
function $4705b8143ca2ee62$var$mh(a, b, c, d) {
    if (50 < $4705b8143ca2ee62$var$zk) throw $4705b8143ca2ee62$var$zk = 0, $4705b8143ca2ee62$var$Ak = null, Error($4705b8143ca2ee62$var$p(185));
    $4705b8143ca2ee62$var$Ac(a, c, d);
    if (0 === ($4705b8143ca2ee62$var$K & 2) || a !== $4705b8143ca2ee62$var$R) a === $4705b8143ca2ee62$var$R && (0 === ($4705b8143ca2ee62$var$K & 2) && ($4705b8143ca2ee62$var$rk |= c), 4 === $4705b8143ca2ee62$var$T && $4705b8143ca2ee62$var$Dk(a, $4705b8143ca2ee62$var$Z)), $4705b8143ca2ee62$var$Ek(a, d), 1 === c && 0 === $4705b8143ca2ee62$var$K && 0 === (b.mode & 1) && ($4705b8143ca2ee62$var$Hj = $4705b8143ca2ee62$var$B() + 500, $4705b8143ca2ee62$var$fg && $4705b8143ca2ee62$var$jg());
}
function $4705b8143ca2ee62$var$Ek(a, b) {
    var c = a.callbackNode;
    $4705b8143ca2ee62$var$wc(a, b);
    var d = $4705b8143ca2ee62$var$uc(a, a === $4705b8143ca2ee62$var$R ? $4705b8143ca2ee62$var$Z : 0);
    if (0 === d) null !== c && $4705b8143ca2ee62$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $4705b8143ca2ee62$var$bc(c);
        if (1 === b) 0 === a.tag ? $4705b8143ca2ee62$var$ig($4705b8143ca2ee62$var$Fk.bind(null, a)) : $4705b8143ca2ee62$var$hg($4705b8143ca2ee62$var$Fk.bind(null, a)), $4705b8143ca2ee62$var$Jf(function() {
            0 === ($4705b8143ca2ee62$var$K & 6) && $4705b8143ca2ee62$var$jg();
        }), c = null;
        else {
            switch($4705b8143ca2ee62$var$Dc(d)){
                case 1:
                    c = $4705b8143ca2ee62$var$fc;
                    break;
                case 4:
                    c = $4705b8143ca2ee62$var$gc;
                    break;
                case 16:
                    c = $4705b8143ca2ee62$var$hc;
                    break;
                case 536870912:
                    c = $4705b8143ca2ee62$var$jc;
                    break;
                default:
                    c = $4705b8143ca2ee62$var$hc;
            }
            c = $4705b8143ca2ee62$var$Gk(c, $4705b8143ca2ee62$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $4705b8143ca2ee62$var$Hk(a, b) {
    $4705b8143ca2ee62$var$Bk = -1;
    $4705b8143ca2ee62$var$Ck = 0;
    if (0 !== ($4705b8143ca2ee62$var$K & 6)) throw Error($4705b8143ca2ee62$var$p(327));
    var c = a.callbackNode;
    if ($4705b8143ca2ee62$var$Ik() && a.callbackNode !== c) return null;
    var d = $4705b8143ca2ee62$var$uc(a, a === $4705b8143ca2ee62$var$R ? $4705b8143ca2ee62$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $4705b8143ca2ee62$var$Jk(a, d);
    else {
        b = d;
        var e = $4705b8143ca2ee62$var$K;
        $4705b8143ca2ee62$var$K |= 2;
        var f = $4705b8143ca2ee62$var$Kk();
        if ($4705b8143ca2ee62$var$R !== a || $4705b8143ca2ee62$var$Z !== b) $4705b8143ca2ee62$var$vk = null, $4705b8143ca2ee62$var$Hj = $4705b8143ca2ee62$var$B() + 500, $4705b8143ca2ee62$var$Lk(a, b);
        for(;;)try {
            $4705b8143ca2ee62$var$Mk();
            break;
        } catch (h) {
            $4705b8143ca2ee62$var$Nk(a, h);
        }
        $4705b8143ca2ee62$var$Qg();
        $4705b8143ca2ee62$var$nk.current = f;
        $4705b8143ca2ee62$var$K = e;
        null !== $4705b8143ca2ee62$var$Y ? b = 0 : ($4705b8143ca2ee62$var$R = null, $4705b8143ca2ee62$var$Z = 0, b = $4705b8143ca2ee62$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $4705b8143ca2ee62$var$xc(a), 0 !== e && (d = e, b = $4705b8143ca2ee62$var$Ok(a, e)));
        if (1 === b) throw c = $4705b8143ca2ee62$var$qk, $4705b8143ca2ee62$var$Lk(a, 0), $4705b8143ca2ee62$var$Dk(a, d), $4705b8143ca2ee62$var$Ek(a, $4705b8143ca2ee62$var$B()), c;
        if (6 === b) $4705b8143ca2ee62$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$4705b8143ca2ee62$var$Pk(e) && (b = $4705b8143ca2ee62$var$Jk(a, d), 2 === b && (f = $4705b8143ca2ee62$var$xc(a), 0 !== f && (d = f, b = $4705b8143ca2ee62$var$Ok(a, f))), 1 === b)) throw c = $4705b8143ca2ee62$var$qk, $4705b8143ca2ee62$var$Lk(a, 0), $4705b8143ca2ee62$var$Dk(a, d), $4705b8143ca2ee62$var$Ek(a, $4705b8143ca2ee62$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($4705b8143ca2ee62$var$p(345));
                case 2:
                    $4705b8143ca2ee62$var$Qk(a, $4705b8143ca2ee62$var$uk, $4705b8143ca2ee62$var$vk);
                    break;
                case 3:
                    $4705b8143ca2ee62$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $4705b8143ca2ee62$var$gk + 500 - $4705b8143ca2ee62$var$B(), 10 < b)) {
                        if (0 !== $4705b8143ca2ee62$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $4705b8143ca2ee62$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $4705b8143ca2ee62$var$Ff($4705b8143ca2ee62$var$Qk.bind(null, a, $4705b8143ca2ee62$var$uk, $4705b8143ca2ee62$var$vk), b);
                        break;
                    }
                    $4705b8143ca2ee62$var$Qk(a, $4705b8143ca2ee62$var$uk, $4705b8143ca2ee62$var$vk);
                    break;
                case 4:
                    $4705b8143ca2ee62$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $4705b8143ca2ee62$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $4705b8143ca2ee62$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $4705b8143ca2ee62$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $4705b8143ca2ee62$var$Ff($4705b8143ca2ee62$var$Qk.bind(null, a, $4705b8143ca2ee62$var$uk, $4705b8143ca2ee62$var$vk), d);
                        break;
                    }
                    $4705b8143ca2ee62$var$Qk(a, $4705b8143ca2ee62$var$uk, $4705b8143ca2ee62$var$vk);
                    break;
                case 5:
                    $4705b8143ca2ee62$var$Qk(a, $4705b8143ca2ee62$var$uk, $4705b8143ca2ee62$var$vk);
                    break;
                default:
                    throw Error($4705b8143ca2ee62$var$p(329));
            }
        }
    }
    $4705b8143ca2ee62$var$Ek(a, $4705b8143ca2ee62$var$B());
    return a.callbackNode === c ? $4705b8143ca2ee62$var$Hk.bind(null, a) : null;
}
function $4705b8143ca2ee62$var$Ok(a, b) {
    var c = $4705b8143ca2ee62$var$tk;
    a.current.memoizedState.isDehydrated && ($4705b8143ca2ee62$var$Lk(a, b).flags |= 256);
    a = $4705b8143ca2ee62$var$Jk(a, b);
    2 !== a && (b = $4705b8143ca2ee62$var$uk, $4705b8143ca2ee62$var$uk = c, null !== b && $4705b8143ca2ee62$var$Gj(b));
    return a;
}
function $4705b8143ca2ee62$var$Gj(a) {
    null === $4705b8143ca2ee62$var$uk ? $4705b8143ca2ee62$var$uk = a : $4705b8143ca2ee62$var$uk.push.apply($4705b8143ca2ee62$var$uk, a);
}
function $4705b8143ca2ee62$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$4705b8143ca2ee62$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $4705b8143ca2ee62$var$Dk(a, b) {
    b &= ~$4705b8143ca2ee62$var$sk;
    b &= ~$4705b8143ca2ee62$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $4705b8143ca2ee62$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $4705b8143ca2ee62$var$Fk(a) {
    if (0 !== ($4705b8143ca2ee62$var$K & 6)) throw Error($4705b8143ca2ee62$var$p(327));
    $4705b8143ca2ee62$var$Ik();
    var b = $4705b8143ca2ee62$var$uc(a, 0);
    if (0 === (b & 1)) return $4705b8143ca2ee62$var$Ek(a, $4705b8143ca2ee62$var$B()), null;
    var c = $4705b8143ca2ee62$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $4705b8143ca2ee62$var$xc(a);
        0 !== d && (b = d, c = $4705b8143ca2ee62$var$Ok(a, d));
    }
    if (1 === c) throw c = $4705b8143ca2ee62$var$qk, $4705b8143ca2ee62$var$Lk(a, 0), $4705b8143ca2ee62$var$Dk(a, b), $4705b8143ca2ee62$var$Ek(a, $4705b8143ca2ee62$var$B()), c;
    if (6 === c) throw Error($4705b8143ca2ee62$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $4705b8143ca2ee62$var$Qk(a, $4705b8143ca2ee62$var$uk, $4705b8143ca2ee62$var$vk);
    $4705b8143ca2ee62$var$Ek(a, $4705b8143ca2ee62$var$B());
    return null;
}
function $4705b8143ca2ee62$var$Rk(a, b) {
    var c = $4705b8143ca2ee62$var$K;
    $4705b8143ca2ee62$var$K |= 1;
    try {
        return a(b);
    } finally{
        $4705b8143ca2ee62$var$K = c, 0 === $4705b8143ca2ee62$var$K && ($4705b8143ca2ee62$var$Hj = $4705b8143ca2ee62$var$B() + 500, $4705b8143ca2ee62$var$fg && $4705b8143ca2ee62$var$jg());
    }
}
function $4705b8143ca2ee62$var$Sk(a) {
    null !== $4705b8143ca2ee62$var$xk && 0 === $4705b8143ca2ee62$var$xk.tag && 0 === ($4705b8143ca2ee62$var$K & 6) && $4705b8143ca2ee62$var$Ik();
    var b = $4705b8143ca2ee62$var$K;
    $4705b8143ca2ee62$var$K |= 1;
    var c = $4705b8143ca2ee62$var$pk.transition, d = $4705b8143ca2ee62$var$C;
    try {
        if ($4705b8143ca2ee62$var$pk.transition = null, $4705b8143ca2ee62$var$C = 1, a) return a();
    } finally{
        $4705b8143ca2ee62$var$C = d, $4705b8143ca2ee62$var$pk.transition = c, $4705b8143ca2ee62$var$K = b, 0 === ($4705b8143ca2ee62$var$K & 6) && $4705b8143ca2ee62$var$jg();
    }
}
function $4705b8143ca2ee62$var$Ij() {
    $4705b8143ca2ee62$var$gj = $4705b8143ca2ee62$var$fj.current;
    $4705b8143ca2ee62$var$E($4705b8143ca2ee62$var$fj);
}
function $4705b8143ca2ee62$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $4705b8143ca2ee62$var$Gf(c));
    if (null !== $4705b8143ca2ee62$var$Y) for(c = $4705b8143ca2ee62$var$Y.return; null !== c;){
        var d = c;
        $4705b8143ca2ee62$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $4705b8143ca2ee62$var$$f();
                break;
            case 3:
                $4705b8143ca2ee62$var$Jh();
                $4705b8143ca2ee62$var$E($4705b8143ca2ee62$var$Wf);
                $4705b8143ca2ee62$var$E($4705b8143ca2ee62$var$H);
                $4705b8143ca2ee62$var$Oh();
                break;
            case 5:
                $4705b8143ca2ee62$var$Lh(d);
                break;
            case 4:
                $4705b8143ca2ee62$var$Jh();
                break;
            case 13:
                $4705b8143ca2ee62$var$E($4705b8143ca2ee62$var$M);
                break;
            case 19:
                $4705b8143ca2ee62$var$E($4705b8143ca2ee62$var$M);
                break;
            case 10:
                $4705b8143ca2ee62$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $4705b8143ca2ee62$var$Ij();
        }
        c = c.return;
    }
    $4705b8143ca2ee62$var$R = a;
    $4705b8143ca2ee62$var$Y = a = $4705b8143ca2ee62$var$wh(a.current, null);
    $4705b8143ca2ee62$var$Z = $4705b8143ca2ee62$var$gj = b;
    $4705b8143ca2ee62$var$T = 0;
    $4705b8143ca2ee62$var$qk = null;
    $4705b8143ca2ee62$var$sk = $4705b8143ca2ee62$var$rk = $4705b8143ca2ee62$var$hh = 0;
    $4705b8143ca2ee62$var$uk = $4705b8143ca2ee62$var$tk = null;
    if (null !== $4705b8143ca2ee62$var$Wg) {
        for(b = 0; b < $4705b8143ca2ee62$var$Wg.length; b++)if (c = $4705b8143ca2ee62$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $4705b8143ca2ee62$var$Wg = null;
    }
    return a;
}
function $4705b8143ca2ee62$var$Nk(a, b) {
    do {
        var c = $4705b8143ca2ee62$var$Y;
        try {
            $4705b8143ca2ee62$var$Qg();
            $4705b8143ca2ee62$var$Ph.current = $4705b8143ca2ee62$var$ai;
            if ($4705b8143ca2ee62$var$Sh) {
                for(var d = $4705b8143ca2ee62$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $4705b8143ca2ee62$var$Sh = !1;
            }
            $4705b8143ca2ee62$var$Rh = 0;
            $4705b8143ca2ee62$var$P = $4705b8143ca2ee62$var$O = $4705b8143ca2ee62$var$N = null;
            $4705b8143ca2ee62$var$Th = !1;
            $4705b8143ca2ee62$var$Uh = 0;
            $4705b8143ca2ee62$var$ok.current = null;
            if (null === c || null === c.return) {
                $4705b8143ca2ee62$var$T = 1;
                $4705b8143ca2ee62$var$qk = b;
                $4705b8143ca2ee62$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $4705b8143ca2ee62$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $4705b8143ca2ee62$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $4705b8143ca2ee62$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $4705b8143ca2ee62$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $4705b8143ca2ee62$var$Ti(f, l, b);
                            $4705b8143ca2ee62$var$uj();
                            break a;
                        }
                        k = Error($4705b8143ca2ee62$var$p(426));
                    }
                } else if ($4705b8143ca2ee62$var$I && h.mode & 1) {
                    var J = $4705b8143ca2ee62$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $4705b8143ca2ee62$var$Wi(J, g, h, f, b);
                        $4705b8143ca2ee62$var$Jg($4705b8143ca2ee62$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $4705b8143ca2ee62$var$Ki(k, h);
                4 !== $4705b8143ca2ee62$var$T && ($4705b8143ca2ee62$var$T = 2);
                null === $4705b8143ca2ee62$var$tk ? $4705b8143ca2ee62$var$tk = [
                    f
                ] : $4705b8143ca2ee62$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $4705b8143ca2ee62$var$Oi(f, k, b);
                            $4705b8143ca2ee62$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $4705b8143ca2ee62$var$Si || !$4705b8143ca2ee62$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $4705b8143ca2ee62$var$Ri(f, h, b);
                                $4705b8143ca2ee62$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $4705b8143ca2ee62$var$Tk(c);
        } catch (na) {
            b = na;
            $4705b8143ca2ee62$var$Y === c && null !== c && ($4705b8143ca2ee62$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $4705b8143ca2ee62$var$Kk() {
    var a = $4705b8143ca2ee62$var$nk.current;
    $4705b8143ca2ee62$var$nk.current = $4705b8143ca2ee62$var$ai;
    return null === a ? $4705b8143ca2ee62$var$ai : a;
}
function $4705b8143ca2ee62$var$uj() {
    if (0 === $4705b8143ca2ee62$var$T || 3 === $4705b8143ca2ee62$var$T || 2 === $4705b8143ca2ee62$var$T) $4705b8143ca2ee62$var$T = 4;
    null === $4705b8143ca2ee62$var$R || 0 === ($4705b8143ca2ee62$var$hh & 268435455) && 0 === ($4705b8143ca2ee62$var$rk & 268435455) || $4705b8143ca2ee62$var$Dk($4705b8143ca2ee62$var$R, $4705b8143ca2ee62$var$Z);
}
function $4705b8143ca2ee62$var$Jk(a, b) {
    var c = $4705b8143ca2ee62$var$K;
    $4705b8143ca2ee62$var$K |= 2;
    var d = $4705b8143ca2ee62$var$Kk();
    if ($4705b8143ca2ee62$var$R !== a || $4705b8143ca2ee62$var$Z !== b) $4705b8143ca2ee62$var$vk = null, $4705b8143ca2ee62$var$Lk(a, b);
    for(;;)try {
        $4705b8143ca2ee62$var$Uk();
        break;
    } catch (e) {
        $4705b8143ca2ee62$var$Nk(a, e);
    }
    $4705b8143ca2ee62$var$Qg();
    $4705b8143ca2ee62$var$K = c;
    $4705b8143ca2ee62$var$nk.current = d;
    if (null !== $4705b8143ca2ee62$var$Y) throw Error($4705b8143ca2ee62$var$p(261));
    $4705b8143ca2ee62$var$R = null;
    $4705b8143ca2ee62$var$Z = 0;
    return $4705b8143ca2ee62$var$T;
}
function $4705b8143ca2ee62$var$Uk() {
    for(; null !== $4705b8143ca2ee62$var$Y;)$4705b8143ca2ee62$var$Vk($4705b8143ca2ee62$var$Y);
}
function $4705b8143ca2ee62$var$Mk() {
    for(; null !== $4705b8143ca2ee62$var$Y && !$4705b8143ca2ee62$var$cc();)$4705b8143ca2ee62$var$Vk($4705b8143ca2ee62$var$Y);
}
function $4705b8143ca2ee62$var$Vk(a) {
    var b = $4705b8143ca2ee62$var$Wk(a.alternate, a, $4705b8143ca2ee62$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $4705b8143ca2ee62$var$Tk(a) : $4705b8143ca2ee62$var$Y = b;
    $4705b8143ca2ee62$var$ok.current = null;
}
function $4705b8143ca2ee62$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $4705b8143ca2ee62$var$Fj(c, b, $4705b8143ca2ee62$var$gj), null !== c) {
                $4705b8143ca2ee62$var$Y = c;
                return;
            }
        } else {
            c = $4705b8143ca2ee62$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $4705b8143ca2ee62$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $4705b8143ca2ee62$var$T = 6;
                $4705b8143ca2ee62$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $4705b8143ca2ee62$var$Y = b;
            return;
        }
        $4705b8143ca2ee62$var$Y = b = a;
    }while (null !== b);
    0 === $4705b8143ca2ee62$var$T && ($4705b8143ca2ee62$var$T = 5);
}
function $4705b8143ca2ee62$var$Qk(a, b, c) {
    var d = $4705b8143ca2ee62$var$C, e = $4705b8143ca2ee62$var$pk.transition;
    try {
        $4705b8143ca2ee62$var$pk.transition = null, $4705b8143ca2ee62$var$C = 1, $4705b8143ca2ee62$var$Xk(a, b, c, d);
    } finally{
        $4705b8143ca2ee62$var$pk.transition = e, $4705b8143ca2ee62$var$C = d;
    }
    return null;
}
function $4705b8143ca2ee62$var$Xk(a, b, c, d) {
    do $4705b8143ca2ee62$var$Ik();
    while (null !== $4705b8143ca2ee62$var$xk);
    if (0 !== ($4705b8143ca2ee62$var$K & 6)) throw Error($4705b8143ca2ee62$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($4705b8143ca2ee62$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $4705b8143ca2ee62$var$Bc(a, f);
    a === $4705b8143ca2ee62$var$R && ($4705b8143ca2ee62$var$Y = $4705b8143ca2ee62$var$R = null, $4705b8143ca2ee62$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $4705b8143ca2ee62$var$wk || ($4705b8143ca2ee62$var$wk = !0, $4705b8143ca2ee62$var$Gk($4705b8143ca2ee62$var$hc, function() {
        $4705b8143ca2ee62$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $4705b8143ca2ee62$var$pk.transition;
        $4705b8143ca2ee62$var$pk.transition = null;
        var g = $4705b8143ca2ee62$var$C;
        $4705b8143ca2ee62$var$C = 1;
        var h = $4705b8143ca2ee62$var$K;
        $4705b8143ca2ee62$var$K |= 4;
        $4705b8143ca2ee62$var$ok.current = null;
        $4705b8143ca2ee62$var$Pj(a, c);
        $4705b8143ca2ee62$var$ek(c, a);
        $4705b8143ca2ee62$var$Oe($4705b8143ca2ee62$var$Df);
        $4705b8143ca2ee62$var$dd = !!$4705b8143ca2ee62$var$Cf;
        $4705b8143ca2ee62$var$Df = $4705b8143ca2ee62$var$Cf = null;
        a.current = c;
        $4705b8143ca2ee62$var$ik(c, a, e);
        $4705b8143ca2ee62$var$dc();
        $4705b8143ca2ee62$var$K = h;
        $4705b8143ca2ee62$var$C = g;
        $4705b8143ca2ee62$var$pk.transition = f;
    } else a.current = c;
    $4705b8143ca2ee62$var$wk && ($4705b8143ca2ee62$var$wk = !1, $4705b8143ca2ee62$var$xk = a, $4705b8143ca2ee62$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($4705b8143ca2ee62$var$Si = null);
    $4705b8143ca2ee62$var$mc(c.stateNode, d);
    $4705b8143ca2ee62$var$Ek(a, $4705b8143ca2ee62$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($4705b8143ca2ee62$var$Pi) throw $4705b8143ca2ee62$var$Pi = !1, a = $4705b8143ca2ee62$var$Qi, $4705b8143ca2ee62$var$Qi = null, a;
    0 !== ($4705b8143ca2ee62$var$yk & 1) && 0 !== a.tag && $4705b8143ca2ee62$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $4705b8143ca2ee62$var$Ak ? $4705b8143ca2ee62$var$zk++ : ($4705b8143ca2ee62$var$zk = 0, $4705b8143ca2ee62$var$Ak = a) : $4705b8143ca2ee62$var$zk = 0;
    $4705b8143ca2ee62$var$jg();
    return null;
}
function $4705b8143ca2ee62$var$Ik() {
    if (null !== $4705b8143ca2ee62$var$xk) {
        var a = $4705b8143ca2ee62$var$Dc($4705b8143ca2ee62$var$yk), b = $4705b8143ca2ee62$var$pk.transition, c = $4705b8143ca2ee62$var$C;
        try {
            $4705b8143ca2ee62$var$pk.transition = null;
            $4705b8143ca2ee62$var$C = 16 > a ? 16 : a;
            if (null === $4705b8143ca2ee62$var$xk) var d = !1;
            else {
                a = $4705b8143ca2ee62$var$xk;
                $4705b8143ca2ee62$var$xk = null;
                $4705b8143ca2ee62$var$yk = 0;
                if (0 !== ($4705b8143ca2ee62$var$K & 6)) throw Error($4705b8143ca2ee62$var$p(331));
                var e = $4705b8143ca2ee62$var$K;
                $4705b8143ca2ee62$var$K |= 4;
                for($4705b8143ca2ee62$var$V = a.current; null !== $4705b8143ca2ee62$var$V;){
                    var f = $4705b8143ca2ee62$var$V, g = f.child;
                    if (0 !== ($4705b8143ca2ee62$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($4705b8143ca2ee62$var$V = l; null !== $4705b8143ca2ee62$var$V;){
                                    var m = $4705b8143ca2ee62$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $4705b8143ca2ee62$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $4705b8143ca2ee62$var$V = q;
                                    else for(; null !== $4705b8143ca2ee62$var$V;){
                                        m = $4705b8143ca2ee62$var$V;
                                        var r = m.sibling, y = m.return;
                                        $4705b8143ca2ee62$var$Tj(m);
                                        if (m === l) {
                                            $4705b8143ca2ee62$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $4705b8143ca2ee62$var$V = r;
                                            break;
                                        }
                                        $4705b8143ca2ee62$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $4705b8143ca2ee62$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $4705b8143ca2ee62$var$V = g;
                    else b: for(; null !== $4705b8143ca2ee62$var$V;){
                        f = $4705b8143ca2ee62$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $4705b8143ca2ee62$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $4705b8143ca2ee62$var$V = x;
                            break b;
                        }
                        $4705b8143ca2ee62$var$V = f.return;
                    }
                }
                var w = a.current;
                for($4705b8143ca2ee62$var$V = w; null !== $4705b8143ca2ee62$var$V;){
                    g = $4705b8143ca2ee62$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $4705b8143ca2ee62$var$V = u;
                    else b: for(g = w; null !== $4705b8143ca2ee62$var$V;){
                        h = $4705b8143ca2ee62$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $4705b8143ca2ee62$var$Rj(9, h);
                            }
                        } catch (na) {
                            $4705b8143ca2ee62$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $4705b8143ca2ee62$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $4705b8143ca2ee62$var$V = F;
                            break b;
                        }
                        $4705b8143ca2ee62$var$V = h.return;
                    }
                }
                $4705b8143ca2ee62$var$K = e;
                $4705b8143ca2ee62$var$jg();
                if ($4705b8143ca2ee62$var$lc && "function" === typeof $4705b8143ca2ee62$var$lc.onPostCommitFiberRoot) try {
                    $4705b8143ca2ee62$var$lc.onPostCommitFiberRoot($4705b8143ca2ee62$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $4705b8143ca2ee62$var$C = c, $4705b8143ca2ee62$var$pk.transition = b;
        }
    }
    return !1;
}
function $4705b8143ca2ee62$var$Yk(a, b, c) {
    b = $4705b8143ca2ee62$var$Ki(c, b);
    b = $4705b8143ca2ee62$var$Oi(a, b, 1);
    a = $4705b8143ca2ee62$var$dh(a, b, 1);
    b = $4705b8143ca2ee62$var$L();
    null !== a && ($4705b8143ca2ee62$var$Ac(a, 1, b), $4705b8143ca2ee62$var$Ek(a, b));
}
function $4705b8143ca2ee62$var$W(a, b, c) {
    if (3 === a.tag) $4705b8143ca2ee62$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $4705b8143ca2ee62$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $4705b8143ca2ee62$var$Si || !$4705b8143ca2ee62$var$Si.has(d))) {
                a = $4705b8143ca2ee62$var$Ki(c, a);
                a = $4705b8143ca2ee62$var$Ri(b, a, 1);
                b = $4705b8143ca2ee62$var$dh(b, a, 1);
                a = $4705b8143ca2ee62$var$L();
                null !== b && ($4705b8143ca2ee62$var$Ac(b, 1, a), $4705b8143ca2ee62$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $4705b8143ca2ee62$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $4705b8143ca2ee62$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $4705b8143ca2ee62$var$R === a && ($4705b8143ca2ee62$var$Z & c) === c && (4 === $4705b8143ca2ee62$var$T || 3 === $4705b8143ca2ee62$var$T && ($4705b8143ca2ee62$var$Z & 130023424) === $4705b8143ca2ee62$var$Z && 500 > $4705b8143ca2ee62$var$B() - $4705b8143ca2ee62$var$gk ? $4705b8143ca2ee62$var$Lk(a, 0) : $4705b8143ca2ee62$var$sk |= c);
    $4705b8143ca2ee62$var$Ek(a, b);
}
function $4705b8143ca2ee62$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $4705b8143ca2ee62$var$sc, $4705b8143ca2ee62$var$sc <<= 1, 0 === ($4705b8143ca2ee62$var$sc & 130023424) && ($4705b8143ca2ee62$var$sc = 4194304)));
    var c = $4705b8143ca2ee62$var$L();
    a = $4705b8143ca2ee62$var$Zg(a, b);
    null !== a && ($4705b8143ca2ee62$var$Ac(a, b, c), $4705b8143ca2ee62$var$Ek(a, c));
}
function $4705b8143ca2ee62$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $4705b8143ca2ee62$var$Zk(a, c);
}
function $4705b8143ca2ee62$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($4705b8143ca2ee62$var$p(314));
    }
    null !== d && d.delete(b);
    $4705b8143ca2ee62$var$Zk(a, c);
}
var $4705b8143ca2ee62$var$Wk;
$4705b8143ca2ee62$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $4705b8143ca2ee62$var$Wf.current) $4705b8143ca2ee62$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $4705b8143ca2ee62$var$Ug = !1, $4705b8143ca2ee62$var$zj(a, b, c);
            $4705b8143ca2ee62$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $4705b8143ca2ee62$var$Ug = !1, $4705b8143ca2ee62$var$I && 0 !== (b.flags & 1048576) && $4705b8143ca2ee62$var$ug(b, $4705b8143ca2ee62$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $4705b8143ca2ee62$var$jj(a, b);
            a = b.pendingProps;
            var e = $4705b8143ca2ee62$var$Yf(b, $4705b8143ca2ee62$var$H.current);
            $4705b8143ca2ee62$var$Tg(b, c);
            e = $4705b8143ca2ee62$var$Xh(null, b, d, a, e, c);
            var f = $4705b8143ca2ee62$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $4705b8143ca2ee62$var$Zf(d) ? (f = !0, $4705b8143ca2ee62$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $4705b8143ca2ee62$var$ah(b), e.updater = $4705b8143ca2ee62$var$nh, b.stateNode = e, e._reactInternals = b, $4705b8143ca2ee62$var$rh(b, d, a, c), b = $4705b8143ca2ee62$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $4705b8143ca2ee62$var$I && f && $4705b8143ca2ee62$var$vg(b), $4705b8143ca2ee62$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $4705b8143ca2ee62$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $4705b8143ca2ee62$var$$k(d);
                a = $4705b8143ca2ee62$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $4705b8143ca2ee62$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $4705b8143ca2ee62$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $4705b8143ca2ee62$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $4705b8143ca2ee62$var$aj(null, b, d, $4705b8143ca2ee62$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($4705b8143ca2ee62$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4705b8143ca2ee62$var$Lg(d, e), $4705b8143ca2ee62$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4705b8143ca2ee62$var$Lg(d, e), $4705b8143ca2ee62$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $4705b8143ca2ee62$var$lj(b);
                if (null === a) throw Error($4705b8143ca2ee62$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $4705b8143ca2ee62$var$bh(a, b);
                $4705b8143ca2ee62$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $4705b8143ca2ee62$var$Ki(Error($4705b8143ca2ee62$var$p(423)), b);
                        b = $4705b8143ca2ee62$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $4705b8143ca2ee62$var$Ki(Error($4705b8143ca2ee62$var$p(424)), b);
                        b = $4705b8143ca2ee62$var$mj(a, b, d, c, e);
                        break a;
                    } else for($4705b8143ca2ee62$var$yg = $4705b8143ca2ee62$var$Lf(b.stateNode.containerInfo.firstChild), $4705b8143ca2ee62$var$xg = b, $4705b8143ca2ee62$var$I = !0, $4705b8143ca2ee62$var$zg = null, c = $4705b8143ca2ee62$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $4705b8143ca2ee62$var$Ig();
                    if (d === e) {
                        b = $4705b8143ca2ee62$var$$i(a, b, c);
                        break a;
                    }
                    $4705b8143ca2ee62$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $4705b8143ca2ee62$var$Kh(b), null === a && $4705b8143ca2ee62$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $4705b8143ca2ee62$var$Ef(d, e) ? g = null : null !== f && $4705b8143ca2ee62$var$Ef(d, f) && (b.flags |= 32), $4705b8143ca2ee62$var$hj(a, b), $4705b8143ca2ee62$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $4705b8143ca2ee62$var$Eg(b), null;
        case 13:
            return $4705b8143ca2ee62$var$pj(a, b, c);
        case 4:
            return $4705b8143ca2ee62$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $4705b8143ca2ee62$var$Bh(b, null, d, c) : $4705b8143ca2ee62$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4705b8143ca2ee62$var$Lg(d, e), $4705b8143ca2ee62$var$Zi(a, b, d, e, c);
        case 7:
            return $4705b8143ca2ee62$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $4705b8143ca2ee62$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $4705b8143ca2ee62$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $4705b8143ca2ee62$var$G($4705b8143ca2ee62$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($4705b8143ca2ee62$var$He(f.value, g)) {
                        if (f.children === e.children && !$4705b8143ca2ee62$var$Wf.current) {
                            b = $4705b8143ca2ee62$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $4705b8143ca2ee62$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $4705b8143ca2ee62$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($4705b8143ca2ee62$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $4705b8143ca2ee62$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $4705b8143ca2ee62$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $4705b8143ca2ee62$var$Tg(b, c), e = $4705b8143ca2ee62$var$Vg(e), d = d(e), b.flags |= 1, $4705b8143ca2ee62$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $4705b8143ca2ee62$var$Lg(d, b.pendingProps), e = $4705b8143ca2ee62$var$Lg(d.type, e), $4705b8143ca2ee62$var$aj(a, b, d, e, c);
        case 15:
            return $4705b8143ca2ee62$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4705b8143ca2ee62$var$Lg(d, e), $4705b8143ca2ee62$var$jj(a, b), b.tag = 1, $4705b8143ca2ee62$var$Zf(d) ? (a = !0, $4705b8143ca2ee62$var$cg(b)) : a = !1, $4705b8143ca2ee62$var$Tg(b, c), $4705b8143ca2ee62$var$ph(b, d, e), $4705b8143ca2ee62$var$rh(b, d, e, c), $4705b8143ca2ee62$var$kj(null, b, d, !0, a, c);
        case 19:
            return $4705b8143ca2ee62$var$yj(a, b, c);
        case 22:
            return $4705b8143ca2ee62$var$ej(a, b, c);
    }
    throw Error($4705b8143ca2ee62$var$p(156, b.tag));
};
function $4705b8143ca2ee62$var$Gk(a, b) {
    return $4705b8143ca2ee62$var$ac(a, b);
}
function $4705b8143ca2ee62$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $4705b8143ca2ee62$var$Bg(a, b, c, d) {
    return new $4705b8143ca2ee62$var$al(a, b, c, d);
}
function $4705b8143ca2ee62$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $4705b8143ca2ee62$var$$k(a) {
    if ("function" === typeof a) return $4705b8143ca2ee62$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $4705b8143ca2ee62$var$Da) return 11;
        if (a === $4705b8143ca2ee62$var$Ga) return 14;
    }
    return 2;
}
function $4705b8143ca2ee62$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $4705b8143ca2ee62$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $4705b8143ca2ee62$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $4705b8143ca2ee62$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $4705b8143ca2ee62$var$ya:
            return $4705b8143ca2ee62$var$Ah(c.children, e, f, b);
        case $4705b8143ca2ee62$var$za:
            g = 8;
            e |= 8;
            break;
        case $4705b8143ca2ee62$var$Aa:
            return a = $4705b8143ca2ee62$var$Bg(12, c, b, e | 2), a.elementType = $4705b8143ca2ee62$var$Aa, a.lanes = f, a;
        case $4705b8143ca2ee62$var$Ea:
            return a = $4705b8143ca2ee62$var$Bg(13, c, b, e), a.elementType = $4705b8143ca2ee62$var$Ea, a.lanes = f, a;
        case $4705b8143ca2ee62$var$Fa:
            return a = $4705b8143ca2ee62$var$Bg(19, c, b, e), a.elementType = $4705b8143ca2ee62$var$Fa, a.lanes = f, a;
        case $4705b8143ca2ee62$var$Ia:
            return $4705b8143ca2ee62$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $4705b8143ca2ee62$var$Ba:
                    g = 10;
                    break a;
                case $4705b8143ca2ee62$var$Ca:
                    g = 9;
                    break a;
                case $4705b8143ca2ee62$var$Da:
                    g = 11;
                    break a;
                case $4705b8143ca2ee62$var$Ga:
                    g = 14;
                    break a;
                case $4705b8143ca2ee62$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($4705b8143ca2ee62$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $4705b8143ca2ee62$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $4705b8143ca2ee62$var$Ah(a, b, c, d) {
    a = $4705b8143ca2ee62$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $4705b8143ca2ee62$var$qj(a, b, c, d) {
    a = $4705b8143ca2ee62$var$Bg(22, a, d, b);
    a.elementType = $4705b8143ca2ee62$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $4705b8143ca2ee62$var$xh(a, b, c) {
    a = $4705b8143ca2ee62$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $4705b8143ca2ee62$var$zh(a, b, c) {
    b = $4705b8143ca2ee62$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $4705b8143ca2ee62$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $4705b8143ca2ee62$var$zc(0);
    this.expirationTimes = $4705b8143ca2ee62$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $4705b8143ca2ee62$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $4705b8143ca2ee62$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $4705b8143ca2ee62$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $4705b8143ca2ee62$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $4705b8143ca2ee62$var$ah(f);
    return a;
}
function $4705b8143ca2ee62$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4705b8143ca2ee62$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $4705b8143ca2ee62$var$el(a) {
    if (!a) return $4705b8143ca2ee62$var$Vf;
    a = a._reactInternals;
    a: {
        if ($4705b8143ca2ee62$var$Vb(a) !== a || 1 !== a.tag) throw Error($4705b8143ca2ee62$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($4705b8143ca2ee62$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($4705b8143ca2ee62$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($4705b8143ca2ee62$var$Zf(c)) return $4705b8143ca2ee62$var$bg(a, c, b);
    }
    return b;
}
function $4705b8143ca2ee62$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $4705b8143ca2ee62$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $4705b8143ca2ee62$var$el(null);
    c = a.current;
    d = $4705b8143ca2ee62$var$L();
    e = $4705b8143ca2ee62$var$lh(c);
    f = $4705b8143ca2ee62$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $4705b8143ca2ee62$var$dh(c, f, e);
    a.current.lanes = e;
    $4705b8143ca2ee62$var$Ac(a, e, d);
    $4705b8143ca2ee62$var$Ek(a, d);
    return a;
}
function $4705b8143ca2ee62$var$gl(a, b, c, d) {
    var e = b.current, f = $4705b8143ca2ee62$var$L(), g = $4705b8143ca2ee62$var$lh(e);
    c = $4705b8143ca2ee62$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $4705b8143ca2ee62$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $4705b8143ca2ee62$var$dh(e, b, g);
    null !== a && ($4705b8143ca2ee62$var$mh(a, e, g, f), $4705b8143ca2ee62$var$eh(a, e, g));
    return g;
}
function $4705b8143ca2ee62$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $4705b8143ca2ee62$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $4705b8143ca2ee62$var$jl(a, b) {
    $4705b8143ca2ee62$var$il(a, b);
    (a = a.alternate) && $4705b8143ca2ee62$var$il(a, b);
}
function $4705b8143ca2ee62$var$kl() {
    return null;
}
var $4705b8143ca2ee62$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $4705b8143ca2ee62$var$ml(a) {
    this._internalRoot = a;
}
$4705b8143ca2ee62$var$nl.prototype.render = $4705b8143ca2ee62$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($4705b8143ca2ee62$var$p(409));
    $4705b8143ca2ee62$var$gl(a, b, null, null);
};
$4705b8143ca2ee62$var$nl.prototype.unmount = $4705b8143ca2ee62$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $4705b8143ca2ee62$var$Sk(function() {
            $4705b8143ca2ee62$var$gl(null, a, null, null);
        });
        b[$4705b8143ca2ee62$var$uf] = null;
    }
};
function $4705b8143ca2ee62$var$nl(a) {
    this._internalRoot = a;
}
$4705b8143ca2ee62$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $4705b8143ca2ee62$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $4705b8143ca2ee62$var$Qc.length && 0 !== b && b < $4705b8143ca2ee62$var$Qc[c].priority; c++);
        $4705b8143ca2ee62$var$Qc.splice(c, 0, a);
        0 === c && $4705b8143ca2ee62$var$Vc(a);
    }
};
function $4705b8143ca2ee62$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $4705b8143ca2ee62$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $4705b8143ca2ee62$var$ql() {}
function $4705b8143ca2ee62$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $4705b8143ca2ee62$var$hl(g);
                f.call(a);
            };
        }
        var g = $4705b8143ca2ee62$var$fl(b, d, a, 0, null, !1, !1, "", $4705b8143ca2ee62$var$ql);
        a._reactRootContainer = g;
        a[$4705b8143ca2ee62$var$uf] = g.current;
        $4705b8143ca2ee62$var$sf(8 === a.nodeType ? a.parentNode : a);
        $4705b8143ca2ee62$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $4705b8143ca2ee62$var$hl(k);
            h.call(a);
        };
    }
    var k = $4705b8143ca2ee62$var$cl(a, 0, !1, null, null, !1, !1, "", $4705b8143ca2ee62$var$ql);
    a._reactRootContainer = k;
    a[$4705b8143ca2ee62$var$uf] = k.current;
    $4705b8143ca2ee62$var$sf(8 === a.nodeType ? a.parentNode : a);
    $4705b8143ca2ee62$var$Sk(function() {
        $4705b8143ca2ee62$var$gl(b, k, c, d);
    });
    return k;
}
function $4705b8143ca2ee62$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $4705b8143ca2ee62$var$hl(g);
                h.call(a);
            };
        }
        $4705b8143ca2ee62$var$gl(b, g, a, e);
    } else g = $4705b8143ca2ee62$var$rl(c, b, a, e, d);
    return $4705b8143ca2ee62$var$hl(g);
}
$4705b8143ca2ee62$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $4705b8143ca2ee62$var$tc(b.pendingLanes);
                0 !== c && ($4705b8143ca2ee62$var$Cc(b, c | 1), $4705b8143ca2ee62$var$Ek(b, $4705b8143ca2ee62$var$B()), 0 === ($4705b8143ca2ee62$var$K & 6) && ($4705b8143ca2ee62$var$Hj = $4705b8143ca2ee62$var$B() + 500, $4705b8143ca2ee62$var$jg()));
            }
            break;
        case 13:
            $4705b8143ca2ee62$var$Sk(function() {
                var b = $4705b8143ca2ee62$var$Zg(a, 1);
                if (null !== b) {
                    var c = $4705b8143ca2ee62$var$L();
                    $4705b8143ca2ee62$var$mh(b, a, 1, c);
                }
            }), $4705b8143ca2ee62$var$jl(a, 1);
    }
};
$4705b8143ca2ee62$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $4705b8143ca2ee62$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $4705b8143ca2ee62$var$L();
            $4705b8143ca2ee62$var$mh(b, a, 134217728, c);
        }
        $4705b8143ca2ee62$var$jl(a, 134217728);
    }
};
$4705b8143ca2ee62$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $4705b8143ca2ee62$var$lh(a), c = $4705b8143ca2ee62$var$Zg(a, b);
        if (null !== c) {
            var d = $4705b8143ca2ee62$var$L();
            $4705b8143ca2ee62$var$mh(c, a, b, d);
        }
        $4705b8143ca2ee62$var$jl(a, b);
    }
};
$4705b8143ca2ee62$var$Hc = function() {
    return $4705b8143ca2ee62$var$C;
};
$4705b8143ca2ee62$var$Ic = function(a, b) {
    var c = $4705b8143ca2ee62$var$C;
    try {
        return $4705b8143ca2ee62$var$C = a, b();
    } finally{
        $4705b8143ca2ee62$var$C = c;
    }
};
$4705b8143ca2ee62$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $4705b8143ca2ee62$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $4705b8143ca2ee62$var$Db(d);
                        if (!e) throw Error($4705b8143ca2ee62$var$p(90));
                        $4705b8143ca2ee62$var$Wa(d);
                        $4705b8143ca2ee62$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $4705b8143ca2ee62$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $4705b8143ca2ee62$var$fb(a, !!c.multiple, b, !1);
    }
};
$4705b8143ca2ee62$var$Gb = $4705b8143ca2ee62$var$Rk;
$4705b8143ca2ee62$var$Hb = $4705b8143ca2ee62$var$Sk;
var $4705b8143ca2ee62$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $4705b8143ca2ee62$var$Cb,
        $4705b8143ca2ee62$var$ue,
        $4705b8143ca2ee62$var$Db,
        $4705b8143ca2ee62$var$Eb,
        $4705b8143ca2ee62$var$Fb,
        $4705b8143ca2ee62$var$Rk
    ]
}, $4705b8143ca2ee62$var$ul = {
    findFiberByHostInstance: $4705b8143ca2ee62$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $4705b8143ca2ee62$var$vl = {
    bundleType: $4705b8143ca2ee62$var$ul.bundleType,
    version: $4705b8143ca2ee62$var$ul.version,
    rendererPackageName: $4705b8143ca2ee62$var$ul.rendererPackageName,
    rendererConfig: $4705b8143ca2ee62$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $4705b8143ca2ee62$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $4705b8143ca2ee62$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $4705b8143ca2ee62$var$ul.findFiberByHostInstance || $4705b8143ca2ee62$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $4705b8143ca2ee62$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$4705b8143ca2ee62$var$wl.isDisabled && $4705b8143ca2ee62$var$wl.supportsFiber) try {
        $4705b8143ca2ee62$var$kc = $4705b8143ca2ee62$var$wl.inject($4705b8143ca2ee62$var$vl), $4705b8143ca2ee62$var$lc = $4705b8143ca2ee62$var$wl;
    } catch (a) {}
}
$4705b8143ca2ee62$export$ae55be85d98224ed = $4705b8143ca2ee62$var$tl;
$4705b8143ca2ee62$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$4705b8143ca2ee62$var$ol(b)) throw Error($4705b8143ca2ee62$var$p(200));
    return $4705b8143ca2ee62$var$dl(a, b, null, c);
};
$4705b8143ca2ee62$export$882461b6382ed46c = function(a, b) {
    if (!$4705b8143ca2ee62$var$ol(a)) throw Error($4705b8143ca2ee62$var$p(299));
    var c = !1, d = "", e = $4705b8143ca2ee62$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $4705b8143ca2ee62$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$4705b8143ca2ee62$var$uf] = b.current;
    $4705b8143ca2ee62$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $4705b8143ca2ee62$var$ml(b);
};
$4705b8143ca2ee62$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($4705b8143ca2ee62$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($4705b8143ca2ee62$var$p(268, a));
    }
    a = $4705b8143ca2ee62$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$4705b8143ca2ee62$export$cd75ccfd720a3cd4 = function(a) {
    return $4705b8143ca2ee62$var$Sk(a);
};
$4705b8143ca2ee62$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$4705b8143ca2ee62$var$pl(b)) throw Error($4705b8143ca2ee62$var$p(200));
    return $4705b8143ca2ee62$var$sl(null, a, b, !0, c);
};
$4705b8143ca2ee62$export$757ceba2d55c277e = function(a, b, c) {
    if (!$4705b8143ca2ee62$var$ol(a)) throw Error($4705b8143ca2ee62$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $4705b8143ca2ee62$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $4705b8143ca2ee62$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$4705b8143ca2ee62$var$uf] = b.current;
    $4705b8143ca2ee62$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $4705b8143ca2ee62$var$nl(b);
};
$4705b8143ca2ee62$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$4705b8143ca2ee62$var$pl(b)) throw Error($4705b8143ca2ee62$var$p(200));
    return $4705b8143ca2ee62$var$sl(null, a, b, !1, c);
};
$4705b8143ca2ee62$export$502457920280e6be = function(a) {
    if (!$4705b8143ca2ee62$var$pl(a)) throw Error($4705b8143ca2ee62$var$p(40));
    return a._reactRootContainer ? ($4705b8143ca2ee62$var$Sk(function() {
        $4705b8143ca2ee62$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$4705b8143ca2ee62$var$uf] = null;
        });
    }), !0) : !1;
};
$4705b8143ca2ee62$export$c78a37762a8d58e1 = $4705b8143ca2ee62$var$Rk;
$4705b8143ca2ee62$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$4705b8143ca2ee62$var$pl(c)) throw Error($4705b8143ca2ee62$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($4705b8143ca2ee62$var$p(38));
    return $4705b8143ca2ee62$var$sl(a, b, c, !1, d);
};
$4705b8143ca2ee62$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("3ob6t", function(module, exports) {
'use strict';

module.exports = (parcelRequire("81BCC"));

});
parcelRegister("81BCC", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $5d7b99ac318686f4$export$c4744153514ff05d; }, function (v) { return $5d7b99ac318686f4$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $5d7b99ac318686f4$export$3e506c1ccc9cc1a7; }, function (v) { return $5d7b99ac318686f4$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $5d7b99ac318686f4$export$e26fe2ed2fa76875; }, function (v) { return $5d7b99ac318686f4$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $5d7b99ac318686f4$export$502329bbf4b505b1; }, function (v) { return $5d7b99ac318686f4$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $5d7b99ac318686f4$export$6e3807111c4874c4; }, function (v) { return $5d7b99ac318686f4$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $5d7b99ac318686f4$export$c27134553091fb3a; }, function (v) { return $5d7b99ac318686f4$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $5d7b99ac318686f4$export$33ee1acdc04fd2a2; }, function (v) { return $5d7b99ac318686f4$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $5d7b99ac318686f4$export$b00a404bbd5edef2; }, function (v) { return $5d7b99ac318686f4$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $5d7b99ac318686f4$export$8352ce38b91d0c62; }, function (v) { return $5d7b99ac318686f4$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $5d7b99ac318686f4$export$d66a1c1c77bd778b; }, function (v) { return $5d7b99ac318686f4$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $5d7b99ac318686f4$export$d3dfb8e4810cb555; }, function (v) { return $5d7b99ac318686f4$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $5d7b99ac318686f4$export$839f9183b0465a69; }, function (v) { return $5d7b99ac318686f4$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $5d7b99ac318686f4$export$72fdf0e06517287b; }, function (v) { return $5d7b99ac318686f4$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $5d7b99ac318686f4$export$4b844e58a3e414b4; }, function (v) { return $5d7b99ac318686f4$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $5d7b99ac318686f4$export$816d2913ae6b83b1; }, function (v) { return $5d7b99ac318686f4$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $5d7b99ac318686f4$export$61bcfe829111a1d0; }, function (v) { return $5d7b99ac318686f4$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $5d7b99ac318686f4$export$7ee8c9beb337bc3f; }, function (v) { return $5d7b99ac318686f4$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $5d7b99ac318686f4$export$b5836b71941fa3ed; }, function (v) { return $5d7b99ac318686f4$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $5d7b99ac318686f4$export$cf845f2c119da08a; }, function (v) { return $5d7b99ac318686f4$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5d7b99ac318686f4$export$c4744153514ff05d;
var $5d7b99ac318686f4$export$3e506c1ccc9cc1a7;
var $5d7b99ac318686f4$export$e26fe2ed2fa76875;
var $5d7b99ac318686f4$export$502329bbf4b505b1;
var $5d7b99ac318686f4$export$6e3807111c4874c4;
var $5d7b99ac318686f4$export$c27134553091fb3a;
var $5d7b99ac318686f4$export$33ee1acdc04fd2a2;
var $5d7b99ac318686f4$export$b00a404bbd5edef2;
var $5d7b99ac318686f4$export$8352ce38b91d0c62;
var $5d7b99ac318686f4$export$d66a1c1c77bd778b;
var $5d7b99ac318686f4$export$d3dfb8e4810cb555;
var $5d7b99ac318686f4$export$839f9183b0465a69;
var $5d7b99ac318686f4$export$72fdf0e06517287b;
var $5d7b99ac318686f4$export$4b844e58a3e414b4;
var $5d7b99ac318686f4$export$816d2913ae6b83b1;
var $5d7b99ac318686f4$export$61bcfe829111a1d0;
var $5d7b99ac318686f4$export$7ee8c9beb337bc3f;
var $5d7b99ac318686f4$export$b5836b71941fa3ed;
var $5d7b99ac318686f4$export$cf845f2c119da08a;
'use strict';
function $5d7b99ac318686f4$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $5d7b99ac318686f4$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $5d7b99ac318686f4$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $5d7b99ac318686f4$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $5d7b99ac318686f4$var$g(C, c)) n < e && 0 > $5d7b99ac318686f4$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $5d7b99ac318686f4$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $5d7b99ac318686f4$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $5d7b99ac318686f4$var$l = performance;
    $5d7b99ac318686f4$export$c4744153514ff05d = function() {
        return $5d7b99ac318686f4$var$l.now();
    };
} else {
    var $5d7b99ac318686f4$var$p = Date, $5d7b99ac318686f4$var$q = $5d7b99ac318686f4$var$p.now();
    $5d7b99ac318686f4$export$c4744153514ff05d = function() {
        return $5d7b99ac318686f4$var$p.now() - $5d7b99ac318686f4$var$q;
    };
}
var $5d7b99ac318686f4$var$r = [], $5d7b99ac318686f4$var$t = [], $5d7b99ac318686f4$var$u = 1, $5d7b99ac318686f4$var$v = null, $5d7b99ac318686f4$var$y = 3, $5d7b99ac318686f4$var$z = !1, $5d7b99ac318686f4$var$A = !1, $5d7b99ac318686f4$var$B = !1, $5d7b99ac318686f4$var$D = "function" === typeof setTimeout ? setTimeout : null, $5d7b99ac318686f4$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $5d7b99ac318686f4$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $5d7b99ac318686f4$var$G(a) {
    for(var b = $5d7b99ac318686f4$var$h($5d7b99ac318686f4$var$t); null !== b;){
        if (null === b.callback) $5d7b99ac318686f4$var$k($5d7b99ac318686f4$var$t);
        else if (b.startTime <= a) $5d7b99ac318686f4$var$k($5d7b99ac318686f4$var$t), b.sortIndex = b.expirationTime, $5d7b99ac318686f4$var$f($5d7b99ac318686f4$var$r, b);
        else break;
        b = $5d7b99ac318686f4$var$h($5d7b99ac318686f4$var$t);
    }
}
function $5d7b99ac318686f4$var$H(a) {
    $5d7b99ac318686f4$var$B = !1;
    $5d7b99ac318686f4$var$G(a);
    if (!$5d7b99ac318686f4$var$A) {
        if (null !== $5d7b99ac318686f4$var$h($5d7b99ac318686f4$var$r)) $5d7b99ac318686f4$var$A = !0, $5d7b99ac318686f4$var$I($5d7b99ac318686f4$var$J);
        else {
            var b = $5d7b99ac318686f4$var$h($5d7b99ac318686f4$var$t);
            null !== b && $5d7b99ac318686f4$var$K($5d7b99ac318686f4$var$H, b.startTime - a);
        }
    }
}
function $5d7b99ac318686f4$var$J(a, b) {
    $5d7b99ac318686f4$var$A = !1;
    $5d7b99ac318686f4$var$B && ($5d7b99ac318686f4$var$B = !1, $5d7b99ac318686f4$var$E($5d7b99ac318686f4$var$L), $5d7b99ac318686f4$var$L = -1);
    $5d7b99ac318686f4$var$z = !0;
    var c = $5d7b99ac318686f4$var$y;
    try {
        $5d7b99ac318686f4$var$G(b);
        for($5d7b99ac318686f4$var$v = $5d7b99ac318686f4$var$h($5d7b99ac318686f4$var$r); null !== $5d7b99ac318686f4$var$v && (!($5d7b99ac318686f4$var$v.expirationTime > b) || a && !$5d7b99ac318686f4$var$M());){
            var d = $5d7b99ac318686f4$var$v.callback;
            if ("function" === typeof d) {
                $5d7b99ac318686f4$var$v.callback = null;
                $5d7b99ac318686f4$var$y = $5d7b99ac318686f4$var$v.priorityLevel;
                var e = d($5d7b99ac318686f4$var$v.expirationTime <= b);
                b = $5d7b99ac318686f4$export$c4744153514ff05d();
                "function" === typeof e ? $5d7b99ac318686f4$var$v.callback = e : $5d7b99ac318686f4$var$v === $5d7b99ac318686f4$var$h($5d7b99ac318686f4$var$r) && $5d7b99ac318686f4$var$k($5d7b99ac318686f4$var$r);
                $5d7b99ac318686f4$var$G(b);
            } else $5d7b99ac318686f4$var$k($5d7b99ac318686f4$var$r);
            $5d7b99ac318686f4$var$v = $5d7b99ac318686f4$var$h($5d7b99ac318686f4$var$r);
        }
        if (null !== $5d7b99ac318686f4$var$v) var w = !0;
        else {
            var m = $5d7b99ac318686f4$var$h($5d7b99ac318686f4$var$t);
            null !== m && $5d7b99ac318686f4$var$K($5d7b99ac318686f4$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $5d7b99ac318686f4$var$v = null, $5d7b99ac318686f4$var$y = c, $5d7b99ac318686f4$var$z = !1;
    }
}
var $5d7b99ac318686f4$var$N = !1, $5d7b99ac318686f4$var$O = null, $5d7b99ac318686f4$var$L = -1, $5d7b99ac318686f4$var$P = 5, $5d7b99ac318686f4$var$Q = -1;
function $5d7b99ac318686f4$var$M() {
    return $5d7b99ac318686f4$export$c4744153514ff05d() - $5d7b99ac318686f4$var$Q < $5d7b99ac318686f4$var$P ? !1 : !0;
}
function $5d7b99ac318686f4$var$R() {
    if (null !== $5d7b99ac318686f4$var$O) {
        var a = $5d7b99ac318686f4$export$c4744153514ff05d();
        $5d7b99ac318686f4$var$Q = a;
        var b = !0;
        try {
            b = $5d7b99ac318686f4$var$O(!0, a);
        } finally{
            b ? $5d7b99ac318686f4$var$S() : ($5d7b99ac318686f4$var$N = !1, $5d7b99ac318686f4$var$O = null);
        }
    } else $5d7b99ac318686f4$var$N = !1;
}
var $5d7b99ac318686f4$var$S;
if ("function" === typeof $5d7b99ac318686f4$var$F) $5d7b99ac318686f4$var$S = function() {
    $5d7b99ac318686f4$var$F($5d7b99ac318686f4$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $5d7b99ac318686f4$var$T = new MessageChannel, $5d7b99ac318686f4$var$U = $5d7b99ac318686f4$var$T.port2;
    $5d7b99ac318686f4$var$T.port1.onmessage = $5d7b99ac318686f4$var$R;
    $5d7b99ac318686f4$var$S = function() {
        $5d7b99ac318686f4$var$U.postMessage(null);
    };
} else $5d7b99ac318686f4$var$S = function() {
    $5d7b99ac318686f4$var$D($5d7b99ac318686f4$var$R, 0);
};
function $5d7b99ac318686f4$var$I(a) {
    $5d7b99ac318686f4$var$O = a;
    $5d7b99ac318686f4$var$N || ($5d7b99ac318686f4$var$N = !0, $5d7b99ac318686f4$var$S());
}
function $5d7b99ac318686f4$var$K(a, b) {
    $5d7b99ac318686f4$var$L = $5d7b99ac318686f4$var$D(function() {
        a($5d7b99ac318686f4$export$c4744153514ff05d());
    }, b);
}
$5d7b99ac318686f4$export$3e506c1ccc9cc1a7 = 5;
$5d7b99ac318686f4$export$e26fe2ed2fa76875 = 1;
$5d7b99ac318686f4$export$502329bbf4b505b1 = 4;
$5d7b99ac318686f4$export$6e3807111c4874c4 = 3;
$5d7b99ac318686f4$export$c27134553091fb3a = null;
$5d7b99ac318686f4$export$33ee1acdc04fd2a2 = 2;
$5d7b99ac318686f4$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$5d7b99ac318686f4$export$8352ce38b91d0c62 = function() {
    $5d7b99ac318686f4$var$A || $5d7b99ac318686f4$var$z || ($5d7b99ac318686f4$var$A = !0, $5d7b99ac318686f4$var$I($5d7b99ac318686f4$var$J));
};
$5d7b99ac318686f4$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $5d7b99ac318686f4$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$5d7b99ac318686f4$export$d3dfb8e4810cb555 = function() {
    return $5d7b99ac318686f4$var$y;
};
$5d7b99ac318686f4$export$839f9183b0465a69 = function() {
    return $5d7b99ac318686f4$var$h($5d7b99ac318686f4$var$r);
};
$5d7b99ac318686f4$export$72fdf0e06517287b = function(a) {
    switch($5d7b99ac318686f4$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $5d7b99ac318686f4$var$y;
    }
    var c = $5d7b99ac318686f4$var$y;
    $5d7b99ac318686f4$var$y = b;
    try {
        return a();
    } finally{
        $5d7b99ac318686f4$var$y = c;
    }
};
$5d7b99ac318686f4$export$4b844e58a3e414b4 = function() {};
$5d7b99ac318686f4$export$816d2913ae6b83b1 = function() {};
$5d7b99ac318686f4$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $5d7b99ac318686f4$var$y;
    $5d7b99ac318686f4$var$y = a;
    try {
        return b();
    } finally{
        $5d7b99ac318686f4$var$y = c;
    }
};
$5d7b99ac318686f4$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $5d7b99ac318686f4$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $5d7b99ac318686f4$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $5d7b99ac318686f4$var$f($5d7b99ac318686f4$var$t, a), null === $5d7b99ac318686f4$var$h($5d7b99ac318686f4$var$r) && a === $5d7b99ac318686f4$var$h($5d7b99ac318686f4$var$t) && ($5d7b99ac318686f4$var$B ? ($5d7b99ac318686f4$var$E($5d7b99ac318686f4$var$L), $5d7b99ac318686f4$var$L = -1) : $5d7b99ac318686f4$var$B = !0, $5d7b99ac318686f4$var$K($5d7b99ac318686f4$var$H, c - d))) : (a.sortIndex = e, $5d7b99ac318686f4$var$f($5d7b99ac318686f4$var$r, a), $5d7b99ac318686f4$var$A || $5d7b99ac318686f4$var$z || ($5d7b99ac318686f4$var$A = !0, $5d7b99ac318686f4$var$I($5d7b99ac318686f4$var$J)));
    return a;
};
$5d7b99ac318686f4$export$b5836b71941fa3ed = $5d7b99ac318686f4$var$M;
$5d7b99ac318686f4$export$cf845f2c119da08a = function(a) {
    var b = $5d7b99ac318686f4$var$y;
    return function() {
        var c = $5d7b99ac318686f4$var$y;
        $5d7b99ac318686f4$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $5d7b99ac318686f4$var$y = c;
        }
    };
};

});



parcelRegister("hq9s0", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $5I1C7 = parcelRequire("5I1C7");
function $caec321d7e819e28$var$emptyFunction() {}
function $caec321d7e819e28$var$emptyFunctionWithReset() {}
$caec321d7e819e28$var$emptyFunctionWithReset.resetWarningCache = $caec321d7e819e28$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $5I1C7) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $caec321d7e819e28$var$emptyFunctionWithReset,
        resetWarningCache: $caec321d7e819e28$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("5I1C7", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $4282504d17d990d8$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $4282504d17d990d8$var$ReactPropTypesSecret;

});


var $ff32bd79773053fb$exports = {};
'use strict';

$ff32bd79773053fb$exports = (parcelRequire("l1JKY"));


parcelRequire("iQhxf");
var $7d799523f5abb734$export$882461b6382ed46c;
var $7d799523f5abb734$export$757ceba2d55c277e;
'use strict';
var $6b69b237a3b768b7$exports = {};
'use strict';
function $6b69b237a3b768b7$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($6b69b237a3b768b7$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$6b69b237a3b768b7$var$checkDCE();

$6b69b237a3b768b7$exports = (parcelRequire("66379"));


var $7d799523f5abb734$var$i;
$7d799523f5abb734$export$882461b6382ed46c = $6b69b237a3b768b7$exports.createRoot;
$7d799523f5abb734$export$757ceba2d55c277e = $6b69b237a3b768b7$exports.hydrateRoot;




var $iQhxf = parcelRequire("iQhxf");


var $iQhxf = parcelRequire("iQhxf");
var $c76bdfd2befe6dfd$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c76bdfd2befe6dfd$var$ReactIs, $c76bdfd2befe6dfd$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$c76bdfd2befe6dfd$exports = (parcelRequire("hq9s0"))();


/**
 * react-router v7.18.5
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $iQhxf = parcelRequire("iQhxf");
var $872c5e169d87e980$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-6KYCQHYJ.mjs"
});
var $872c5e169d87e980$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $872c5e169d87e980$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $872c5e169d87e980$var$__typeError("Cannot " + msg);
var $872c5e169d87e980$var$__privateGet = (obj, member, getter)=>($872c5e169d87e980$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $872c5e169d87e980$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $872c5e169d87e980$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $872c5e169d87e980$var$__privateSet = (obj, member, value, setter)=>($872c5e169d87e980$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
// lib/router/url.ts
var $872c5e169d87e980$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|[\\/]{2})/i;
var $872c5e169d87e980$export$825a82322d91916e = /^[\\/]{2}/;
function $872c5e169d87e980$var$normalizeProtocolRelativeUrl(url, protocol) {
    return protocol + url.replace(/\\/g, "/");
}
// lib/router/history.ts
var $872c5e169d87e980$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($872c5e169d87e980$export$e19cd5f9376f8cee || {});
var $872c5e169d87e980$var$PopStateEventType = "popstate";
function $872c5e169d87e980$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
function $872c5e169d87e980$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, mask) {
        let location = $872c5e169d87e980$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $872c5e169d87e980$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $872c5e169d87e980$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $872c5e169d87e980$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = $872c5e169d87e980$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = $872c5e169d87e980$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $872c5e169d87e980$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window2.location;
        return $872c5e169d87e980$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window2.location.pathname,
            search: window2.location.search,
            hash: window2.location.hash
        } : void 0);
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $872c5e169d87e980$export$fe53371bee54353d(to);
    }
    return $872c5e169d87e980$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $872c5e169d87e980$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $872c5e169d87e980$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $872c5e169d87e980$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $872c5e169d87e980$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $872c5e169d87e980$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $872c5e169d87e980$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $872c5e169d87e980$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $872c5e169d87e980$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $872c5e169d87e980$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $872c5e169d87e980$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
function $872c5e169d87e980$var$createLocation(current, to, state = null, key, mask) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $872c5e169d87e980$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $872c5e169d87e980$var$createKey(),
        mask: mask
    };
    return location;
}
function $872c5e169d87e980$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $872c5e169d87e980$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $872c5e169d87e980$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $872c5e169d87e980$var$isLocation(to) ? to : $872c5e169d87e980$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $872c5e169d87e980$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $872c5e169d87e980$var$isLocation(to) ? to : $872c5e169d87e980$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $872c5e169d87e980$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $872c5e169d87e980$var$createBrowserURLImpl(window2, to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($872c5e169d87e980$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($872c5e169d87e980$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $872c5e169d87e980$var$createBrowserURLImpl(windowImpl, to, isAbsolute = false) {
    let base = "http://localhost";
    if (windowImpl) base = windowImpl.location.origin !== "null" ? windowImpl.location.origin : windowImpl.location.href;
    $872c5e169d87e980$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $872c5e169d87e980$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && $872c5e169d87e980$export$825a82322d91916e.test(href)) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $872c5e169d87e980$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $872c5e169d87e980$var$_map;
var $872c5e169d87e980$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $872c5e169d87e980$var$__privateAdd(this, $872c5e169d87e980$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($872c5e169d87e980$var$__privateGet(this, $872c5e169d87e980$var$_map).has(context)) return $872c5e169d87e980$var$__privateGet(this, $872c5e169d87e980$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $872c5e169d87e980$var$__privateGet(this, $872c5e169d87e980$var$_map).set(context, value);
    }
};
$872c5e169d87e980$var$_map = new WeakMap();
var $872c5e169d87e980$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $872c5e169d87e980$var$isUnsupportedLazyRouteObjectKey(key) {
    return $872c5e169d87e980$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $872c5e169d87e980$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $872c5e169d87e980$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $872c5e169d87e980$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $872c5e169d87e980$var$isIndexRoute(route) {
    return route.index === true;
}
function $872c5e169d87e980$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $872c5e169d87e980$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $872c5e169d87e980$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($872c5e169d87e980$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $872c5e169d87e980$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $872c5e169d87e980$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $872c5e169d87e980$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $872c5e169d87e980$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $872c5e169d87e980$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $872c5e169d87e980$export$5c7b09132f833c25(routes, locationArg, basename, false);
}
function $872c5e169d87e980$export$5c7b09132f833c25(routes, locationArg, basename, allowPartial, precomputedBranches) {
    let location = typeof locationArg === "string" ? $872c5e169d87e980$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $872c5e169d87e980$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = precomputedBranches ?? $872c5e169d87e980$var$flattenAndRankRoutes(routes);
    let matches = null;
    let decoded = $872c5e169d87e980$var$decodePath(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $872c5e169d87e980$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $872c5e169d87e980$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $872c5e169d87e980$var$flattenAndRankRoutes(routes) {
    let branches = $872c5e169d87e980$var$flattenRoutes(routes);
    $872c5e169d87e980$var$rankRouteBranches(branches);
    return branches;
}
function $872c5e169d87e980$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $872c5e169d87e980$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $872c5e169d87e980$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $872c5e169d87e980$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $872c5e169d87e980$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $872c5e169d87e980$var$computeScore(path, route.index),
            routesMeta: routesMeta.map((meta2, i)=>{
                let [matcher, params] = $872c5e169d87e980$var$compilePath(meta2.relativePath, meta2.caseSensitive, i === routesMeta.length - 1);
                return {
                    ...meta2,
                    matcher: matcher,
                    compiledParams: params
                };
            })
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $872c5e169d87e980$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $872c5e169d87e980$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $872c5e169d87e980$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $872c5e169d87e980$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $872c5e169d87e980$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $872c5e169d87e980$var$paramRe = /^:[\w-]+$/;
var $872c5e169d87e980$var$dynamicSegmentValue = 3;
var $872c5e169d87e980$var$indexRouteValue = 2;
var $872c5e169d87e980$var$emptySegmentValue = 1;
var $872c5e169d87e980$var$staticSegmentValue = 10;
var $872c5e169d87e980$var$splatPenalty = -2;
var $872c5e169d87e980$var$isSplat = (s)=>s === "*";
function $872c5e169d87e980$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($872c5e169d87e980$var$isSplat)) initialScore += $872c5e169d87e980$var$splatPenalty;
    if (index) initialScore += $872c5e169d87e980$var$indexRouteValue;
    return segments.filter((s)=>!$872c5e169d87e980$var$isSplat(s)).reduce((score, segment)=>score + ($872c5e169d87e980$var$paramRe.test(segment) ? $872c5e169d87e980$var$dynamicSegmentValue : segment === "" ? $872c5e169d87e980$var$emptySegmentValue : $872c5e169d87e980$var$staticSegmentValue), initialScore);
}
function $872c5e169d87e980$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $872c5e169d87e980$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let pattern = {
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        };
        let match = // Use precomputed matcher if it exists
        meta.matcher && meta.compiledParams ? $872c5e169d87e980$var$matchPathImpl(pattern, remainingPathname, meta.matcher, meta.compiledParams) : $872c5e169d87e980$export$81336c211d5ff295(pattern, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $872c5e169d87e980$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $872c5e169d87e980$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $872c5e169d87e980$var$normalizePathname($872c5e169d87e980$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $872c5e169d87e980$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $872c5e169d87e980$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $872c5e169d87e980$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") return stringify2(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            $872c5e169d87e980$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $872c5e169d87e980$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $872c5e169d87e980$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    return $872c5e169d87e980$var$matchPathImpl(pattern, pathname, matcher, compiledParams);
}
function $872c5e169d87e980$var$matchPathImpl(pattern, pathname, matcher, compiledParams) {
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = $872c5e169d87e980$var$removeTrailingSlash(matchedPathname, 1);
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = $872c5e169d87e980$var$removeTrailingSlash(matchedPathname.slice(0, matchedPathname.length - splatValue.length), 1);
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $872c5e169d87e980$var$compilePath(path, caseSensitive = false, end = true) {
    $872c5e169d87e980$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $872c5e169d87e980$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $872c5e169d87e980$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $872c5e169d87e980$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $872c5e169d87e980$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $872c5e169d87e980$var$joinPaths([
        basename,
        pathname
    ]);
}
var $872c5e169d87e980$var$isAbsoluteUrl = (url)=>$872c5e169d87e980$var$ABSOLUTE_URL_REGEX.test(url);
function $872c5e169d87e980$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $872c5e169d87e980$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $872c5e169d87e980$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/") || toPathname.startsWith("\\")) pathname = $872c5e169d87e980$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $872c5e169d87e980$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $872c5e169d87e980$var$normalizeSearch(search),
        hash: $872c5e169d87e980$var$normalizeHash(hash)
    };
}
function $872c5e169d87e980$var$resolvePathname(relativePath, fromPathname) {
    let segments = $872c5e169d87e980$var$removeTrailingSlash(fromPathname).split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $872c5e169d87e980$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $872c5e169d87e980$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $872c5e169d87e980$var$getResolveToMatches(matches) {
    let pathMatches = $872c5e169d87e980$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $872c5e169d87e980$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $872c5e169d87e980$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $872c5e169d87e980$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $872c5e169d87e980$var$getInvalidPathError("?", "pathname", "search", to));
        $872c5e169d87e980$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $872c5e169d87e980$var$getInvalidPathError("#", "pathname", "hash", to));
        $872c5e169d87e980$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $872c5e169d87e980$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $872c5e169d87e980$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $872c5e169d87e980$var$removeDoubleSlashes = (path)=>path.replace(/[\\/]{2,}/g, "/");
var $872c5e169d87e980$var$joinPaths = (paths)=>$872c5e169d87e980$var$removeDoubleSlashes(paths.join("/"));
function $872c5e169d87e980$var$removeTrailingSlash(path, minLength = 0) {
    let end = path.length;
    while(end > minLength && path.charCodeAt(end - 1) === 47)end--;
    return end === path.length ? path : path.slice(0, end);
}
var $872c5e169d87e980$var$normalizePathname = (pathname)=>$872c5e169d87e980$var$removeTrailingSlash(pathname).replace(/^\/*/, "/");
var $872c5e169d87e980$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $872c5e169d87e980$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $872c5e169d87e980$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $872c5e169d87e980$export$4051a07651545597(data2, init) {
    return new $872c5e169d87e980$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $872c5e169d87e980$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $872c5e169d87e980$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $872c5e169d87e980$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $872c5e169d87e980$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $872c5e169d87e980$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $872c5e169d87e980$var$SUPPORTED_ERROR_TYPES = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $872c5e169d87e980$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $872c5e169d87e980$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $872c5e169d87e980$var$getRoutePattern(matches) {
    let parts = matches.map((m)=>m.route.path).filter(Boolean);
    return $872c5e169d87e980$var$joinPaths(parts) || "/";
}
var $872c5e169d87e980$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $872c5e169d87e980$var$parseToInfo(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !$872c5e169d87e980$var$ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($872c5e169d87e980$var$isBrowser) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = $872c5e169d87e980$export$825a82322d91916e.test(to) ? new URL($872c5e169d87e980$var$normalizeProtocolRelativeUrl(to, currentUrl.protocol)) : new URL(to);
        let path = $872c5e169d87e980$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        $872c5e169d87e980$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var $872c5e169d87e980$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $872c5e169d87e980$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $872c5e169d87e980$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $872c5e169d87e980$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$872c5e169d87e980$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $872c5e169d87e980$var$wrapImpl(aggregated[key], original, (...args)=>$872c5e169d87e980$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$872c5e169d87e980$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$872c5e169d87e980$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $872c5e169d87e980$var$wrapImpl(aggregated.middleware, original, (...args)=>$872c5e169d87e980$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$872c5e169d87e980$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $872c5e169d87e980$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$872c5e169d87e980$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $872c5e169d87e980$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $872c5e169d87e980$export$fe53371bee54353d(to) : ".",
                ...$872c5e169d87e980$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$872c5e169d87e980$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$872c5e169d87e980$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $872c5e169d87e980$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$872c5e169d87e980$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$872c5e169d87e980$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $872c5e169d87e980$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $872c5e169d87e980$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $872c5e169d87e980$var$getReadonlyRequest(request),
            context: context != null ? $872c5e169d87e980$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $872c5e169d87e980$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $872c5e169d87e980$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $872c5e169d87e980$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $872c5e169d87e980$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $872c5e169d87e980$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $872c5e169d87e980$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, pattern: pattern } = args;
    return {
        request: $872c5e169d87e980$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        pattern: pattern,
        context: $872c5e169d87e980$var$getReadonlyContext(context)
    };
}
function $872c5e169d87e980$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $872c5e169d87e980$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $872c5e169d87e980$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $872c5e169d87e980$var$getReadonlyContext(context) {
    if ($872c5e169d87e980$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $872c5e169d87e980$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $872c5e169d87e980$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $872c5e169d87e980$var$objectProtoNames;
}
// lib/router/navigation.ts
var $872c5e169d87e980$var$DEFAULT_NAVIGATION_URL = new URL("http://localhost");
function $872c5e169d87e980$var$getNavigatorCurrentUrl(navigator) {
    if (navigator.createURL) return navigator.createURL("/");
    try {
        return new URL(navigator.createHref("/"), $872c5e169d87e980$var$DEFAULT_NAVIGATION_URL);
    } catch  {
        return $872c5e169d87e980$var$DEFAULT_NAVIGATION_URL;
    }
}
function $872c5e169d87e980$var$isSameOrigin(a, b) {
    return a.origin === b.origin && (a.origin !== "null" || a.protocol === b.protocol && a.host === b.host);
}
function $872c5e169d87e980$var$isExplicitUrl(destination, target) {
    if (destination.startsWith("//")) return true;
    let protocol = target.protocol.toLowerCase();
    if (!destination.toLowerCase().startsWith(protocol)) return false;
    return target.host === "" || destination.slice(protocol.length).startsWith("//");
}
function $872c5e169d87e980$export$6c8e41f66e7aa990(original, resolved, currentUrl, externalPolicy) {
    let originalUrl = null;
    try {
        originalUrl = original == null ? null : new URL(original, currentUrl);
    } catch  {}
    let resolvedUrl = new URL(resolved, currentUrl);
    let originalIsExternal = originalUrl != null && !$872c5e169d87e980$var$isSameOrigin(originalUrl, currentUrl);
    let resolvedIsExternal = !$872c5e169d87e980$var$isSameOrigin(resolvedUrl, currentUrl);
    if (externalPolicy === "reject") {
        if (originalIsExternal || resolvedIsExternal) throw new Error("External navigation is not allowed");
    } else if (resolvedIsExternal) {
        if (originalUrl == null || !$872c5e169d87e980$var$isExplicitUrl(original, originalUrl) || !$872c5e169d87e980$var$isSameOrigin(originalUrl, resolvedUrl)) throw new Error("External navigation is not allowed");
    }
}
// lib/router/router.ts
var $872c5e169d87e980$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $872c5e169d87e980$var$validMutationMethods = new Set($872c5e169d87e980$var$validMutationMethodsArr);
var $872c5e169d87e980$var$validRequestMethodsArr = [
    "GET",
    ...$872c5e169d87e980$var$validMutationMethodsArr
];
var $872c5e169d87e980$var$validRequestMethods = new Set($872c5e169d87e980$var$validRequestMethodsArr);
var $872c5e169d87e980$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $872c5e169d87e980$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $872c5e169d87e980$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $872c5e169d87e980$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $872c5e169d87e980$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $872c5e169d87e980$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $872c5e169d87e980$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $872c5e169d87e980$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
var $872c5e169d87e980$var$_routes, $872c5e169d87e980$var$_branches, $872c5e169d87e980$var$_hmrRoutes, $872c5e169d87e980$var$_hmrBranches;
var $872c5e169d87e980$var$DataRoutes = class {
    constructor(routes){
        $872c5e169d87e980$var$__privateAdd(this, $872c5e169d87e980$var$_routes);
        $872c5e169d87e980$var$__privateAdd(this, $872c5e169d87e980$var$_branches);
        $872c5e169d87e980$var$__privateAdd(this, $872c5e169d87e980$var$_hmrRoutes);
        $872c5e169d87e980$var$__privateAdd(this, $872c5e169d87e980$var$_hmrBranches);
        $872c5e169d87e980$var$__privateSet(this, $872c5e169d87e980$var$_routes, routes);
        $872c5e169d87e980$var$__privateSet(this, $872c5e169d87e980$var$_branches, $872c5e169d87e980$var$flattenAndRankRoutes(routes));
    }
    /** The stable route tree */ get stableRoutes() {
        return $872c5e169d87e980$var$__privateGet(this, $872c5e169d87e980$var$_routes);
    }
    /** The in-flight route tree if one is active, otherwise the stable tree */ get activeRoutes() {
        return $872c5e169d87e980$var$__privateGet(this, $872c5e169d87e980$var$_hmrRoutes) ?? $872c5e169d87e980$var$__privateGet(this, $872c5e169d87e980$var$_routes);
    }
    /** Pre-computed branches */ get branches() {
        return $872c5e169d87e980$var$__privateGet(this, $872c5e169d87e980$var$_hmrBranches) ?? $872c5e169d87e980$var$__privateGet(this, $872c5e169d87e980$var$_branches);
    }
    get hasHMRRoutes() {
        return $872c5e169d87e980$var$__privateGet(this, $872c5e169d87e980$var$_hmrRoutes) != null;
    }
    /** Replace the stable route tree and recompute its branches */ setRoutes(routes) {
        $872c5e169d87e980$var$__privateSet(this, $872c5e169d87e980$var$_routes, routes);
        $872c5e169d87e980$var$__privateSet(this, $872c5e169d87e980$var$_branches, $872c5e169d87e980$var$flattenAndRankRoutes(routes));
    }
    /** Set a new in-flight route tree and recompute its branches */ setHmrRoutes(routes) {
        $872c5e169d87e980$var$__privateSet(this, $872c5e169d87e980$var$_hmrRoutes, routes);
        $872c5e169d87e980$var$__privateSet(this, $872c5e169d87e980$var$_hmrBranches, $872c5e169d87e980$var$flattenAndRankRoutes(routes));
    }
    /** Commit in-flight routes/branches to the stable slot and clear in-flight */ commitHmrRoutes() {
        if ($872c5e169d87e980$var$__privateGet(this, $872c5e169d87e980$var$_hmrRoutes)) {
            $872c5e169d87e980$var$__privateSet(this, $872c5e169d87e980$var$_routes, $872c5e169d87e980$var$__privateGet(this, $872c5e169d87e980$var$_hmrRoutes));
            $872c5e169d87e980$var$__privateSet(this, $872c5e169d87e980$var$_branches, $872c5e169d87e980$var$__privateGet(this, $872c5e169d87e980$var$_hmrBranches));
            $872c5e169d87e980$var$__privateSet(this, $872c5e169d87e980$var$_hmrRoutes, void 0);
            $872c5e169d87e980$var$__privateSet(this, $872c5e169d87e980$var$_hmrBranches, void 0);
        }
    }
};
$872c5e169d87e980$var$_routes = new WeakMap();
$872c5e169d87e980$var$_branches = new WeakMap();
$872c5e169d87e980$var$_hmrRoutes = new WeakMap();
$872c5e169d87e980$var$_hmrBranches = new WeakMap();
function $872c5e169d87e980$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $872c5e169d87e980$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $872c5e169d87e980$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.instrumentations) {
        let instrumentations = init.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$872c5e169d87e980$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = new $872c5e169d87e980$var$DataRoutes($872c5e169d87e980$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest));
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $872c5e169d87e980$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let bufferedInitialStateUpdate = null;
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $872c5e169d87e980$export$5c7b09132f833c25(dataRoutes.activeRoutes, init.history.location, basename, false, dataRoutes.branches);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $872c5e169d87e980$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $872c5e169d87e980$var$getShortCircuitMatches(dataRoutes.activeRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$872c5e169d87e980$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $872c5e169d87e980$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $872c5e169d87e980$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $872c5e169d87e980$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $872c5e169d87e980$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            $872c5e169d87e980$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$872c5e169d87e980$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(state.fetchers, key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        if (bufferedInitialStateUpdate) {
            let { newErrors: newErrors } = bufferedInitialStateUpdate;
            bufferedInitialStateUpdate = null;
            fn(state, {
                deletedFetchers: [],
                newErrors: newErrors,
                viewTransitionOpts: void 0,
                flushSync: false
            });
        }
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        if (subscribers.size === 0) bufferedInitialStateUpdate = {
            newErrors: newState.errors ?? null
        };
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(state.fetchers, key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $872c5e169d87e980$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $872c5e169d87e980$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $872c5e169d87e980$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $872c5e169d87e980$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */  && !isUninterruptedRevalidation && location !== state.location) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $872c5e169d87e980$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $872c5e169d87e980$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $872c5e169d87e980$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $872c5e169d87e980$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let maskPath;
        if (opts?.mask) {
            let partialPath = typeof opts.mask === "string" ? $872c5e169d87e980$export$8ccf933b0513f8d0(opts.mask) : {
                ...state.location.mask,
                ...opts.mask
            };
            maskPath = {
                pathname: partialPath.pathname ?? "",
                search: partialPath.search ?? "",
                hash: partialPath.hash ?? ""
            };
            if ($872c5e169d87e980$export$825a82322d91916e.test(maskPath.pathname)) throw new Error("External navigation is not allowed");
            else if (maskPath.pathname.startsWith("\\")) maskPath.pathname = maskPath.pathname.replace(/^\\+/, "/");
            $872c5e169d87e980$export$6c8e41f66e7aa990(typeof opts.mask === "string" ? opts.mask : $872c5e169d87e980$export$fe53371bee54353d(opts.mask), $872c5e169d87e980$export$fe53371bee54353d(maskPath), init.history.createURL("/"), "reject");
        }
        let currentLocation = state.location;
        let nextLocation = $872c5e169d87e980$var$createLocation(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        $872c5e169d87e980$export$6c8e41f66e7aa990(to == null ? init.history.createHref(state.location) : typeof to === "string" ? to : $872c5e169d87e980$export$fe53371bee54353d(to), init.history.createHref(nextLocation.mask || nextLocation), init.history.createURL("/"), "reject");
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $872c5e169d87e980$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $872c5e169d87e980$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $872c5e169d87e980$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $872c5e169d87e980$export$5c7b09132f833c25(routesToUse, location, basename, false, dataRoutes.branches);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $872c5e169d87e980$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $872c5e169d87e980$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        let loadingNavigation = opts && opts.overrideNavigation ? {
            ...opts.overrideNavigation,
            matches: matches,
            historyAction: historyAction
        } : void 0;
        pendingNavigationController = new AbortController();
        let request = $872c5e169d87e980$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $872c5e169d87e980$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $872c5e169d87e980$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $872c5e169d87e980$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($872c5e169d87e980$var$isErrorResult(result) && $872c5e169d87e980$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $872c5e169d87e980$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $872c5e169d87e980$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors, workingFetchers: workingFetchers } = await handleLoaders(request, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$872c5e169d87e980$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors,
            ...workingFetchers ? {
                fetchers: workingFetchers
            } : {}
        });
    }
    async function handleAction(request, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $872c5e169d87e980$var$getSubmittingNavigation(location, matches, historyAction, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $872c5e169d87e980$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $872c5e169d87e980$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $872c5e169d87e980$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $872c5e169d87e980$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $872c5e169d87e980$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, location, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($872c5e169d87e980$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $872c5e169d87e980$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($872c5e169d87e980$var$isErrorResult(result)) {
            let boundaryMatch = $872c5e169d87e980$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $872c5e169d87e980$var$getLoadingNavigation(location, matches, historyAction, submission);
        let activeSubmission = submission || fetcherSubmission || $872c5e169d87e980$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $872c5e169d87e980$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $872c5e169d87e980$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = dataRoutes.activeRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $872c5e169d87e980$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let workingFetchers2 = new Map(state.fetchers);
            let didUpdateFetcherRedirects2 = markFetchRedirectsDone(workingFetchers2);
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $872c5e169d87e980$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$872c5e169d87e980$var$getActionDataForCommit(pendingActionResult),
                ...didUpdateFetcherRedirects2 ? {
                    fetchers: workingFetchers2
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $872c5e169d87e980$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $872c5e169d87e980$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let workingFetchers = new Map(state.fetchers);
        let { loaderData: loaderData, errors: errors } = $872c5e169d87e980$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
        let shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                workingFetchers: workingFetchers
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$872c5e169d87e980$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        let workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = workingFetchers.get(rf.key);
            let revalidatingFetcher = $872c5e169d87e980$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let normalizedPath = $872c5e169d87e980$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $872c5e169d87e980$export$5c7b09132f833c25(routesToUse, normalizedPath, basename, false, dataRoutes.branches);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $872c5e169d87e980$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $872c5e169d87e980$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $872c5e169d87e980$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $872c5e169d87e980$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $872c5e169d87e980$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $872c5e169d87e980$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $872c5e169d87e980$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $872c5e169d87e980$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $872c5e169d87e980$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $872c5e169d87e980$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($872c5e169d87e980$var$isRedirectResult(actionResult) || $872c5e169d87e980$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $872c5e169d87e980$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($872c5e169d87e980$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $872c5e169d87e980$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $872c5e169d87e980$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($872c5e169d87e980$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $872c5e169d87e980$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = dataRoutes.activeRoutes;
        let matches = state.navigation.state !== "idle" ? $872c5e169d87e980$export$5c7b09132f833c25(routesToUse, state.navigation.location, basename, false, dataRoutes.branches) : state.matches;
        $872c5e169d87e980$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $872c5e169d87e980$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        let loadFetcher = $872c5e169d87e980$var$getLoadingFetcher(submission, actionResult.data);
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, loadFetcher);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = workingFetchers.get(staleKey);
            let revalidatingFetcher = $872c5e169d87e980$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            workingFetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: workingFetchers
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let fetcherIsMounted = state.fetchers.has(key);
        let getRedirectStateWithDoneFetcher = (s)=>{
            if (!fetcherIsMounted) return s;
            let workingFetchers2 = new Map(s.fetchers);
            workingFetchers2.set(key, $872c5e169d87e980$var$getDoneFetcher(actionResult.data));
            return {
                ...s,
                fetchers: workingFetchers2
            };
        };
        let redirect2 = $872c5e169d87e980$var$findRedirect(loaderResults);
        if (redirect2) {
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        redirect2 = $872c5e169d87e980$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let finalFetchers = new Map(state.fetchers);
        if (fetcherIsMounted) finalFetchers.set(key, $872c5e169d87e980$var$getDoneFetcher(actionResult.data));
        let { loaderData: loaderData, errors: errors } = $872c5e169d87e980$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers);
        abortStaleFetchLoads(loadId, finalFetchers);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $872c5e169d87e980$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: finalFetchers
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $872c5e169d87e980$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: finalFetchers
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $872c5e169d87e980$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $872c5e169d87e980$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $872c5e169d87e980$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $872c5e169d87e980$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $872c5e169d87e980$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, path, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (!result) {
            for (let match2 of matches)if (results[match2.route.id]) {
                result = results[match2.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $872c5e169d87e980$var$getDoneFetcher(void 0));
            return;
        }
        if ($872c5e169d87e980$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $872c5e169d87e980$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($872c5e169d87e980$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $872c5e169d87e980$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $872c5e169d87e980$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        let originalLocation = location;
        let currentUrl = new URL(request.url);
        location = $872c5e169d87e980$var$normalizeRedirectLocation(location, currentUrl, basename, init.history);
        $872c5e169d87e980$export$6c8e41f66e7aa990(originalLocation, location, currentUrl, "allow-explicit");
        let redirectLocation = $872c5e169d87e980$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser3) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($872c5e169d87e980$var$isAbsoluteUrl(location)) {
                const url = $872c5e169d87e980$var$createBrowserURLImpl(routerWindow, location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $872c5e169d87e980$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $872c5e169d87e980$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($872c5e169d87e980$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $872c5e169d87e980$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $872c5e169d87e980$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $872c5e169d87e980$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$872c5e169d87e980$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error" /* error */ ) break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error" /* error */ ,
                result: new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($872c5e169d87e980$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $872c5e169d87e980$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $872c5e169d87e980$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $872c5e169d87e980$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $872c5e169d87e980$var$findNearestBoundary(state.matches, routeId);
        let workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $872c5e169d87e980$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $872c5e169d87e980$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        for (let key of keys){
            let fetcher = fetchers.get(key);
            $872c5e169d87e980$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            let doneFetcher = $872c5e169d87e980$var$getDoneFetcher(fetcher.data);
            fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone(fetchers) {
        let doneKeys = [];
        let didUpdateFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = fetchers.get(key);
            $872c5e169d87e980$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                didUpdateFetchers = true;
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = fetchers.get(key);
            $872c5e169d87e980$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $872c5e169d87e980$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $872c5e169d87e980$export$386d57f03f0b2883;
        $872c5e169d87e980$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $872c5e169d87e980$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $872c5e169d87e980$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = dataRoutes.activeRoutes;
        let { matches: matches, route: route } = $872c5e169d87e980$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $872c5e169d87e980$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$872c5e169d87e980$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            let activeBranches = dataRoutes.branches;
            if (!matches) {
                let fogMatches = $872c5e169d87e980$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $872c5e169d87e980$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $872c5e169d87e980$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let activeBranches = dataRoutes.branches;
            let newMatches = $872c5e169d87e980$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, false, activeBranches);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $872c5e169d87e980$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $872c5e169d87e980$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes($872c5e169d87e980$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest));
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        $872c5e169d87e980$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        get branches () {
            return dataRoutes.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        createURL: (to)=>init.history.createURL(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = $872c5e169d87e980$var$instrumentClientSideRouter(router, init.instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $872c5e169d87e980$export$3336b097a6fbc59a(routes, opts) {
    $872c5e169d87e980$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $872c5e169d87e980$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    let future = {
        ...opts?.future
    };
    if (opts?.instrumentations) {
        let instrumentations = opts.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$872c5e169d87e980$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $872c5e169d87e980$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    let routeBranches = $872c5e169d87e980$var$flattenAndRankRoutes(dataRoutes);
    let matchCost = routeBranches.reduce((total, branch)=>total + branch.routesMeta.length, 0);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $872c5e169d87e980$var$defaultNormalizePath;
        let method = request.method;
        let location = $872c5e169d87e980$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $872c5e169d87e980$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $872c5e169d87e980$export$b8d3e69d4b3eff04();
        if (!$872c5e169d87e980$var$isValidMethod(method) && method !== "HEAD") {
            let error = $872c5e169d87e980$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $872c5e169d87e980$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $872c5e169d87e980$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $872c5e169d87e980$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $872c5e169d87e980$export$f5708dca728d7177(requestContext instanceof $872c5e169d87e980$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $872c5e169d87e980$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $872c5e169d87e980$var$runServerMiddlewarePipeline({
                    request: request,
                    url: $872c5e169d87e980$var$createDataFunctionUrl(request, location),
                    pattern: $872c5e169d87e980$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($872c5e169d87e980$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($872c5e169d87e980$export$6e80290866a84dd4(error)) return error;
                    if ($872c5e169d87e980$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $872c5e169d87e980$export$f2680fa305b734ca(error.status, error.statusText, await $872c5e169d87e980$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($872c5e169d87e980$export$e0163cfdf7bc9cfa(error)) error = $872c5e169d87e980$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $872c5e169d87e980$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $872c5e169d87e980$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $872c5e169d87e980$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $872c5e169d87e980$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $872c5e169d87e980$export$f5708dca728d7177($872c5e169d87e980$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($872c5e169d87e980$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($872c5e169d87e980$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $872c5e169d87e980$var$defaultNormalizePath;
        let method = request.method;
        let location = $872c5e169d87e980$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $872c5e169d87e980$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $872c5e169d87e980$export$b8d3e69d4b3eff04();
        if (!$872c5e169d87e980$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $872c5e169d87e980$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $872c5e169d87e980$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $872c5e169d87e980$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $872c5e169d87e980$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $872c5e169d87e980$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $872c5e169d87e980$export$f5708dca728d7177(requestContext instanceof $872c5e169d87e980$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $872c5e169d87e980$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $872c5e169d87e980$var$runServerMiddlewarePipeline({
                request: request,
                url: $872c5e169d87e980$var$createDataFunctionUrl(request, location),
                pattern: $872c5e169d87e980$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $872c5e169d87e980$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($872c5e169d87e980$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($872c5e169d87e980$var$dataWithResponseInitToResponse(error));
                if ($872c5e169d87e980$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($872c5e169d87e980$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $872c5e169d87e980$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($872c5e169d87e980$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, location, matches, routeMatch || $872c5e169d87e980$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $872c5e169d87e980$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($872c5e169d87e980$var$isDataStrategyResult(e) && $872c5e169d87e980$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($872c5e169d87e980$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $872c5e169d87e980$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $872c5e169d87e980$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $872c5e169d87e980$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($872c5e169d87e980$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($872c5e169d87e980$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($872c5e169d87e980$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $872c5e169d87e980$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $872c5e169d87e980$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($872c5e169d87e980$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $872c5e169d87e980$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $872c5e169d87e980$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $872c5e169d87e980$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $872c5e169d87e980$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $872c5e169d87e980$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $872c5e169d87e980$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $872c5e169d87e980$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, false);
                return $872c5e169d87e980$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $872c5e169d87e980$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $872c5e169d87e980$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $872c5e169d87e980$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $872c5e169d87e980$var$callDataStrategyImpl(dataStrategy || $872c5e169d87e980$var$defaultDataStrategy, request, location, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($872c5e169d87e980$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $872c5e169d87e980$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($872c5e169d87e980$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($872c5e169d87e980$export$e0163cfdf7bc9cfa(result.result)) throw $872c5e169d87e980$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $872c5e169d87e980$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        _matchCost: matchCost,
        _internalRouteBranches: routeBranches,
        query: query,
        queryRoute: queryRoute
    };
}
function $872c5e169d87e980$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $872c5e169d87e980$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $872c5e169d87e980$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $872c5e169d87e980$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $872c5e169d87e980$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $872c5e169d87e980$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $872c5e169d87e980$var$resolveTo(to ? to : ".", $872c5e169d87e980$var$getResolveToMatches(contextualMatches), $872c5e169d87e980$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $872c5e169d87e980$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $872c5e169d87e980$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $872c5e169d87e980$export$fe53371bee54353d(path);
}
function $872c5e169d87e980$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$872c5e169d87e980$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$872c5e169d87e980$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $872c5e169d87e980$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $872c5e169d87e980$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $872c5e169d87e980$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$872c5e169d87e980$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$872c5e169d87e980$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $872c5e169d87e980$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $872c5e169d87e980$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $872c5e169d87e980$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $872c5e169d87e980$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $872c5e169d87e980$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($872c5e169d87e980$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $872c5e169d87e980$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $872c5e169d87e980$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $872c5e169d87e980$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $872c5e169d87e980$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, branches, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $872c5e169d87e980$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $872c5e169d87e980$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $872c5e169d87e980$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$872c5e169d87e980$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad2 } = $872c5e169d87e980$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad2;
        } else if ($872c5e169d87e980$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $872c5e169d87e980$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($872c5e169d87e980$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $872c5e169d87e980$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $872c5e169d87e980$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $872c5e169d87e980$export$5c7b09132f833c25(routesToUse, f.path, basename ?? "/", false, branches);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $872c5e169d87e980$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $872c5e169d87e980$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $872c5e169d87e980$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $872c5e169d87e980$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($872c5e169d87e980$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $872c5e169d87e980$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $872c5e169d87e980$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $872c5e169d87e980$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$872c5e169d87e980$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $872c5e169d87e980$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $872c5e169d87e980$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $872c5e169d87e980$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $872c5e169d87e980$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $872c5e169d87e980$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$872c5e169d87e980$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $872c5e169d87e980$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $872c5e169d87e980$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes([
        ...dataRoutes.activeRoutes
    ]);
}
function $872c5e169d87e980$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$872c5e169d87e980$var$isSameRoute(aChild, bChild))) ?? false;
}
var $872c5e169d87e980$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $872c5e169d87e980$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $872c5e169d87e980$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $872c5e169d87e980$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $872c5e169d87e980$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $872c5e169d87e980$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $872c5e169d87e980$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $872c5e169d87e980$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $872c5e169d87e980$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $872c5e169d87e980$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $872c5e169d87e980$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $872c5e169d87e980$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $872c5e169d87e980$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $872c5e169d87e980$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $872c5e169d87e980$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $872c5e169d87e980$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $872c5e169d87e980$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $872c5e169d87e980$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $872c5e169d87e980$var$isNonNullable(value) {
    return value !== void 0;
}
function $872c5e169d87e980$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $872c5e169d87e980$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($872c5e169d87e980$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $872c5e169d87e980$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $872c5e169d87e980$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $872c5e169d87e980$var$defaultDataStrategy(args);
    return $872c5e169d87e980$var$runClientMiddlewarePipeline(args, ()=>$872c5e169d87e980$var$defaultDataStrategy(args));
}
function $872c5e169d87e980$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $872c5e169d87e980$var$runMiddlewarePipeline(args, handler, processResult, $872c5e169d87e980$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $872c5e169d87e980$export$e0163cfdf7bc9cfa(result) ? $872c5e169d87e980$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $872c5e169d87e980$var$runClientMiddlewarePipeline(args, handler) {
    return $872c5e169d87e980$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($872c5e169d87e980$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $872c5e169d87e980$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $872c5e169d87e980$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $872c5e169d87e980$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $872c5e169d87e980$var$callRouteMiddleware(dataFnArgs, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $872c5e169d87e980$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $872c5e169d87e980$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $872c5e169d87e980$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $872c5e169d87e980$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $872c5e169d87e980$var$loadLazyRoute(match.route, $872c5e169d87e980$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $872c5e169d87e980$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $872c5e169d87e980$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $872c5e169d87e980$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $872c5e169d87e980$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $872c5e169d87e980$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$872c5e169d87e980$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($872c5e169d87e980$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $872c5e169d87e980$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $872c5e169d87e980$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $872c5e169d87e980$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $872c5e169d87e980$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, $872c5e169d87e980$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $872c5e169d87e980$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        url: $872c5e169d87e980$var$createDataFunctionUrl(request, path),
        pattern: $872c5e169d87e980$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $872c5e169d87e980$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $872c5e169d87e980$var$callLoaderOrAction({ request: request, path: path, pattern: pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $872c5e169d87e980$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                url: $872c5e169d87e980$var$createDataFunctionUrl(request, path),
                pattern: pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $872c5e169d87e980$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $872c5e169d87e980$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $872c5e169d87e980$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $872c5e169d87e980$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($872c5e169d87e980$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $872c5e169d87e980$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $872c5e169d87e980$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($872c5e169d87e980$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $872c5e169d87e980$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $872c5e169d87e980$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $872c5e169d87e980$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($872c5e169d87e980$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $872c5e169d87e980$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $872c5e169d87e980$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$872c5e169d87e980$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $872c5e169d87e980$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
var $872c5e169d87e980$var$invalidProtocols = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    // eslint-disable-next-line no-script-url
    "javascript:"
];
function $872c5e169d87e980$export$961a3ef7a4da3a39(location) {
    try {
        return $872c5e169d87e980$var$invalidProtocols.includes(new URL(location).protocol);
    } catch  {
        return false;
    }
}
function $872c5e169d87e980$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ($872c5e169d87e980$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = $872c5e169d87e980$export$825a82322d91916e.test(normalizedLocation) ? new URL($872c5e169d87e980$var$normalizeProtocolRelativeUrl(normalizedLocation, currentUrl.protocol)) : new URL(normalizedLocation);
        if ($872c5e169d87e980$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
        let isSameBasename = $872c5e169d87e980$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $872c5e169d87e980$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if ($872c5e169d87e980$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $872c5e169d87e980$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($872c5e169d87e980$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $872c5e169d87e980$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $872c5e169d87e980$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $872c5e169d87e980$var$createDataFunctionUrl(request, path) {
    let url = new URL(request.url);
    let parsed = typeof path === "string" ? $872c5e169d87e980$export$8ccf933b0513f8d0(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        url.search = searchParams.size ? `?${searchParams.toString()}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
function $872c5e169d87e980$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $872c5e169d87e980$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $872c5e169d87e980$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $872c5e169d87e980$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $872c5e169d87e980$export$f5708dca728d7177(!$872c5e169d87e980$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($872c5e169d87e980$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $872c5e169d87e980$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $872c5e169d87e980$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $872c5e169d87e980$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $872c5e169d87e980$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    let { loaderData: loaderData, errors: errors } = $872c5e169d87e980$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $872c5e169d87e980$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($872c5e169d87e980$var$isErrorResult(result)) {
            let boundaryMatch = $872c5e169d87e980$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            workingFetchers.delete(key);
        } else if ($872c5e169d87e980$var$isRedirectResult(result)) $872c5e169d87e980$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $872c5e169d87e980$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $872c5e169d87e980$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $872c5e169d87e980$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $872c5e169d87e980$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $872c5e169d87e980$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $872c5e169d87e980$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $872c5e169d87e980$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $872c5e169d87e980$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $872c5e169d87e980$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $872c5e169d87e980$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($872c5e169d87e980$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $872c5e169d87e980$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $872c5e169d87e980$export$8ccf933b0513f8d0(path) : path;
    return $872c5e169d87e980$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $872c5e169d87e980$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $872c5e169d87e980$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $872c5e169d87e980$var$dataWithResponseInitToErrorResponse(data2) {
    return new $872c5e169d87e980$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $872c5e169d87e980$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $872c5e169d87e980$var$isDataStrategyResult(value));
}
function $872c5e169d87e980$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $872c5e169d87e980$var$isRedirectDataStrategyResult(result) {
    return $872c5e169d87e980$export$3f1eb41d9a6a6a27(result.result) && $872c5e169d87e980$var$redirectStatusCodes.has(result.result.status);
}
function $872c5e169d87e980$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $872c5e169d87e980$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $872c5e169d87e980$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $872c5e169d87e980$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $872c5e169d87e980$export$794b2760043cf8cd(statusCode) {
    return $872c5e169d87e980$var$redirectStatusCodes.has(statusCode);
}
function $872c5e169d87e980$export$6e80290866a84dd4(result) {
    return $872c5e169d87e980$export$3f1eb41d9a6a6a27(result) && $872c5e169d87e980$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $872c5e169d87e980$var$isValidMethod(method) {
    return $872c5e169d87e980$var$validRequestMethods.has(method.toUpperCase());
}
function $872c5e169d87e980$export$cbae47800eb95bc3(method) {
    return $872c5e169d87e980$var$validMutationMethods.has(method.toUpperCase());
}
function $872c5e169d87e980$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $872c5e169d87e980$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $872c5e169d87e980$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $872c5e169d87e980$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $872c5e169d87e980$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $872c5e169d87e980$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $872c5e169d87e980$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $872c5e169d87e980$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $872c5e169d87e980$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $872c5e169d87e980$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $872c5e169d87e980$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $872c5e169d87e980$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($872c5e169d87e980$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $872c5e169d87e980$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($872c5e169d87e980$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $872c5e169d87e980$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $872c5e169d87e980$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $872c5e169d87e980$export$2eeee58951ff3c1c = $iQhxf.createContext(null);
$872c5e169d87e980$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $872c5e169d87e980$export$315e3ffb01f217 = $iQhxf.createContext(null);
$872c5e169d87e980$export$315e3ffb01f217.displayName = "DataRouterState";
var $872c5e169d87e980$export$717f757c655223f1 = $iQhxf.createContext(false);
function $872c5e169d87e980$var$useIsRSCRouterContext() {
    return $iQhxf.useContext($872c5e169d87e980$export$717f757c655223f1);
}
var $872c5e169d87e980$export$3681f408decb40d1 = $iQhxf.createContext({
    isTransitioning: false
});
$872c5e169d87e980$export$3681f408decb40d1.displayName = "ViewTransition";
var $872c5e169d87e980$export$cb3f1df1bef00a39 = $iQhxf.createContext(/* @__PURE__ */ new Map());
$872c5e169d87e980$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $872c5e169d87e980$var$AwaitContext = $iQhxf.createContext(null);
$872c5e169d87e980$var$AwaitContext.displayName = "Await";
var $872c5e169d87e980$export$2666c20e15407622 = (props)=>$iQhxf.createElement($872c5e169d87e980$var$AwaitContext.Provider, props);
var $872c5e169d87e980$export$3044ab7fdabeaee6 = $iQhxf.createContext(null);
$872c5e169d87e980$export$3044ab7fdabeaee6.displayName = "Navigation";
var $872c5e169d87e980$export$e6a44b110a0c44d3 = $iQhxf.createContext(null);
$872c5e169d87e980$export$e6a44b110a0c44d3.displayName = "Location";
var $872c5e169d87e980$export$aac280ed165a4397 = $iQhxf.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$872c5e169d87e980$export$aac280ed165a4397.displayName = "Route";
var $872c5e169d87e980$var$RouteErrorContext = $iQhxf.createContext(null);
$872c5e169d87e980$var$RouteErrorContext.displayName = "RouteError";
var $872c5e169d87e980$export$945fecf35a8ef089 = true;
// lib/errors.ts
var $872c5e169d87e980$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $872c5e169d87e980$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $872c5e169d87e980$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $872c5e169d87e980$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$872c5e169d87e980$var$ERROR_DIGEST_BASE}:${$872c5e169d87e980$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $872c5e169d87e980$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$872c5e169d87e980$var$ERROR_DIGEST_BASE}:${$872c5e169d87e980$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new $872c5e169d87e980$export$f2680fa305b734ca(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}
// lib/hooks.tsx
function $872c5e169d87e980$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $872c5e169d87e980$export$f5708dca728d7177($872c5e169d87e980$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $iQhxf.useContext($872c5e169d87e980$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $872c5e169d87e980$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $872c5e169d87e980$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $872c5e169d87e980$export$9c954a9d03d32f4a() {
    return $iQhxf.useContext($872c5e169d87e980$export$e6a44b110a0c44d3) != null;
}
function $872c5e169d87e980$export$45d76561a5302f2b() {
    $872c5e169d87e980$export$f5708dca728d7177($872c5e169d87e980$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $iQhxf.useContext($872c5e169d87e980$export$e6a44b110a0c44d3).location;
}
function $872c5e169d87e980$export$1b3f31771c5d07c() {
    return $iQhxf.useContext($872c5e169d87e980$export$e6a44b110a0c44d3).navigationType;
}
function $872c5e169d87e980$export$6c330e8992e8a295(pattern) {
    $872c5e169d87e980$export$f5708dca728d7177($872c5e169d87e980$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $872c5e169d87e980$export$45d76561a5302f2b();
    return $iQhxf.useMemo(()=>$872c5e169d87e980$export$81336c211d5ff295(pattern, $872c5e169d87e980$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $872c5e169d87e980$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $872c5e169d87e980$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $iQhxf.useContext($872c5e169d87e980$export$3044ab7fdabeaee6).static;
    if (!isStatic) $iQhxf.useLayoutEffect(cb);
}
function $872c5e169d87e980$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $iQhxf.useContext($872c5e169d87e980$export$aac280ed165a4397);
    return isDataRoute ? $872c5e169d87e980$var$useNavigateStable() : $872c5e169d87e980$var$useNavigateUnstable();
}
function $872c5e169d87e980$var$useNavigateUnstable() {
    $872c5e169d87e980$export$f5708dca728d7177($872c5e169d87e980$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $iQhxf.useContext($872c5e169d87e980$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $iQhxf.useContext($872c5e169d87e980$export$3044ab7fdabeaee6);
    let { matches: matches } = $iQhxf.useContext($872c5e169d87e980$export$aac280ed165a4397);
    let { pathname: locationPathname } = $872c5e169d87e980$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($872c5e169d87e980$var$getResolveToMatches(matches));
    let activeRef = $iQhxf.useRef(false);
    $872c5e169d87e980$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $iQhxf.useCallback((to, options = {})=>{
        $872c5e169d87e980$var$warning(activeRef.current, $872c5e169d87e980$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $872c5e169d87e980$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $872c5e169d87e980$var$joinPaths([
            basename,
            path.pathname
        ]);
        $872c5e169d87e980$export$6c8e41f66e7aa990(typeof to === "string" ? to : $872c5e169d87e980$export$fe53371bee54353d(to), navigator.createHref(path), $872c5e169d87e980$var$getNavigatorCurrentUrl(navigator), "reject");
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $872c5e169d87e980$var$OutletContext = $iQhxf.createContext(null);
function $872c5e169d87e980$export$4138103a3ae699cc() {
    return $iQhxf.useContext($872c5e169d87e980$var$OutletContext);
}
function $872c5e169d87e980$export$a3be3530d8e40d0b(context) {
    let outlet = $iQhxf.useContext($872c5e169d87e980$export$aac280ed165a4397).outlet;
    return $iQhxf.useMemo(()=>outlet && /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $872c5e169d87e980$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $iQhxf.useContext($872c5e169d87e980$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch?.params ?? {};
}
function $872c5e169d87e980$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $iQhxf.useContext($872c5e169d87e980$export$aac280ed165a4397);
    let { pathname: locationPathname } = $872c5e169d87e980$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($872c5e169d87e980$var$getResolveToMatches(matches));
    return $iQhxf.useMemo(()=>$872c5e169d87e980$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $872c5e169d87e980$export$5d3fca4a98652595(routes, locationArg) {
    return $872c5e169d87e980$var$useRoutesImpl(routes, locationArg);
}
function $872c5e169d87e980$var$useRoutesImpl(routes, locationArg, dataRouterOpts) {
    $872c5e169d87e980$export$f5708dca728d7177($872c5e169d87e980$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $iQhxf.useContext($872c5e169d87e980$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $iQhxf.useContext($872c5e169d87e980$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($872c5e169d87e980$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $872c5e169d87e980$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $872c5e169d87e980$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $872c5e169d87e980$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $872c5e169d87e980$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = dataRouterOpts && dataRouterOpts.state.matches.length ? // If we're in a data router, use the matches we've already identified but ensure
    // we have the latest route instances from the manifest in case elements have changed
    dataRouterOpts.state.matches.map((m)=>Object.assign(m, {
            route: dataRouterOpts.manifest[m.route.id] || m.route
        })) : $872c5e169d87e980$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($872c5e169d87e980$export$945fecf35a8ef089) {
        $872c5e169d87e980$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $872c5e169d87e980$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $872c5e169d87e980$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $872c5e169d87e980$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $872c5e169d87e980$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0,
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $872c5e169d87e980$var$DefaultErrorComponent() {
    let error = $872c5e169d87e980$export$ed527bf60f6e05f2();
    let message = $872c5e169d87e980$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($872c5e169d87e980$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $iQhxf.createElement($iQhxf.Fragment, null, /* @__PURE__ */ $iQhxf.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $iQhxf.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $iQhxf.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $iQhxf.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $iQhxf.createElement($iQhxf.Fragment, null, /* @__PURE__ */ $iQhxf.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $iQhxf.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $iQhxf.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $872c5e169d87e980$var$defaultErrorElement = /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$var$DefaultErrorComponent, null);
var $872c5e169d87e980$var$RenderErrorBoundary = class extends $iQhxf.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = $872c5e169d87e980$export$2b5950305b3e7eaf(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$var$RouteErrorContext.Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
$872c5e169d87e980$var$RenderErrorBoundary.contextType = $872c5e169d87e980$export$717f757c655223f1;
var $872c5e169d87e980$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $872c5e169d87e980$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename, navigator: navigator } = $iQhxf.useContext($872c5e169d87e980$export$3044ab7fdabeaee6);
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect2 = $872c5e169d87e980$export$30db792b333fd2ee(error.digest);
        if (redirect2) {
            let existingRedirect = $872c5e169d87e980$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = $872c5e169d87e980$var$parseToInfo(redirect2.location, basename);
            let target = parsed.absoluteURL || parsed.to;
            $872c5e169d87e980$export$6c8e41f66e7aa990(redirect2.location, target, $872c5e169d87e980$var$getNavigatorCurrentUrl(navigator), "allow-explicit");
            if ($872c5e169d87e980$export$961a3ef7a4da3a39(target)) throw new Error("Invalid redirect location");
            if ($872c5e169d87e980$var$isBrowser && !$872c5e169d87e980$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = target;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        }));
                    $872c5e169d87e980$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $iQhxf.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${target}`
            });
        }
    }
    return children;
}
function $872c5e169d87e980$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $iQhxf.useContext($872c5e169d87e980$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $872c5e169d87e980$var$_renderMatches(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $872c5e169d87e980$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors2 } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            pattern: $872c5e169d87e980$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $872c5e169d87e980$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $872c5e169d87e980$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $iQhxf.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $872c5e169d87e980$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $872c5e169d87e980$var$useDataRouterContext(hookName) {
    let ctx = $iQhxf.useContext($872c5e169d87e980$export$2eeee58951ff3c1c);
    $872c5e169d87e980$export$f5708dca728d7177(ctx, $872c5e169d87e980$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $872c5e169d87e980$var$useDataRouterState(hookName) {
    let state = $iQhxf.useContext($872c5e169d87e980$export$315e3ffb01f217);
    $872c5e169d87e980$export$f5708dca728d7177(state, $872c5e169d87e980$var$getDataRouterConsoleError(hookName));
    return state;
}
function $872c5e169d87e980$var$useRouteContext(hookName) {
    let route = $iQhxf.useContext($872c5e169d87e980$export$aac280ed165a4397);
    $872c5e169d87e980$export$f5708dca728d7177(route, $872c5e169d87e980$var$getDataRouterConsoleError(hookName));
    return route;
}
function $872c5e169d87e980$var$useCurrentRouteId(hookName) {
    let route = $872c5e169d87e980$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $872c5e169d87e980$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $872c5e169d87e980$var$useRouteId() {
    return $872c5e169d87e980$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $872c5e169d87e980$export$d0fd4b7106de2769() {
    let state = $872c5e169d87e980$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return $iQhxf.useMemo(()=>{
        let { matches: matches, historyAction: historyAction, ...rest } = state.navigation;
        return rest;
    }, [
        state.navigation
    ]);
}
function $872c5e169d87e980$export$600dc272ed516c15() {
    let dataRouterContext = $872c5e169d87e980$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $872c5e169d87e980$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $iQhxf.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $iQhxf.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $872c5e169d87e980$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $872c5e169d87e980$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $iQhxf.useMemo(()=>matches.map((m)=>$872c5e169d87e980$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $872c5e169d87e980$export$1448a5050d252c4d() {
    let state = $872c5e169d87e980$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $872c5e169d87e980$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $872c5e169d87e980$export$fd5d37484eab868d(routeId) {
    let state = $872c5e169d87e980$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $872c5e169d87e980$export$fdc00f3f26066d5e() {
    let state = $872c5e169d87e980$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $872c5e169d87e980$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $872c5e169d87e980$export$ed527bf60f6e05f2() {
    let error = $iQhxf.useContext($872c5e169d87e980$var$RouteErrorContext);
    let state = $872c5e169d87e980$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $872c5e169d87e980$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $872c5e169d87e980$export$78a72ddb39bdd145() {
    let value = $iQhxf.useContext($872c5e169d87e980$var$AwaitContext);
    return value?._data;
}
function $872c5e169d87e980$export$17f53340677d5831() {
    let value = $iQhxf.useContext($872c5e169d87e980$var$AwaitContext);
    return value?._error;
}
var $872c5e169d87e980$var$blockerId = 0;
function $872c5e169d87e980$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $872c5e169d87e980$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $872c5e169d87e980$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $iQhxf.useState("");
    let blockerFunction = $iQhxf.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $872c5e169d87e980$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $872c5e169d87e980$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $iQhxf.useEffect(()=>{
        let key = String(++$872c5e169d87e980$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $iQhxf.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $872c5e169d87e980$export$386d57f03f0b2883;
}
function $872c5e169d87e980$var$useNavigateStable() {
    let { router: router } = $872c5e169d87e980$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $872c5e169d87e980$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $iQhxf.useRef(false);
    $872c5e169d87e980$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $iQhxf.useCallback(async (to, options = {})=>{
        $872c5e169d87e980$var$warning(activeRef.current, $872c5e169d87e980$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $872c5e169d87e980$var$alreadyWarned = {};
function $872c5e169d87e980$var$warningOnce(key, cond, message) {
    if (!cond && !$872c5e169d87e980$var$alreadyWarned[key]) {
        $872c5e169d87e980$var$alreadyWarned[key] = true;
        $872c5e169d87e980$var$warning(false, message);
    }
}
function $872c5e169d87e980$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $872c5e169d87e980$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $872c5e169d87e980$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
function $872c5e169d87e980$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
function $872c5e169d87e980$export$dbb5ccc270afbbb4() {
    let { location: location, historyAction: type, matches: matches, navigation: navigation } = $872c5e169d87e980$var$useDataRouterState("unstable_useRouterState" /* UseRouterState */ );
    let active = $iQhxf.useMemo(()=>({
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: matches[matches.length - 1]?.params ?? {},
            matches: matches.map((m)=>$872c5e169d87e980$var$toRouterStateMatch(m))
        }), [
        location,
        matches,
        type
    ]);
    let pending = $iQhxf.useMemo(()=>{
        if (navigation.state === "idle") return null;
        let shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: navigation.matches[navigation.matches.length - 1]?.params ?? {},
            matches: navigation.matches.map((m)=>$872c5e169d87e980$var$toRouterStateMatch(m))
        };
        return navigation.state === "loading" ? {
            ...shared,
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        } : {
            ...shared,
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        };
    }, [
        navigation
    ]);
    return $iQhxf.useMemo(()=>({
            active: active,
            pending: pending
        }), [
        active,
        pending
    ]);
}
// lib/server-runtime/warnings.ts
var $872c5e169d87e980$var$alreadyWarned2 = {};
function $872c5e169d87e980$export$5b28268982f175ba(condition, message) {
    if (!condition && !$872c5e169d87e980$var$alreadyWarned2[message]) {
        $872c5e169d87e980$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $872c5e169d87e980$var$USE_OPTIMISTIC = "useOptimistic";
var $872c5e169d87e980$var$useOptimisticImpl = $iQhxf[$872c5e169d87e980$var$USE_OPTIMISTIC];
var $872c5e169d87e980$var$stableUseOptimisticSetter = ()=>void 0;
function $872c5e169d87e980$var$useOptimisticSafe(val) {
    if ($872c5e169d87e980$var$useOptimisticImpl) return $872c5e169d87e980$var$useOptimisticImpl(val);
    else return [
        val,
        $872c5e169d87e980$var$stableUseOptimisticSetter
    ];
}
function $872c5e169d87e980$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($872c5e169d87e980$export$945fecf35a8ef089) {
            if (route.element) $872c5e169d87e980$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $iQhxf.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($872c5e169d87e980$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $872c5e169d87e980$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $iQhxf.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($872c5e169d87e980$export$945fecf35a8ef089) {
            if (route.errorElement) $872c5e169d87e980$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $iQhxf.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $872c5e169d87e980$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $872c5e169d87e980$export$f30f7e456d254e83(routes, opts) {
    return $872c5e169d87e980$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $872c5e169d87e980$export$2b76ad033c6e6d08({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $872c5e169d87e980$export$e2fd2c03906469db,
        mapRouteProperties: $872c5e169d87e980$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        instrumentations: opts?.instrumentations
    }).initialize();
}
var $872c5e169d87e980$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $872c5e169d87e980$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, useTransitions: useTransitions }) {
    let unstable_rsc = $872c5e169d87e980$var$useIsRSCRouterContext();
    useTransitions = unstable_rsc || useTransitions;
    let [_state, setStateImpl] = $iQhxf.useState(router.state);
    let [state, setOptimisticState] = $872c5e169d87e980$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $iQhxf.useState();
    let [vtContext, setVtContext] = $iQhxf.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $iQhxf.useState();
    let [transition, setTransition] = $iQhxf.useState();
    let [interruption, setInterruption] = $iQhxf.useState();
    let fetcherData = $iQhxf.useRef(/* @__PURE__ */ new Map());
    let setState = $iQhxf.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                pattern: $872c5e169d87e980$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $872c5e169d87e980$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $872c5e169d87e980$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (useTransitions === false) setStateImpl(newState);
            else $iQhxf.startTransition(()=>{
                if (useTransitions === true) setOptimisticState((s)=>$872c5e169d87e980$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $iQhxf.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $iQhxf.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $872c5e169d87e980$var$Deferred());
    }, [
        vtContext
    ]);
    $iQhxf.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (useTransitions === false) setStateImpl(newState);
                else $iQhxf.startTransition(()=>{
                    if (useTransitions === true) setOptimisticState((s)=>$872c5e169d87e980$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $iQhxf.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $iQhxf.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $iQhxf.useMemo(()=>{
        return {
            createHref: router.createHref,
            createURL: router.createURL,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $iQhxf.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $iQhxf.createElement($iQhxf.Fragment, null, /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $872c5e169d87e980$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $872c5e169d87e980$var$MemoizedDataRoutes = $iQhxf.memo($872c5e169d87e980$var$DataRoutes2);
function $872c5e169d87e980$var$DataRoutes2({ routes: routes, manifest: manifest, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return $872c5e169d87e980$var$useRoutesImpl(routes, void 0, {
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
function $872c5e169d87e980$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, useTransitions: useTransitions }) {
    let historyRef = $iQhxf.useRef();
    if (historyRef.current == null) historyRef.current = $872c5e169d87e980$export$2b76ad033c6e6d08({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $iQhxf.useState({
        action: history.action,
        location: history.location
    });
    let setState = $iQhxf.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $iQhxf.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $iQhxf.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $872c5e169d87e980$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $872c5e169d87e980$export$f5708dca728d7177($872c5e169d87e980$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic, navigator: navigator } = $iQhxf.useContext($872c5e169d87e980$export$3044ab7fdabeaee6);
    $872c5e169d87e980$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $iQhxf.useContext($872c5e169d87e980$export$aac280ed165a4397);
    let { pathname: locationPathname } = $872c5e169d87e980$export$45d76561a5302f2b();
    let navigate = $872c5e169d87e980$export$9770f232ac06a008();
    let path = $872c5e169d87e980$var$resolveTo(to, $872c5e169d87e980$var$getResolveToMatches(matches), locationPathname, relative === "path");
    $872c5e169d87e980$export$6c8e41f66e7aa990(typeof to === "string" ? to : $872c5e169d87e980$export$fe53371bee54353d(to), navigator.createHref(path), $872c5e169d87e980$var$getNavigatorCurrentUrl(navigator), "reject");
    let jsonPath = JSON.stringify(path);
    $iQhxf.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $872c5e169d87e980$export$910ae8079b2c2852(props) {
    return $872c5e169d87e980$export$a3be3530d8e40d0b(props.context);
}
function $872c5e169d87e980$export$e7b0ac011bb776c6(props) {
    $872c5e169d87e980$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $872c5e169d87e980$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, useTransitions: useTransitions }) {
    $872c5e169d87e980$export$f5708dca728d7177(!$872c5e169d87e980$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $iQhxf.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $872c5e169d87e980$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", mask: mask } = locationProp;
    let locationContext = $iQhxf.useMemo(()=>{
        let trailingPathname = $872c5e169d87e980$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    $872c5e169d87e980$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $872c5e169d87e980$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $872c5e169d87e980$export$5d3fca4a98652595($872c5e169d87e980$export$16da398f5434bdec(children), location);
}
function $872c5e169d87e980$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $iQhxf.useContext($872c5e169d87e980$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $iQhxf.useContext($872c5e169d87e980$export$315e3ffb01f217);
    let onError = $iQhxf.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            pattern: $872c5e169d87e980$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$var$ResolveAwait, null, children));
}
var $872c5e169d87e980$var$AwaitErrorBoundary = class extends $iQhxf.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $872c5e169d87e980$var$ResolveAwait({ children: children }) {
    let data2 = $872c5e169d87e980$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $iQhxf.createElement($iQhxf.Fragment, null, toRender);
}
function $872c5e169d87e980$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $iQhxf.Children.forEach(children, (element, index)=>{
        if (!$iQhxf.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $iQhxf.Fragment) {
            routes.push.apply(routes, $872c5e169d87e980$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $872c5e169d87e980$export$f5708dca728d7177(element.type === $872c5e169d87e980$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $872c5e169d87e980$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $872c5e169d87e980$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $872c5e169d87e980$export$9b5b6d122dea0c88 = $872c5e169d87e980$export$16da398f5434bdec;
function $872c5e169d87e980$export$daf73786167a7f72(matches) {
    return $872c5e169d87e980$var$_renderMatches(matches);
}
function $872c5e169d87e980$var$useRouteComponentProps() {
    return {
        params: $872c5e169d87e980$export$99eaa27ddbbb95ef(),
        loaderData: $872c5e169d87e980$export$1448a5050d252c4d(),
        actionData: $872c5e169d87e980$export$fdc00f3f26066d5e(),
        matches: $872c5e169d87e980$export$2378eb7f5ff86053()
    };
}
function $872c5e169d87e980$export$6c4f3826290c37af({ children: children }) {
    const props = $872c5e169d87e980$var$useRouteComponentProps();
    return $iQhxf.cloneElement(children, props);
}
function $872c5e169d87e980$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $872c5e169d87e980$var$useRouteComponentProps();
        return $iQhxf.createElement(Component4, props);
    };
}
function $872c5e169d87e980$var$useHydrateFallbackProps() {
    return {
        params: $872c5e169d87e980$export$99eaa27ddbbb95ef(),
        loaderData: $872c5e169d87e980$export$1448a5050d252c4d(),
        actionData: $872c5e169d87e980$export$fdc00f3f26066d5e()
    };
}
function $872c5e169d87e980$export$f8cff34f39c1932a({ children: children }) {
    const props = $872c5e169d87e980$var$useHydrateFallbackProps();
    return $iQhxf.cloneElement(children, props);
}
function $872c5e169d87e980$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $872c5e169d87e980$var$useHydrateFallbackProps();
        return $iQhxf.createElement(HydrateFallback, props);
    };
}
function $872c5e169d87e980$var$useErrorBoundaryProps() {
    return {
        params: $872c5e169d87e980$export$99eaa27ddbbb95ef(),
        loaderData: $872c5e169d87e980$export$1448a5050d252c4d(),
        actionData: $872c5e169d87e980$export$fdc00f3f26066d5e(),
        error: $872c5e169d87e980$export$ed527bf60f6e05f2()
    };
}
function $872c5e169d87e980$export$e5afde5c4b6d747b({ children: children }) {
    const props = $872c5e169d87e980$var$useErrorBoundaryProps();
    return $iQhxf.cloneElement(children, props);
}
function $872c5e169d87e980$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $872c5e169d87e980$var$useErrorBoundaryProps();
        return $iQhxf.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $872c5e169d87e980$var$defaultMethod = "get";
var $872c5e169d87e980$var$defaultEncType = "application/x-www-form-urlencoded";
function $872c5e169d87e980$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $872c5e169d87e980$var$isButtonElement(object) {
    return $872c5e169d87e980$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $872c5e169d87e980$var$isFormElement(object) {
    return $872c5e169d87e980$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $872c5e169d87e980$var$isInputElement(object) {
    return $872c5e169d87e980$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $872c5e169d87e980$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $872c5e169d87e980$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$872c5e169d87e980$var$isModifiedEvent(event);
}
function $872c5e169d87e980$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $872c5e169d87e980$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $872c5e169d87e980$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $872c5e169d87e980$var$_formDataSupportsSubmitter = null;
function $872c5e169d87e980$var$isFormDataSubmitterSupported() {
    if ($872c5e169d87e980$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $872c5e169d87e980$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $872c5e169d87e980$var$_formDataSupportsSubmitter = true;
    }
    return $872c5e169d87e980$var$_formDataSupportsSubmitter;
}
var $872c5e169d87e980$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $872c5e169d87e980$var$getFormEncType(encType) {
    if (encType != null && !$872c5e169d87e980$var$supportedFormEncTypes.has(encType)) {
        $872c5e169d87e980$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$872c5e169d87e980$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $872c5e169d87e980$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($872c5e169d87e980$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $872c5e169d87e980$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $872c5e169d87e980$var$defaultMethod;
        encType = $872c5e169d87e980$var$getFormEncType(target.getAttribute("enctype")) || $872c5e169d87e980$var$defaultEncType;
        formData = new FormData(target);
    } else if ($872c5e169d87e980$var$isButtonElement(target) || $872c5e169d87e980$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $872c5e169d87e980$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $872c5e169d87e980$var$defaultMethod;
        encType = $872c5e169d87e980$var$getFormEncType(target.getAttribute("formenctype")) || $872c5e169d87e980$var$getFormEncType(form.getAttribute("enctype")) || $872c5e169d87e980$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$872c5e169d87e980$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($872c5e169d87e980$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $872c5e169d87e980$var$defaultMethod;
        action = null;
        encType = $872c5e169d87e980$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $872c5e169d87e980$var$HOLE = -1;
var $872c5e169d87e980$var$NAN = -2;
var $872c5e169d87e980$var$NEGATIVE_INFINITY = -3;
var $872c5e169d87e980$var$NEGATIVE_ZERO = -4;
var $872c5e169d87e980$var$NULL = -5;
var $872c5e169d87e980$var$POSITIVE_INFINITY = -6;
var $872c5e169d87e980$var$UNDEFINED = -7;
var $872c5e169d87e980$var$TYPE_BIGINT = "B";
var $872c5e169d87e980$var$TYPE_DATE = "D";
var $872c5e169d87e980$var$TYPE_ERROR = "E";
var $872c5e169d87e980$var$TYPE_MAP = "M";
var $872c5e169d87e980$var$TYPE_NULL_OBJECT = "N";
var $872c5e169d87e980$var$TYPE_PROMISE = "P";
var $872c5e169d87e980$var$TYPE_REGEXP = "R";
var $872c5e169d87e980$var$TYPE_SET = "S";
var $872c5e169d87e980$var$TYPE_SYMBOL = "Y";
var $872c5e169d87e980$var$TYPE_URL = "U";
var $872c5e169d87e980$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $872c5e169d87e980$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $872c5e169d87e980$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
var $872c5e169d87e980$var$TIME_LIMIT_MS = 1;
var $872c5e169d87e980$var$getNow = ()=>Date.now();
var $872c5e169d87e980$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $872c5e169d87e980$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $872c5e169d87e980$var$UNDEFINED;
    if (input === null) return $872c5e169d87e980$var$NULL;
    if (Number.isNaN(input)) return $872c5e169d87e980$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $872c5e169d87e980$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $872c5e169d87e980$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $872c5e169d87e980$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $872c5e169d87e980$var$stringify.call(this, stack);
    return index;
}
async function $872c5e169d87e980$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $872c5e169d87e980$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return $872c5e169d87e980$var$UNDEFINED;
        if (value === null) return $872c5e169d87e980$var$NULL;
        if (Number.isNaN(value)) return $872c5e169d87e980$var$NAN;
        if (value === Number.POSITIVE_INFINITY) return $872c5e169d87e980$var$POSITIVE_INFINITY;
        if (value === Number.NEGATIVE_INFINITY) return $872c5e169d87e980$var$NEGATIVE_INFINITY;
        if (value === 0 && 1 / value < 0) return $872c5e169d87e980$var$NEGATIVE_ZERO;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $872c5e169d87e980$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $872c5e169d87e980$var$TIME_LIMIT_MS) {
            await $872c5e169d87e980$var$yieldToMain();
            lastYieldTime = $872c5e169d87e980$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["${$872c5e169d87e980$var$TYPE_BIGINT}","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["${$872c5e169d87e980$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `${$872c5e169d87e980$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i2 = 0; i2 < input.length; i2++)result += (i2 ? "," : "") + (i2 in input ? flattenValue(input[i2]) : $872c5e169d87e980$var$HOLE);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["${$872c5e169d87e980$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["${$872c5e169d87e980$var$TYPE_URL}",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["${$872c5e169d87e980$var$TYPE_REGEXP}",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["${$872c5e169d87e980$var$TYPE_SET}",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["${$872c5e169d87e980$var$TYPE_SET}"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["${$872c5e169d87e980$var$TYPE_MAP}",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["${$872c5e169d87e980$var$TYPE_MAP}"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["${$872c5e169d87e980$var$TYPE_PROMISE}",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["${$872c5e169d87e980$var$TYPE_ERROR}",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["${$872c5e169d87e980$var$TYPE_NULL_OBJECT}",{${partsForObj(input)}}]`;
                        else if ($872c5e169d87e980$var$isPlainObject2(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $872c5e169d87e980$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $872c5e169d87e980$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $872c5e169d87e980$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $872c5e169d87e980$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $872c5e169d87e980$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $872c5e169d87e980$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $872c5e169d87e980$var$hydrate.call(this, startIndex);
}
function $872c5e169d87e980$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $872c5e169d87e980$var$UNDEFINED:
                set(void 0);
                continue;
            case $872c5e169d87e980$var$NULL:
                set(null);
                continue;
            case $872c5e169d87e980$var$NAN:
                set(NaN);
                continue;
            case $872c5e169d87e980$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $872c5e169d87e980$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $872c5e169d87e980$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        $872c5e169d87e980$var$validateIndex(index2, values.length);
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $872c5e169d87e980$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $872c5e169d87e980$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $872c5e169d87e980$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $872c5e169d87e980$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $872c5e169d87e980$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $872c5e169d87e980$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $872c5e169d87e980$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $872c5e169d87e980$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $872c5e169d87e980$var$TYPE_PROMISE:
                        $872c5e169d87e980$var$validateIndex(b, values.length);
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $872c5e169d87e980$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $872c5e169d87e980$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $872c5e169d87e980$var$globalObj && $872c5e169d87e980$var$SUPPORTED_ERROR_TYPES.includes(errorType) && errorType in $872c5e169d87e980$var$globalObj && typeof $872c5e169d87e980$var$globalObj[errorType] === "function" ? new $872c5e169d87e980$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $872c5e169d87e980$var$TYPE_PREVIOUS_RESOLVED:
                        $872c5e169d87e980$var$validateIndex(b, values.length);
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $872c5e169d87e980$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    Object.defineProperty(object, r[0], {
                        value: r[1],
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
function $872c5e169d87e980$var$validateIndex(index, length) {
    if (!Number.isSafeInteger(index) || index < 0 || index >= length) throw new SyntaxError();
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $872c5e169d87e980$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $872c5e169d87e980$var$Deferred2();
    const reader = readable.pipeThrough($872c5e169d87e980$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $872c5e169d87e980$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $872c5e169d87e980$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $872c5e169d87e980$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $872c5e169d87e980$var$unflatten.call(this, line)
    };
}
async function $872c5e169d87e980$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $872c5e169d87e980$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $872c5e169d87e980$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $872c5e169d87e980$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $872c5e169d87e980$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $872c5e169d87e980$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = await $872c5e169d87e980$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id2 = await $872c5e169d87e980$var$flatten.call(encoder, resolved);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$872c5e169d87e980$var$TYPE_PROMISE}${deferredId}:[["${$872c5e169d87e980$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$872c5e169d87e980$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$872c5e169d87e980$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                                const id2 = await $872c5e169d87e980$var$flatten.call(encoder, reason);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$872c5e169d87e980$var$TYPE_ERROR}${deferredId}:[["${$872c5e169d87e980$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$872c5e169d87e980$var$TYPE_ERROR}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$872c5e169d87e980$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $872c5e169d87e980$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $872c5e169d87e980$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $872c5e169d87e980$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $872c5e169d87e980$export$4cf11838cdc2a8a8(html) {
    return html.replace($872c5e169d87e980$var$ESCAPE_REGEX, (match)=>$872c5e169d87e980$var$ESCAPE_LOOKUP[match]);
}
function $872c5e169d87e980$export$30330f3d5eb70e11(value) {
    return value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
// lib/dom/ssr/invariant.ts
function $872c5e169d87e980$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $872c5e169d87e980$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $872c5e169d87e980$var$SingleFetchNoResultError = class extends Error {
};
var $872c5e169d87e980$export$ae9272e641ead836 = 202;
var $872c5e169d87e980$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $872c5e169d87e980$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $iQhxf.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$872c5e169d87e980$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $iQhxf.createElement($iQhxf.Fragment, null, scriptTag, /* @__PURE__ */ $iQhxf.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $iQhxf.createElement($iQhxf.Fragment, null, scriptTag, /* @__PURE__ */ $iQhxf.createElement($iQhxf.Suspense, null, /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $872c5e169d87e980$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    let dataStrategy = $872c5e169d87e980$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $872c5e169d87e980$var$invariant2(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $872c5e169d87e980$var$fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $872c5e169d87e980$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $872c5e169d87e980$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $872c5e169d87e980$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware);
        if (fetcherKey) return $872c5e169d87e980$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        return $872c5e169d87e980$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut);
    };
}
async function $872c5e169d87e980$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $872c5e169d87e980$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, trailingSlashAware, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $872c5e169d87e980$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($872c5e169d87e980$export$3f1eb41d9a6a6a27(result.result) || $872c5e169d87e980$export$972111febbeef05b(result.result) || $872c5e169d87e980$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $872c5e169d87e980$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $872c5e169d87e980$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                        routeId
                    ]);
                    return $872c5e169d87e980$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $872c5e169d87e980$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$872c5e169d87e980$var$createDeferred2());
    let singleFetchDfd = $872c5e169d87e980$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                            routeId
                        ]);
                        return $872c5e169d87e980$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $872c5e169d87e980$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, trailingSlashAware, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $872c5e169d87e980$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $872c5e169d87e980$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $872c5e169d87e980$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $872c5e169d87e980$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $872c5e169d87e980$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                routeId
            ]);
            return $872c5e169d87e980$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $872c5e169d87e980$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $872c5e169d87e980$export$7b977381851b2c(reqUrl, basename, trailingSlashAware, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
        else url.pathname = `${url.pathname}.${extension}`;
    } else {
        if (url.pathname === "/") url.pathname = `_root.${extension}`;
        else if (basename && $872c5e169d87e980$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${$872c5e169d87e980$var$removeTrailingSlash(basename)}/_root.${extension}`;
        else url.pathname = `${$872c5e169d87e980$var$removeTrailingSlash(url.pathname)}.${extension}`;
    }
    return url;
}
async function $872c5e169d87e980$var$fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    let { request: request } = args;
    let url = $872c5e169d87e980$export$7b977381851b2c(request.url, basename, trailingSlashAware, "data");
    if (request.method === "GET") {
        url = $872c5e169d87e980$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $872c5e169d87e980$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $872c5e169d87e980$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $872c5e169d87e980$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($872c5e169d87e980$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $872c5e169d87e980$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $872c5e169d87e980$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($872c5e169d87e980$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$872c5e169d87e980$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $872c5e169d87e980$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $872c5e169d87e980$export$4023ad4ecd4126a2(body, global) {
    return $872c5e169d87e980$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && $872c5e169d87e980$var$SUPPORTED_ERROR_TYPES.includes(name) && name in global && // @ts-expect-error
                    typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $872c5e169d87e980$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$872c5e169d87e980$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $872c5e169d87e980$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $872c5e169d87e980$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $872c5e169d87e980$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $872c5e169d87e980$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $872c5e169d87e980$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $872c5e169d87e980$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $872c5e169d87e980$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $872c5e169d87e980$var$getModuleLinkHrefs(matches, manifest);
    return $872c5e169d87e980$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $872c5e169d87e980$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $872c5e169d87e980$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $872c5e169d87e980$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($872c5e169d87e980$var$prefetchStyleLink));
}
async function $872c5e169d87e980$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$872c5e169d87e980$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$872c5e169d87e980$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$872c5e169d87e980$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($872c5e169d87e980$var$prefetchStyleLink));
}
async function $872c5e169d87e980$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $872c5e169d87e980$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $872c5e169d87e980$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $872c5e169d87e980$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $872c5e169d87e980$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $872c5e169d87e980$var$dedupeLinkDescriptors(links.flat(1).filter($872c5e169d87e980$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $872c5e169d87e980$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $872c5e169d87e980$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $872c5e169d87e980$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $872c5e169d87e980$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $872c5e169d87e980$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $872c5e169d87e980$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$872c5e169d87e980$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($872c5e169d87e980$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $872c5e169d87e980$var$_isPreloadSupported;
function $872c5e169d87e980$var$isPreloadSupported() {
    if ($872c5e169d87e980$var$_isPreloadSupported !== void 0) return $872c5e169d87e980$var$_isPreloadSupported;
    let el = document.createElement("link");
    $872c5e169d87e980$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $872c5e169d87e980$var$_isPreloadSupported;
}
function $872c5e169d87e980$var$RemixRootDefaultHydrateFallback() {
    let { nonce: nonce } = $872c5e169d87e980$var$useFrameworkContext();
    return /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $872c5e169d87e980$export$945fecf35a8ef089 ? /* @__PURE__ */ $iQhxf.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $872c5e169d87e980$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $872c5e169d87e980$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $872c5e169d87e980$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $872c5e169d87e980$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$var$RemixRootDefaultErrorBoundary, {
            error: $872c5e169d87e980$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $iQhxf.createElement(routeModule.Layout, null, /* @__PURE__ */ $iQhxf.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $iQhxf.createElement(routeModule.Layout, null, /* @__PURE__ */ $iQhxf.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $iQhxf.createElement(routeModule.Layout, null, /* @__PURE__ */ $iQhxf.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $872c5e169d87e980$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $872c5e169d87e980$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $872c5e169d87e980$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$872c5e169d87e980$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $872c5e169d87e980$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $872c5e169d87e980$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $872c5e169d87e980$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $872c5e169d87e980$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $872c5e169d87e980$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $872c5e169d87e980$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $872c5e169d87e980$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $872c5e169d87e980$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $872c5e169d87e980$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $872c5e169d87e980$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $872c5e169d87e980$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $872c5e169d87e980$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $872c5e169d87e980$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$872c5e169d87e980$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $872c5e169d87e980$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                let _isHydrationRequest = isHydrationRequest;
                isHydrationRequest = false;
                let result = await prefetchStylesAndCallHandler(async ()=>{
                    $872c5e169d87e980$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                    if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                    return routeModule.clientLoader({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverLoader () {
                            $872c5e169d87e980$var$preventInvalidServerHandlerCall("loader", route);
                            if (_isHydrationRequest) {
                                if (hasInitialData) return initialData;
                                if (hasInitialError) throw initialError;
                            }
                            return fetchServerLoader(singleFetch);
                        }
                    });
                });
                return result;
            };
            dataRoute.loader.hydrate = $872c5e169d87e980$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $872c5e169d87e980$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $872c5e169d87e980$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverAction () {
                            $872c5e169d87e980$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $872c5e169d87e980$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $872c5e169d87e980$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $872c5e169d87e980$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $872c5e169d87e980$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $872c5e169d87e980$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $872c5e169d87e980$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $872c5e169d87e980$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $872c5e169d87e980$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $872c5e169d87e980$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $872c5e169d87e980$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $872c5e169d87e980$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $872c5e169d87e980$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $872c5e169d87e980$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $872c5e169d87e980$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $872c5e169d87e980$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $872c5e169d87e980$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $872c5e169d87e980$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $872c5e169d87e980$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $872c5e169d87e980$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $872c5e169d87e980$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $872c5e169d87e980$var$nextPaths = /* @__PURE__ */ new Set();
var $872c5e169d87e980$var$discoveredPathsMaxSize = 1e3;
var $872c5e169d87e980$var$discoveredPaths = /* @__PURE__ */ new Set();
var $872c5e169d87e980$export$b5915cf27fa06b9f = 7680;
function $872c5e169d87e980$export$791cac19ae57137a(paths) {
    let result = /* @__PURE__ */ new Set();
    paths.forEach((path)=>{
        if (!path.startsWith("/")) path = `/${path}`;
        for(let i = 1; i < path.length; i++)if (path[i] === "/") result.add(path.slice(0, i));
        result.add(path);
    });
    return Array.from(result);
}
function $872c5e169d87e980$export$741d98b28dbfd(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
var $872c5e169d87e980$var$MANIFEST_MATCH_COST_LIMIT = 5e4;
var $872c5e169d87e980$var$MANIFEST_MATCH_COST_SEGMENT_THRESHOLD = 10;
function $872c5e169d87e980$export$6b125d9215e726d(pathname, matchCost = 0) {
    let segmentCount = pathname.split("/").length - 1;
    let ancestorCount = Math.max(segmentCount - 1, 0);
    return ancestorCount * pathname.length + 1 > $872c5e169d87e980$export$b5915cf27fa06b9f || segmentCount > $872c5e169d87e980$var$MANIFEST_MATCH_COST_SEGMENT_THRESHOLD && segmentCount * matchCost > $872c5e169d87e980$var$MANIFEST_MATCH_COST_LIMIT;
}
function $872c5e169d87e980$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $872c5e169d87e980$export$5c7b09132f833c25(router.routes, path, router.basename || "/", false, router.branches);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $872c5e169d87e980$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$872c5e169d87e980$export$741d98b28dbfd(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($872c5e169d87e980$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $872c5e169d87e980$var$fetchAndApplyManifestPatches([
            path
        ], // If we're patching for a fetcher call, reload the current location
        // Otherwise prefer any ongoing navigation location
        fetcherKey ? window.location.href : $872c5e169d87e980$export$fe53371bee54353d(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $872c5e169d87e980$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $iQhxf.useEffect(()=>{
        if (!$872c5e169d87e980$export$741d98b28dbfd(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$872c5e169d87e980$var$discoveredPaths.has(pathname)) $872c5e169d87e980$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($872c5e169d87e980$var$nextPaths.keys()).filter((path)=>{
                if ($872c5e169d87e980$var$discoveredPaths.has(path)) {
                    $872c5e169d87e980$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $872c5e169d87e980$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $872c5e169d87e980$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $872c5e169d87e980$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : $872c5e169d87e980$var$joinPaths([
        basename,
        manifestPath
    ]);
}
var $872c5e169d87e980$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $872c5e169d87e980$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    paths = $872c5e169d87e980$export$791cac19ae57137a(paths);
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($872c5e169d87e980$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $872c5e169d87e980$export$b5915cf27fa06b9f) {
        $872c5e169d87e980$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($872c5e169d87e980$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($872c5e169d87e980$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($872c5e169d87e980$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$872c5e169d87e980$var$addToFifoQueue(p, $872c5e169d87e980$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $872c5e169d87e980$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $872c5e169d87e980$var$addToFifoQueue(path, queue) {
    if (queue.size >= $872c5e169d87e980$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $872c5e169d87e980$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $872c5e169d87e980$var$useDataRouterContext2() {
    let context = $iQhxf.useContext($872c5e169d87e980$export$2eeee58951ff3c1c);
    $872c5e169d87e980$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $872c5e169d87e980$var$useDataRouterStateContext() {
    let context = $iQhxf.useContext($872c5e169d87e980$export$315e3ffb01f217);
    $872c5e169d87e980$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $872c5e169d87e980$export$208d6a3bc3aa62bd = $iQhxf.createContext(void 0);
$872c5e169d87e980$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $872c5e169d87e980$var$useFrameworkContext() {
    let context = $iQhxf.useContext($872c5e169d87e980$export$208d6a3bc3aa62bd);
    $872c5e169d87e980$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $872c5e169d87e980$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $iQhxf.useContext($872c5e169d87e980$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $iQhxf.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $iQhxf.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $iQhxf.useRef(null);
    $iQhxf.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $iQhxf.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $872c5e169d87e980$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $872c5e169d87e980$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $872c5e169d87e980$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $872c5e169d87e980$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $872c5e169d87e980$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $872c5e169d87e980$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $872c5e169d87e980$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$872c5e169d87e980$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $872c5e169d87e980$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $872c5e169d87e980$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, nonce: contextNonce } = $872c5e169d87e980$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $872c5e169d87e980$var$useDataRouterStateContext();
    let matches = $872c5e169d87e980$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $iQhxf.useMemo(()=>$872c5e169d87e980$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    if (nonce == null && contextNonce) nonce = contextNonce;
    return /* @__PURE__ */ $iQhxf.createElement($iQhxf.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $iQhxf.createElement("style", {
        [$872c5e169d87e980$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $iQhxf.createElement("link", {
        [$872c5e169d87e980$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>$872c5e169d87e980$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $iQhxf.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
function $872c5e169d87e980$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = $872c5e169d87e980$var$useIsRSCRouterContext();
    let { nonce: contextNonce } = $872c5e169d87e980$var$useFrameworkContext();
    let { router: router } = $872c5e169d87e980$var$useDataRouterContext2();
    let matches = $iQhxf.useMemo(()=>$872c5e169d87e980$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    if (linkProps.nonce == null && contextNonce) linkProps = {
        ...linkProps,
        nonce: contextNonce
    };
    if (rsc) return /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $872c5e169d87e980$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $872c5e169d87e980$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $iQhxf.useState([]);
    $iQhxf.useEffect(()=>{
        let interrupted = false;
        $872c5e169d87e980$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $872c5e169d87e980$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $872c5e169d87e980$export$45d76561a5302f2b();
    let { future: future } = $872c5e169d87e980$var$useFrameworkContext();
    let { basename: basename } = $872c5e169d87e980$var$useDataRouterContext2();
    let dataHrefs = $iQhxf.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = $872c5e169d87e980$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "rsc");
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $iQhxf.createElement($iQhxf.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $iQhxf.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $872c5e169d87e980$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $872c5e169d87e980$export$45d76561a5302f2b();
    let { future: future, manifest: manifest, routeModules: routeModules } = $872c5e169d87e980$var$useFrameworkContext();
    let { basename: basename } = $872c5e169d87e980$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $872c5e169d87e980$var$useDataRouterStateContext();
    let newMatchesForData = $iQhxf.useMemo(()=>$872c5e169d87e980$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $iQhxf.useMemo(()=>$872c5e169d87e980$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $iQhxf.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $872c5e169d87e980$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $iQhxf.useMemo(()=>$872c5e169d87e980$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $872c5e169d87e980$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $iQhxf.createElement($iQhxf.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $iQhxf.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $iQhxf.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $iQhxf.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
function $872c5e169d87e980$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $872c5e169d87e980$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $872c5e169d87e980$var$useDataRouterStateContext();
    let location = $872c5e169d87e980$export$45d76561a5302f2b();
    let _matches = $872c5e169d87e980$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $iQhxf.createElement($iQhxf.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$872c5e169d87e980$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $iQhxf.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $iQhxf.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $iQhxf.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $iQhxf.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $872c5e169d87e980$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (e) {
            return null;
        }
        return /* @__PURE__ */ $iQhxf.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $872c5e169d87e980$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $872c5e169d87e980$var$isHydrated = false;
function $872c5e169d87e980$export$3be068dde909e563() {
    $872c5e169d87e980$var$isHydrated = true;
}
function $872c5e169d87e980$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr, nonce: contextNonce } = $872c5e169d87e980$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $872c5e169d87e980$var$useDataRouterContext2();
    let { matches: routerMatches } = $872c5e169d87e980$var$useDataRouterStateContext();
    let isRSCRouterContext = $872c5e169d87e980$var$useIsRSCRouterContext();
    let enableFogOfWar = $872c5e169d87e980$export$741d98b28dbfd(routeDiscovery, ssr);
    if (scriptProps.nonce == null && contextNonce) scriptProps = {
        ...scriptProps,
        nonce: contextNonce
    };
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $872c5e169d87e980$var$getActiveMatches(routerMatches, null, isSpaMode);
    $iQhxf.useEffect(()=>{
        $872c5e169d87e980$export$3be068dde909e563();
    }, []);
    let initialScripts = $iQhxf.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $872c5e169d87e980$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($872c5e169d87e980$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $iQhxf.createElement($iQhxf.Fragment, null, /* @__PURE__ */ $iQhxf.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $iQhxf.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $872c5e169d87e980$var$isHydrated || isRSCRouterContext ? [] : [
        // Dedupe through a Set
        ...new Set(manifest.entry.imports.concat($872c5e169d87e980$var$getModuleLinkHrefs(matches, manifest, {
            includeHydrateFallback: true
        })))
    ];
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $872c5e169d87e980$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $872c5e169d87e980$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $iQhxf.createElement($iQhxf.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $iQhxf.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $iQhxf.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $iQhxf.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $iQhxf.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        })), initialScripts);
}
function $872c5e169d87e980$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $872c5e169d87e980$export$32e57f52df4b6e34 = class extends $iQhxf.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $872c5e169d87e980$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    let { nonce: nonce } = $872c5e169d87e980$var$useFrameworkContext();
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $iQhxf.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($872c5e169d87e980$export$972111febbeef05b(error)) return /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $iQhxf.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $872c5e169d87e980$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $iQhxf.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $iQhxf.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $872c5e169d87e980$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $872c5e169d87e980$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $iQhxf.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $iQhxf.createElement("head", null, /* @__PURE__ */ $iQhxf.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $iQhxf.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $iQhxf.createElement("title", null, title)), /* @__PURE__ */ $iQhxf.createElement("body", null, /* @__PURE__ */ $iQhxf.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$export$ff0bf87698939488, null) : null)));
}
var $872c5e169d87e980$var$isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($872c5e169d87e980$var$isBrowser2) window.__reactRouterVersion = "7.18.5";
} catch (e) {}
function $872c5e169d87e980$export$1f3f55432a00e06d(routes, opts) {
    return $872c5e169d87e980$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $872c5e169d87e980$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $872c5e169d87e980$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $872c5e169d87e980$export$9269a41d8c4635e,
        hydrationRouteProperties: $872c5e169d87e980$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $872c5e169d87e980$export$1ba7ed8a3a7b3765(routes, opts) {
    return $872c5e169d87e980$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $872c5e169d87e980$export$b71fdd3798280242({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $872c5e169d87e980$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $872c5e169d87e980$export$9269a41d8c4635e,
        hydrationRouteProperties: $872c5e169d87e980$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $872c5e169d87e980$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $872c5e169d87e980$var$deserializeErrors(state.errors)
    };
    return state;
}
function $872c5e169d87e980$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $872c5e169d87e980$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (typeof val.__subType === "string" && $872c5e169d87e980$var$SUPPORTED_ERROR_TYPES.includes(val.__subType)) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $872c5e169d87e980$export$9ba4e89fdfa1fc54({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $iQhxf.useRef();
    if (historyRef.current == null) historyRef.current = $872c5e169d87e980$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $iQhxf.useState({
        action: history.action,
        location: history.location
    });
    let setState = $iQhxf.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $iQhxf.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $iQhxf.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $872c5e169d87e980$export$7221d69dcfc8e36b({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $iQhxf.useRef();
    if (historyRef.current == null) historyRef.current = $872c5e169d87e980$export$b71fdd3798280242({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $iQhxf.useState({
        action: history.action,
        location: history.location
    });
    let setState = $iQhxf.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $iQhxf.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $iQhxf.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $872c5e169d87e980$export$de73885c9336221c({ basename: basename, children: children, history: history, useTransitions: useTransitions }) {
    let [state, setStateImpl] = $iQhxf.useState({
        action: history.action,
        location: history.location
    });
    let setState = $iQhxf.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $iQhxf.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $iQhxf.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$872c5e169d87e980$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $872c5e169d87e980$export$a6c7ac8248d6e38a = $iQhxf.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, mask: mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, useTransitions: useTransitions } = $iQhxf.useContext($872c5e169d87e980$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $872c5e169d87e980$var$ABSOLUTE_URL_REGEX.test(to);
    let parsed = $872c5e169d87e980$var$parseToInfo(to, basename);
    to = parsed.to;
    let href = $872c5e169d87e980$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let location = $872c5e169d87e980$export$45d76561a5302f2b();
    let maskedHref = null;
    if (mask) {
        let resolved = $872c5e169d87e980$var$resolveTo(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : $872c5e169d87e980$var$joinPaths([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $872c5e169d87e980$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $872c5e169d87e980$export$67621102c14d847(to, {
        replace: replace2,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $iQhxf.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: $872c5e169d87e980$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $iQhxf.createElement($iQhxf.Fragment, null, link, /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$872c5e169d87e980$export$a6c7ac8248d6e38a.displayName = "Link";
var $872c5e169d87e980$export$b0d92dbee9b5b60d = $iQhxf.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $872c5e169d87e980$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $872c5e169d87e980$export$45d76561a5302f2b();
    let routerState = $iQhxf.useContext($872c5e169d87e980$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $iQhxf.useContext($872c5e169d87e980$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $872c5e169d87e980$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $872c5e169d87e980$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$872c5e169d87e980$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $872c5e169d87e980$export$a7fed597f4b8afd8 = $iQhxf.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $872c5e169d87e980$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { useTransitions: useTransitions } = $iQhxf.useContext($872c5e169d87e980$export$3044ab7fdabeaee6);
    let submit = $872c5e169d87e980$export$47c85c6e3a081d3();
    let formAction = $872c5e169d87e980$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $872c5e169d87e980$var$ABSOLUTE_URL_REGEX.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        if (useTransitions && navigate !== false) $iQhxf.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $iQhxf.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$872c5e169d87e980$export$a7fed597f4b8afd8.displayName = "Form";
function $872c5e169d87e980$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $iQhxf.useContext($872c5e169d87e980$export$208d6a3bc3aa62bd);
    let { basename: basename } = $iQhxf.useContext($872c5e169d87e980$export$3044ab7fdabeaee6);
    let location = $872c5e169d87e980$export$45d76561a5302f2b();
    let matches = $872c5e169d87e980$export$2378eb7f5ff86053();
    $872c5e169d87e980$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $iQhxf.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $872c5e169d87e980$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    if (props.nonce == null && remixContext?.nonce) props.nonce = remixContext.nonce;
    return /* @__PURE__ */ $iQhxf.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${$872c5e169d87e980$export$4cf11838cdc2a8a8(JSON.stringify(storageKey || $872c5e169d87e980$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${$872c5e169d87e980$export$4cf11838cdc2a8a8(JSON.stringify(ssrKey))})`
        }
    });
}
$872c5e169d87e980$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $872c5e169d87e980$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $872c5e169d87e980$var$useDataRouterContext3(hookName) {
    let ctx = $iQhxf.useContext($872c5e169d87e980$export$2eeee58951ff3c1c);
    $872c5e169d87e980$export$f5708dca728d7177(ctx, $872c5e169d87e980$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $872c5e169d87e980$var$useDataRouterState2(hookName) {
    let state = $iQhxf.useContext($872c5e169d87e980$export$315e3ffb01f217);
    $872c5e169d87e980$export$f5708dca728d7177(state, $872c5e169d87e980$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $872c5e169d87e980$export$67621102c14d847(to, { target: target, replace: replaceProp, mask: mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, useTransitions: useTransitions } = {}) {
    let navigate = $872c5e169d87e980$export$9770f232ac06a008();
    let location = $872c5e169d87e980$export$45d76561a5302f2b();
    let path = $872c5e169d87e980$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $iQhxf.useCallback((event)=>{
        if ($872c5e169d87e980$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $872c5e169d87e980$export$fe53371bee54353d(location) === $872c5e169d87e980$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            if (useTransitions) $iQhxf.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
function $872c5e169d87e980$export$f1a78c17382fe22a(defaultInit) {
    $872c5e169d87e980$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $iQhxf.useRef($872c5e169d87e980$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $iQhxf.useRef(false);
    let location = $872c5e169d87e980$export$45d76561a5302f2b();
    let searchParams = $iQhxf.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $872c5e169d87e980$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $872c5e169d87e980$export$9770f232ac06a008();
    let setSearchParams = $iQhxf.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $872c5e169d87e980$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $872c5e169d87e980$var$fetcherId = 0;
var $872c5e169d87e980$var$getUniqueFetcherId = ()=>`__${String(++$872c5e169d87e980$var$fetcherId)}__`;
function $872c5e169d87e980$export$47c85c6e3a081d3() {
    let { router: router } = $872c5e169d87e980$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $iQhxf.useContext($872c5e169d87e980$export$3044ab7fdabeaee6);
    let currentRouteId = $872c5e169d87e980$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $iQhxf.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $872c5e169d87e980$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $872c5e169d87e980$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                defaultShouldRevalidate: options.defaultShouldRevalidate,
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $872c5e169d87e980$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $iQhxf.useContext($872c5e169d87e980$export$3044ab7fdabeaee6);
    let routeContext = $iQhxf.useContext($872c5e169d87e980$export$aac280ed165a4397);
    $872c5e169d87e980$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$872c5e169d87e980$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $872c5e169d87e980$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $872c5e169d87e980$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $872c5e169d87e980$export$fe53371bee54353d(path);
}
function $872c5e169d87e980$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $872c5e169d87e980$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $872c5e169d87e980$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $iQhxf.useContext($872c5e169d87e980$export$cb3f1df1bef00a39);
    let route = $iQhxf.useContext($872c5e169d87e980$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $872c5e169d87e980$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $872c5e169d87e980$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $872c5e169d87e980$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $iQhxf.useId();
    let [fetcherKey, setFetcherKey] = $iQhxf.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $iQhxf.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $iQhxf.useCallback(async (href, opts)=>{
        $872c5e169d87e980$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $872c5e169d87e980$export$47c85c6e3a081d3();
    let submit = $iQhxf.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $iQhxf.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $iQhxf.useMemo(()=>{
        let FetcherForm2 = $iQhxf.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $872c5e169d87e980$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $iQhxf.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $872c5e169d87e980$export$fa996778a3a31087() {
    let state = $872c5e169d87e980$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return $iQhxf.useMemo(()=>Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
                ...fetcher,
                key: key
            })), [
        state.fetchers
    ]);
}
var $872c5e169d87e980$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $872c5e169d87e980$var$savedScrollPositions = {};
function $872c5e169d87e980$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $872c5e169d87e980$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $872c5e169d87e980$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $872c5e169d87e980$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $872c5e169d87e980$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $iQhxf.useContext($872c5e169d87e980$export$3044ab7fdabeaee6);
    let location = $872c5e169d87e980$export$45d76561a5302f2b();
    let matches = $872c5e169d87e980$export$2378eb7f5ff86053();
    let navigation = $872c5e169d87e980$export$d0fd4b7106de2769();
    $iQhxf.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $872c5e169d87e980$var$usePageHide($iQhxf.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $872c5e169d87e980$var$getScrollRestorationKey(location, matches, basename, getKey);
            $872c5e169d87e980$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $872c5e169d87e980$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($872c5e169d87e980$var$savedScrollPositions));
        } catch (error) {
            $872c5e169d87e980$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $iQhxf.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $872c5e169d87e980$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $872c5e169d87e980$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $iQhxf.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($872c5e169d87e980$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$872c5e169d87e980$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $iQhxf.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $872c5e169d87e980$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $872c5e169d87e980$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $iQhxf.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $872c5e169d87e980$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $iQhxf.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $872c5e169d87e980$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $872c5e169d87e980$export$b273b3273281a049(when);
    $iQhxf.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $iQhxf.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $872c5e169d87e980$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $iQhxf.useContext($872c5e169d87e980$export$3681f408decb40d1);
    $872c5e169d87e980$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $872c5e169d87e980$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $872c5e169d87e980$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $872c5e169d87e980$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $872c5e169d87e980$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $872c5e169d87e980$export$81336c211d5ff295(path.pathname, nextPath) != null || $872c5e169d87e980$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $872c5e169d87e980$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $872c5e169d87e980$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default",
        mask: void 0
    };
    let staticNavigator = $872c5e169d87e980$var$getStatelessNavigator();
    return /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        useTransitions: false
    });
}
function $872c5e169d87e980$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $872c5e169d87e980$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $872c5e169d87e980$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $872c5e169d87e980$var$serializeErrors(context.errors)
        };
        let json = $872c5e169d87e980$export$4cf11838cdc2a8a8(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $iQhxf.createElement($iQhxf.Fragment, null, /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        useTransitions: false
    }, /* @__PURE__ */ $iQhxf.createElement($872c5e169d87e980$var$DataRoutes2, {
        manifest: router.manifest,
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: true
    })))))), hydrateScript ? /* @__PURE__ */ $iQhxf.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $872c5e169d87e980$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($872c5e169d87e980$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $872c5e169d87e980$var$getStatelessNavigator() {
    return {
        createHref: $872c5e169d87e980$var$createHref,
        encodeLocation: $872c5e169d87e980$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $872c5e169d87e980$export$69163f0b72ec60d9(routes, opts) {
    return $872c5e169d87e980$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $872c5e169d87e980$export$9269a41d8c4635e
    });
}
function $872c5e169d87e980$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $872c5e169d87e980$export$87cb1a9238dc3fba(routes, $872c5e169d87e980$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                v8_passThroughRequests: false,
                v8_trailingSlashAwareDataRequests: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                renderFallback: false,
                navigation: $872c5e169d87e980$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get branches () {
            return opts.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $872c5e169d87e980$var$createHref,
        encodeLocation: $872c5e169d87e980$var$encodeLocation,
        getFetcher () {
            return $872c5e169d87e980$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $872c5e169d87e980$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $872c5e169d87e980$var$createHref(to) {
    return typeof to === "string" ? to : $872c5e169d87e980$export$fe53371bee54353d(to);
}
function $872c5e169d87e980$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $872c5e169d87e980$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $872c5e169d87e980$var$ABSOLUTE_URL_REGEX.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}



var $iQhxf = parcelRequire("iQhxf");
const $70f8926b82fcac0e$export$4d28219d42798a75 = ()=>{
    const baseUrl = "https://api.myflix.marksavilledesigns.com"?.trim();
    if (!baseUrl) throw new Error('MYFLIX_API_BASE_URL is required. Set it in your environment before starting the app.');
    return baseUrl.replace(/\/+$/, '');
};


class $a3d754e15ed774ee$export$f2e832acab1bdd79 extends Error {
    constructor(message, status, errors = []){
        super(message);
        this.name = 'ApiError';
        this.status = status;
        this.errors = errors;
    }
}
const $a3d754e15ed774ee$var$buildUrl = (path)=>`${(0, $70f8926b82fcac0e$export$4d28219d42798a75)()}/${path.replace(/^\/+/, '')}`;
const $a3d754e15ed774ee$var$getErrorDetails = async (response, profileUpdate)=>{
    try {
        const data = await response.json();
        const errors = profileUpdate && Array.isArray(data.errors) ? data.errors.map(({ path: path, param: param, msg: msg })=>({
                path: path || param,
                msg: typeof msg === 'string' ? msg : 'Invalid field.'
            })) : [];
        if (profileUpdate && response.status === 422 && Array.isArray(data.errors) && data.errors.some((error)=>error.path === 'Password' && error.msg === 'Password is required')) return {
            message: 'Password is required',
            errors: errors
        };
        return {
            message: data.message || data.error || 'The request could not be completed.',
            errors: errors
        };
    } catch  {
        return {
            message: 'The request could not be completed.',
            errors: []
        };
    }
};
const $a3d754e15ed774ee$export$b5fe3f66a567bec0 = async (path, options = {})=>{
    const { token: token, body: body, headers: headers, profileUpdate: profileUpdate = false, registration: registration = false, ...fetchOptions } = options;
    const response = await fetch($a3d754e15ed774ee$var$buildUrl(path), {
        ...fetchOptions,
        headers: {
            ...body ? {
                'Content-Type': 'application/json'
            } : {},
            ...token ? {
                Authorization: `Bearer ${token}`
            } : {},
            ...headers
        },
        ...body ? {
            body: JSON.stringify(body)
        } : {}
    });
    if (!response.ok) {
        if (registration) {
            // Read once: registration may return JSON validation errors or plain text.
            const text = await response.text();
            let data;
            try {
                data = JSON.parse(text);
            } catch  {
                data = null;
            }
            const errors = Array.isArray(data?.errors) ? data.errors.map(({ path: path, param: param, msg: msg })=>({
                    path: path || param,
                    msg: typeof msg === 'string' ? msg : 'Invalid field.'
                })) : [];
            throw new $a3d754e15ed774ee$export$f2e832acab1bdd79(data?.message || data?.error || (data ? 'Registration unsuccessful. Please try again.' : text.trim()) || 'Registration unsuccessful. Please try again.', response.status, errors);
        }
        const { message: message, errors: errors } = await $a3d754e15ed774ee$var$getErrorDetails(response, profileUpdate);
        throw new $a3d754e15ed774ee$export$f2e832acab1bdd79(message, response.status, errors);
    }
    if (response.status === 204) return undefined;
    const contentLength = response.headers?.get?.('content-length');
    if (contentLength === '0') return undefined;
    try {
        return await response.json();
    } catch  {
        return undefined;
    }
};
const $a3d754e15ed774ee$var$encode = encodeURIComponent;
const $a3d754e15ed774ee$export$644d8ea042df96a6 = {
    login: (credentials)=>$a3d754e15ed774ee$export$b5fe3f66a567bec0('login', {
            method: 'POST',
            body: credentials
        }),
    signup: (user)=>$a3d754e15ed774ee$export$b5fe3f66a567bec0('users', {
            method: 'POST',
            body: user,
            registration: true
        }),
    getMovies: (token, signal)=>$a3d754e15ed774ee$export$b5fe3f66a567bec0('movies', {
            token: token,
            signal: signal
        }),
    updateUser: (username, updates, token)=>$a3d754e15ed774ee$export$b5fe3f66a567bec0(`users/${$a3d754e15ed774ee$var$encode(username)}`, {
            method: 'PUT',
            body: updates,
            token: token,
            profileUpdate: true
        }),
    deleteUser: (username, token)=>$a3d754e15ed774ee$export$b5fe3f66a567bec0(`users/${$a3d754e15ed774ee$var$encode(username)}`, {
            method: 'DELETE',
            token: token
        }),
    addFavorite: (username, movieId, token)=>$a3d754e15ed774ee$export$b5fe3f66a567bec0(`users/${$a3d754e15ed774ee$var$encode(username)}/movies/${$a3d754e15ed774ee$var$encode(movieId)}`, {
            method: 'POST',
            token: token
        }),
    removeFavorite: (username, movieId, token)=>$a3d754e15ed774ee$export$b5fe3f66a567bec0(`users/${$a3d754e15ed774ee$var$encode(username)}/movies/${$a3d754e15ed774ee$var$encode(movieId)}`, {
            method: 'DELETE',
            token: token
        })
};




var $iQhxf = parcelRequire("iQhxf");


const $32487ffaa9d71536$var$AppContext = /*#__PURE__*/ (0, $iQhxf.createContext)(null);
const $32487ffaa9d71536$export$fdc397e486fa83e7 = ()=>{
    const context = (0, $iQhxf.useContext)($32487ffaa9d71536$var$AppContext);
    if (!context) throw new Error('useAppContext must be used within AppProvider');
    return context;
};
const $32487ffaa9d71536$var$storageKeys = [
    'user',
    'token'
];
const $32487ffaa9d71536$var$clearStoredAuth = ()=>{
    $32487ffaa9d71536$var$storageKeys.forEach((key)=>localStorage.removeItem(key));
};
// Restore only complete, parseable sessions; discard partial or corrupted storage.
const $32487ffaa9d71536$var$readStoredAuth = ()=>{
    const token = localStorage.getItem('token');
    const storedUser = localStorage.getItem('user');
    if (!token || !storedUser) {
        $32487ffaa9d71536$var$clearStoredAuth();
        return {
            user: null,
            token: null
        };
    }
    try {
        const user = JSON.parse(storedUser);
        if (!user || typeof user !== 'object' || !user.Username) throw new Error('Invalid stored user');
        return {
            user: user,
            token: token
        };
    } catch  {
        $32487ffaa9d71536$var$clearStoredAuth();
        return {
            user: null,
            token: null
        };
    }
};
const $32487ffaa9d71536$export$c7dacf3845253dcf = ({ children: children })=>{
    const [{ user: user, token: token }, setAuth] = (0, $iQhxf.useState)($32487ffaa9d71536$var$readStoredAuth);
    const [sessionNotice, setSessionNotice] = (0, $iQhxf.useState)('');
    const persistAuth = (0, $iQhxf.useCallback)((nextUser, nextToken = token)=>{
        localStorage.setItem('user', JSON.stringify(nextUser));
        localStorage.setItem('token', nextToken);
        setAuth({
            user: nextUser,
            token: nextToken
        });
    }, [
        token
    ]);
    const login = (0, $iQhxf.useCallback)((nextUser, nextToken)=>{
        persistAuth(nextUser, nextToken);
        setSessionNotice('');
    }, [
        persistAuth
    ]);
    const updateUser = (0, $iQhxf.useCallback)((nextUser)=>persistAuth(nextUser), [
        persistAuth
    ]);
    const logout = (0, $iQhxf.useCallback)((notice = '')=>{
        $32487ffaa9d71536$var$clearStoredAuth();
        setAuth({
            user: null,
            token: null
        });
        setSessionNotice(notice);
    }, []);
    const clearSessionNotice = (0, $iQhxf.useCallback)(()=>setSessionNotice(''), []);
    const handleApiError = (0, $iQhxf.useCallback)((error)=>{
        // Rejected authentication on a protected request invalidates the local session.
        if (error instanceof (0, $a3d754e15ed774ee$export$f2e832acab1bdd79) && [
            401,
            403
        ].includes(error.status)) {
            logout('Your session has expired. Please sign in again.');
            return true;
        }
        return false;
    }, [
        logout
    ]);
    const value = (0, $iQhxf.useMemo)(()=>({
            user: user,
            token: token,
            sessionNotice: sessionNotice,
            login: login,
            updateUser: updateUser,
            logout: logout,
            handleApiError: handleApiError,
            clearSessionNotice: clearSessionNotice
        }), [
        user,
        token,
        sessionNotice,
        login,
        updateUser,
        logout,
        handleApiError,
        clearSessionNotice
    ]);
    return /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)($32487ffaa9d71536$var$AppContext.Provider, {
        value: value,
        children: children
    });
};
$32487ffaa9d71536$export$c7dacf3845253dcf.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).node.isRequired
};


const $4866d1f129073a08$export$d186c6cf79469180 = (movieId)=>{
    const { user: user, token: token, updateUser: updateUser, handleApiError: handleApiError } = (0, $32487ffaa9d71536$export$fdc397e486fa83e7)();
    const [isPending, setIsPending] = (0, $iQhxf.useState)(false);
    const [error, setError] = (0, $iQhxf.useState)('');
    const requestPending = (0, $iQhxf.useRef)(false);
    const isFavorite = user?.FavoriteMovies?.includes(movieId) || false;
    const toggleFavorite = async ()=>{
        if (requestPending.current || !user || !token) return;
        requestPending.current = true;
        setIsPending(true);
        setError('');
        try {
            const updatedUser = isFavorite ? await (0, $a3d754e15ed774ee$export$644d8ea042df96a6).removeFavorite(user.Username, movieId, token) : await (0, $a3d754e15ed774ee$export$644d8ea042df96a6).addFavorite(user.Username, movieId, token);
            updateUser(updatedUser);
        } catch (requestError) {
            if (!handleApiError(requestError)) setError('Favorites could not be updated. Please try again.');
        } finally{
            requestPending.current = false;
            setIsPending(false);
        }
    };
    return {
        isFavorite: isFavorite,
        isPending: isPending,
        error: error,
        toggleFavorite: toggleFavorite
    };
};


const $387be721b7eb71a7$export$9bd698419030e459 = ({ movie: movie, headingLevel: headingLevel = 2 })=>{
    const { isFavorite: isFavorite, isPending: isPending, error: error, toggleFavorite: toggleFavorite } = (0, $4866d1f129073a08$export$d186c6cf79469180)(movie.id);
    const Heading = `h${headingLevel}`;
    const titleId = (0, $iQhxf.useId)();
    const errorId = (0, $iQhxf.useId)();
    return /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("article", {
        className: "movie-card",
        "aria-labelledby": titleId,
        children: [
            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("img", {
                className: "aspect-[2/3] w-full object-cover",
                src: movie.image,
                alt: `${movie.title} poster`,
                loading: "lazy"
            }),
            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("div", {
                className: "flex flex-1 flex-col p-4",
                children: [
                    /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)(Heading, {
                        id: titleId,
                        className: "mb-3 line-clamp-2 min-h-[52px] break-words text-heading-sm",
                        children: movie.title
                    }),
                    /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("p", {
                        className: "mb-2 break-words text-body-sm text-text-secondary",
                        children: [
                            "Genre: ",
                            movie.genre
                        ]
                    }),
                    /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("p", {
                        className: "mb-3 break-words text-body-sm text-text-secondary",
                        children: [
                            "Director: ",
                            movie.director
                        ]
                    }),
                    /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("p", {
                        className: "mb-6 line-clamp-3 break-words text-body text-text-muted",
                        children: movie.description
                    }),
                    /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("div", {
                        className: "mt-auto flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $872c5e169d87e980$export$a6c7ac8248d6e38a), {
                                to: `/movies/${encodeURIComponent(movie.id)}`,
                                className: "button button-secondary",
                                "aria-label": `View Details for ${movie.title}`,
                                children: "View Details"
                            }),
                            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("button", {
                                type: "button",
                                className: "button button-primary",
                                onClick: toggleFavorite,
                                disabled: isPending,
                                "aria-busy": isPending,
                                "aria-pressed": isFavorite,
                                "aria-describedby": error ? errorId : undefined,
                                "aria-label": isPending ? `Updating... for ${movie.title}` : `${isFavorite ? 'Remove from Favorites' : 'Add to Favorites'}: ${movie.title}`,
                                children: isPending ? 'Updating...' : isFavorite ? 'Remove from Favorites' : 'Add to Favorites'
                            }),
                            error && /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("p", {
                                id: errorId,
                                role: "alert",
                                className: "text-body-sm text-text-secondary",
                                children: error
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$387be721b7eb71a7$export$9bd698419030e459.propTypes = {
    headingLevel: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).oneOf([
        2,
        3
    ]),
    movie: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).string.isRequired,
        title: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).string.isRequired,
        description: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).string.isRequired,
        genre: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).string.isRequired,
        director: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).string.isRequired,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).string
    }).isRequired
};




var $iQhxf = parcelRequire("iQhxf");



const $c23f257bef54ec96$export$78d497080ea8f89a = ({ movies: movies })=>{
    const { movieId: movieId } = (0, $872c5e169d87e980$export$99eaa27ddbbb95ef)();
    const { isFavorite: isFavorite, isPending: isPending, error: error, toggleFavorite: toggleFavorite } = (0, $4866d1f129073a08$export$d186c6cf79469180)(movieId);
    const errorId = (0, $iQhxf.useId)();
    const movie = movies.find((item)=>item.id === movieId);
    if (!movie) return /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("section", {
        className: "surface p-6 sm:p-8",
        "aria-labelledby": "movie-not-found-title",
        children: [
            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("h1", {
                id: "movie-not-found-title",
                className: "mb-6 text-heading-lg-mobile sm:text-heading-lg",
                children: "Movie not found."
            }),
            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $872c5e169d87e980$export$a6c7ac8248d6e38a), {
                to: "/",
                className: "button button-secondary",
                children: "Back to Movies"
            })
        ]
    });
    return /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("article", {
        className: "movie-detail",
        "aria-labelledby": "movie-detail-title",
        children: [
            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("img", {
                className: "movie-detail-poster",
                src: movie.image,
                alt: `${movie.title} poster`
            }),
            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("div", {
                className: "min-w-0 p-6 md:p-8 lg:p-10",
                children: [
                    /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("h1", {
                        id: "movie-detail-title",
                        className: "mb-6 break-words text-heading-lg-mobile sm:text-heading-lg",
                        children: movie.title
                    }),
                    /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("p", {
                        className: "mb-8 whitespace-pre-line break-words text-body-lg text-text-secondary",
                        children: movie.description
                    }),
                    /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("dl", {
                        className: "mb-8 space-y-4 text-body-lg",
                        children: [
                            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("dt", {
                                        className: "text-label text-text-muted",
                                        children: "Genre"
                                    }),
                                    /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("dd", {
                                        className: "mt-1 break-words",
                                        children: movie.genre
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("dt", {
                                        className: "text-label text-text-muted",
                                        children: "Director"
                                    }),
                                    /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("dd", {
                                        className: "mt-1 break-words",
                                        children: movie.director
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("div", {
                        className: "flex flex-col gap-3 sm:flex-row sm:flex-wrap",
                        children: [
                            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("button", {
                                type: "button",
                                className: "button button-primary",
                                onClick: toggleFavorite,
                                disabled: isPending,
                                "aria-busy": isPending,
                                "aria-pressed": isFavorite,
                                "aria-describedby": error ? errorId : undefined,
                                children: isPending ? 'Updating...' : isFavorite ? 'Remove from Favorites' : 'Add to Favorites'
                            }),
                            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $872c5e169d87e980$export$a6c7ac8248d6e38a), {
                                to: "/",
                                className: "button button-secondary",
                                children: "Back to Movies"
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("p", {
                        id: errorId,
                        role: "alert",
                        className: "mt-4 text-body text-text-secondary",
                        children: error
                    })
                ]
            })
        ]
    });
};
$c23f257bef54ec96$export$78d497080ea8f89a.propTypes = {
    movies: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).string.isRequired,
        title: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).string.isRequired,
        description: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).string.isRequired,
        genre: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).string.isRequired,
        director: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).string.isRequired,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).string
    })).isRequired
};




var $iQhxf = parcelRequire("iQhxf");



const $13fdb569d35102c2$export$1582048ca8384970 = ()=>{
    const usernameInput = (0, $iQhxf.useRef)(null);
    const [username, setUsername] = (0, $iQhxf.useState)('');
    const [password, setPassword] = (0, $iQhxf.useState)('');
    const [error, setError] = (0, $iQhxf.useState)('');
    const [isSubmitting, setIsSubmitting] = (0, $iQhxf.useState)(false);
    const { login: login, sessionNotice: sessionNotice, clearSessionNotice: clearSessionNotice } = (0, $32487ffaa9d71536$export$fdc397e486fa83e7)();
    const handleLogin = async (event)=>{
        event.preventDefault();
        const data = {
            Username: username,
            Password: password
        };
        setError('');
        setIsSubmitting(true);
        try {
            const result = await (0, $a3d754e15ed774ee$export$644d8ea042df96a6).login(data);
            // Persist a session only when the API returns both user data and a token.
            if (!result?.user || !result?.token) throw new Error('The login response was incomplete.');
            login(result.user, result.token);
        } catch  {
            setError('Login unsuccessful. Please check your details and try again.');
        } finally{
            setIsSubmitting(false);
        }
    };
    return /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("div", {
        className: "auth-layout",
        children: /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("section", {
            className: "auth-panel",
            "aria-labelledby": "login-title",
            children: [
                /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("h1", {
                    id: "login-title",
                    className: "mb-6 text-heading-lg-mobile sm:text-heading-lg",
                    children: "Login"
                }),
                /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("form", {
                    onSubmit: handleLogin,
                    "aria-busy": isSubmitting,
                    "aria-describedby": error || sessionNotice ? 'login-feedback' : undefined,
                    className: "space-y-4",
                    children: [
                        /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("label", {
                                    className: "form-label",
                                    htmlFor: "login-username",
                                    children: "Username:"
                                }),
                                /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("input", {
                                    ref: usernameInput,
                                    id: "login-username",
                                    name: "username",
                                    type: "text",
                                    value: username,
                                    onChange: (event)=>setUsername(event.target.value),
                                    required: true,
                                    autoComplete: "username",
                                    className: "form-input",
                                    minLength: "3"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("label", {
                                    className: "form-label",
                                    htmlFor: "login-password",
                                    children: "Password:"
                                }),
                                /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("input", {
                                    id: "login-password",
                                    name: "password",
                                    type: "password",
                                    value: password,
                                    onChange: (event)=>setPassword(event.target.value),
                                    required: true,
                                    autoComplete: "current-password",
                                    className: "form-input"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("button", {
                            type: "submit",
                            disabled: isSubmitting,
                            className: "button button-primary w-full",
                            children: isSubmitting ? 'Signing in...' : 'Login'
                        })
                    ]
                }),
                (error || sessionNotice) && /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("div", {
                    id: "login-feedback",
                    className: "auth-notice mt-4",
                    role: "alert",
                    children: [
                        /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("p", {
                            className: "min-w-0 flex-1",
                            children: error || sessionNotice
                        }),
                        /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("button", {
                            type: "button",
                            "aria-label": "Dismiss message",
                            className: "button button-secondary shrink-0 px-3",
                            onClick: ()=>{
                                setError('');
                                clearSessionNotice();
                                usernameInput.current?.focus();
                            },
                            children: /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("svg", {
                                "aria-hidden": "true",
                                focusable: "false",
                                className: "h-5 w-5",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                children: /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("path", {
                                    d: "M6 6l12 12M6 18L18 6",
                                    strokeWidth: "2",
                                    strokeLinecap: "round"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("p", {
                    className: "mt-6 text-text-secondary",
                    children: [
                        "Need an account?",
                        ' ',
                        /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $872c5e169d87e980$export$a6c7ac8248d6e38a), {
                            to: "/signup",
                            className: "auth-link",
                            children: "Signup"
                        })
                    ]
                })
            ]
        })
    });
};




var $iQhxf = parcelRequire("iQhxf");


const $ced35e7a829a5b3d$export$25f3896ea1e09820 = ()=>{
    const usernameInput = (0, $iQhxf.useRef)(null);
    const confirmationInput = (0, $iQhxf.useRef)(null);
    const [username, setUsername] = (0, $iQhxf.useState)('');
    const [password, setPassword] = (0, $iQhxf.useState)('');
    const [confirmPassword, setConfirmPassword] = (0, $iQhxf.useState)('');
    const [email, setEmail] = (0, $iQhxf.useState)('');
    const [birthday, setBirthday] = (0, $iQhxf.useState)('');
    const [success, setSuccess] = (0, $iQhxf.useState)(false);
    const [error, setError] = (0, $iQhxf.useState)('');
    const [fieldErrors, setFieldErrors] = (0, $iQhxf.useState)({});
    const [isSubmitting, setIsSubmitting] = (0, $iQhxf.useState)(false);
    const passwordMismatch = Boolean(fieldErrors.ConfirmPassword);
    const now = new Date();
    const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    const fieldProps = (field, help)=>({
            'aria-invalid': fieldErrors[field] ? true : undefined,
            'aria-describedby': [
                help,
                fieldErrors[field] ? `signup-${field}-error` : null
            ].filter(Boolean).join(' ') || undefined
        });
    const fieldMessage = (field)=>fieldErrors[field] && /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("p", {
            id: `signup-${field}-error`,
            className: "mt-2 text-body-sm text-text-muted",
            children: fieldErrors[field]
        });
    // Validate locally, then map API validation errors to the matching fields.
    const handleSubmit = async (event)=>{
        event.preventDefault();
        if (isSubmitting) return;
        const form = event.currentTarget;
        const errors = {};
        if (!/^[A-Za-z0-9]{5,}$/.test(username)) errors.Username = 'Enter at least 5 characters using letters and numbers only; no spaces or symbols.';
        // Enforce the password minimum in characters and the API limit in UTF-8 bytes.
        if (Array.from(password).length < 8) errors.Password = 'Enter a password with at least 8 characters.';
        else if (new TextEncoder().encode(password).length > 72) errors.Password = 'Password must not exceed 72 UTF-8 bytes.';
        if (!confirmPassword || password !== confirmPassword) errors.ConfirmPassword = 'The passwords do not match. Please try again.';
        if (!email || form.elements.email.validity.typeMismatch) errors.Email = 'Enter a valid email address.';
        if (birthday) {
            const parsed = new Date(`${birthday}T00:00:00Z`);
            if (!/^\d{4}-\d{2}-\d{2}$/.test(birthday) || Number.isNaN(parsed.getTime()) || parsed.toISOString().slice(0, 10) !== birthday) errors.Birthday = 'Enter a valid date in YYYY-MM-DD format.';
            else if (birthday > today) errors.Birthday = 'Birthday must not be in the future.';
        }
        setFieldErrors(errors);
        setSuccess(false);
        if (Object.keys(errors).length) {
            setError(errors.ConfirmPassword || 'Please correct the highlighted fields.');
            form.querySelector(`[data-field="${Object.keys(errors)[0]}"]`)?.focus();
            return;
        }
        setError('');
        setIsSubmitting(true);
        try {
            await (0, $a3d754e15ed774ee$export$644d8ea042df96a6).signup({
                Username: username,
                Password: password,
                Email: email,
                // Omit a blank birthday to preserve the API's optional registration contract.
                ...birthday ? {
                    Birthday: birthday
                } : {}
            });
            setSuccess(true);
        } catch (requestError) {
            const errors = {};
            for (const issue of requestError.errors || [])if ([
                'Username',
                'Password',
                'Email',
                'Birthday'
            ].includes(issue.path)) errors[issue.path] = issue.msg;
            if (requestError.status === 400 && !Object.keys(errors).length) errors.Username = requestError.message;
            setFieldErrors(errors);
            setError(Object.keys(errors).length ? 'Please correct the highlighted fields.' : 'Registration unsuccessful. Please try again.');
            if (Object.keys(errors).length) form.querySelector(`[data-field="${Object.keys(errors)[0]}"]`)?.focus();
        } finally{
            setIsSubmitting(false);
        }
    };
    return /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("div", {
        className: "auth-layout",
        children: /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("section", {
            className: "auth-panel",
            "aria-labelledby": "signup-title",
            children: [
                /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("h1", {
                    id: "signup-title",
                    className: "mb-6 text-heading-lg-mobile sm:text-heading-lg",
                    children: "Signup"
                }),
                /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("p", {
                    className: "mb-4 text-body-sm text-text-muted",
                    children: "All fields are required except Birthday."
                }),
                /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("form", {
                    noValidate: true,
                    onSubmit: handleSubmit,
                    "aria-busy": isSubmitting,
                    "aria-describedby": error ? 'signup-feedback' : undefined,
                    className: "space-y-4",
                    children: [
                        /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("label", {
                                    className: "form-label",
                                    htmlFor: "signup-username",
                                    children: "Username:"
                                }),
                                /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("input", {
                                    ref: usernameInput,
                                    id: "signup-username",
                                    name: "username",
                                    type: "text",
                                    value: username,
                                    onChange: (event)=>setUsername(event.target.value),
                                    required: true,
                                    autoComplete: "username",
                                    className: "form-input",
                                    minLength: "5",
                                    pattern: "[A-Za-z0-9]+",
                                    "data-field": "Username",
                                    ...fieldProps('Username', 'signup-username-help')
                                }),
                                /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("p", {
                                    id: "signup-username-help",
                                    className: "mt-2 text-body-sm text-text-muted",
                                    children: "At least 5 characters. Letters and numbers only; no spaces or symbols."
                                }),
                                fieldMessage('Username')
                            ]
                        }),
                        /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("label", {
                                    className: "form-label",
                                    htmlFor: "signup-password",
                                    children: "Password:"
                                }),
                                /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("input", {
                                    id: "signup-password",
                                    name: "password",
                                    type: "password",
                                    value: password,
                                    onChange: (event)=>setPassword(event.target.value),
                                    required: true,
                                    autoComplete: "new-password",
                                    className: "form-input",
                                    minLength: "8",
                                    "data-field": "Password",
                                    ...fieldProps('Password', 'signup-password-help')
                                }),
                                /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("p", {
                                    id: "signup-password-help",
                                    className: "mt-2 text-body-sm text-text-muted",
                                    children: "At least 8 characters."
                                }),
                                fieldMessage('Password')
                            ]
                        }),
                        /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("label", {
                                    className: "form-label",
                                    htmlFor: "signup-confirmPassword",
                                    children: "Confirm Password:"
                                }),
                                /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("input", {
                                    ref: confirmationInput,
                                    id: "signup-confirmPassword",
                                    name: "confirmPassword",
                                    type: "password",
                                    value: confirmPassword,
                                    onChange: (event)=>setConfirmPassword(event.target.value),
                                    required: true,
                                    autoComplete: "new-password",
                                    className: "form-input",
                                    "data-field": "ConfirmPassword",
                                    ...fieldProps('ConfirmPassword')
                                }),
                                fieldMessage('ConfirmPassword')
                            ]
                        }),
                        /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("label", {
                                    className: "form-label",
                                    htmlFor: "signup-email",
                                    children: "Email:"
                                }),
                                /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("input", {
                                    id: "signup-email",
                                    name: "email",
                                    type: "email",
                                    value: email,
                                    onChange: (event)=>setEmail(event.target.value),
                                    required: true,
                                    autoComplete: "email",
                                    className: "form-input",
                                    "data-field": "Email",
                                    ...fieldProps('Email')
                                }),
                                fieldMessage('Email')
                            ]
                        }),
                        /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("label", {
                                    className: "form-label",
                                    htmlFor: "signup-birthday",
                                    children: "Birthday (optional):"
                                }),
                                /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("input", {
                                    id: "signup-birthday",
                                    name: "birthday",
                                    type: "date",
                                    value: birthday,
                                    onChange: (event)=>setBirthday(event.target.value),
                                    max: today,
                                    autoComplete: "bday",
                                    className: "form-input",
                                    "data-field": "Birthday",
                                    ...fieldProps('Birthday')
                                }),
                                fieldMessage('Birthday')
                            ]
                        }),
                        /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("button", {
                            type: "submit",
                            disabled: isSubmitting,
                            className: "button button-primary w-full",
                            children: isSubmitting ? 'Creating account...' : 'Signup'
                        })
                    ]
                }),
                success && /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("p", {
                    className: "auth-notice mt-4",
                    role: "status",
                    children: "Sign up successful. Account created."
                }),
                error && /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("div", {
                    id: "signup-feedback",
                    className: "auth-notice mt-4",
                    role: "alert",
                    children: [
                        /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("p", {
                            className: "min-w-0 flex-1",
                            children: error
                        }),
                        /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("button", {
                            type: "button",
                            "aria-label": "Dismiss message",
                            className: "button button-secondary shrink-0 px-3",
                            onClick: ()=>{
                                setError('');
                                setFieldErrors({});
                                (passwordMismatch ? confirmationInput : usernameInput).current?.focus();
                            },
                            children: /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("svg", {
                                "aria-hidden": "true",
                                focusable: "false",
                                className: "h-5 w-5",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                children: /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("path", {
                                    d: "M6 6l12 12M6 18L18 6",
                                    strokeWidth: "2",
                                    strokeLinecap: "round"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("p", {
                    className: "mt-6 text-text-secondary",
                    children: [
                        "Already have an account?",
                        ' ',
                        /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $872c5e169d87e980$export$a6c7ac8248d6e38a), {
                            to: "/login",
                            className: "auth-link",
                            children: "Login"
                        })
                    ]
                })
            ]
        })
    });
};




var $iQhxf = parcelRequire("iQhxf");


const $e54f00686d3d1f8f$export$214ae410b202e65a = ({ user: user, onLoggedOut: onLoggedOut })=>{
    const [isMenuOpen, setIsMenuOpen] = (0, $iQhxf.useState)(false);
    const menuButton = (0, $iQhxf.useRef)(null);
    const location = (0, $872c5e169d87e980$export$45d76561a5302f2b)();
    // Close the mobile menu after navigation or an authentication change.
    (0, $iQhxf.useEffect)(()=>{
        setIsMenuOpen(false);
    }, [
        location.pathname,
        user
    ]);
    const closeMenu = ()=>setIsMenuOpen(false);
    const navigationItems = user ? [
        {
            to: '/',
            label: 'Home'
        },
        {
            to: '/profile',
            label: 'My Profile'
        }
    ] : [
        {
            to: '/login',
            label: 'Login'
        },
        {
            to: '/signup',
            label: 'Signup'
        }
    ];
    const renderLinks = ()=>/*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)((0, $ff32bd79773053fb$exports.Fragment), {
            children: [
                navigationItems.map(({ to: to, label: label })=>/*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $872c5e169d87e980$export$b0d92dbee9b5b60d), {
                        to: to,
                        end: true,
                        className: "nav-link",
                        onClick: closeMenu,
                        children: label
                    }, to)),
                user && /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("button", {
                    type: "button",
                    className: "button button-secondary",
                    onClick: ()=>{
                        closeMenu();
                        onLoggedOut();
                    },
                    children: "Logout"
                })
            ]
        });
    return /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)((0, $ff32bd79773053fb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("a", {
                className: "skip-link",
                href: "#main-content",
                children: "Skip to main content"
            }),
            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("header", {
                className: "border-b border-border-subtle bg-surface-1",
                children: /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("nav", {
                    "aria-label": "Main navigation",
                    className: "page-container",
                    onKeyDown: (event)=>{
                        if (event.key === 'Escape' && isMenuOpen) {
                            event.preventDefault();
                            closeMenu();
                            menuButton.current?.focus();
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("div", {
                            className: "flex min-h-[72px] items-center justify-between gap-4 py-3",
                            children: [
                                /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $872c5e169d87e980$export$a6c7ac8248d6e38a), {
                                    to: "/",
                                    onClick: closeMenu,
                                    className: "inline-flex min-h-[44px] items-center rounded-control text-2xl font-extrabold tracking-tight text-primary",
                                    children: "myFlix"
                                }),
                                /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("div", {
                                    className: "hidden items-center gap-2 sm:flex",
                                    children: renderLinks()
                                }),
                                /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("button", {
                                    ref: menuButton,
                                    type: "button",
                                    className: "button button-secondary sm:hidden",
                                    "aria-controls": "mobile-menu",
                                    "aria-expanded": isMenuOpen,
                                    "aria-label": isMenuOpen ? 'Close main menu' : 'Open main menu',
                                    onClick: ()=>setIsMenuOpen((open)=>!open),
                                    children: /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("svg", {
                                        "aria-hidden": "true",
                                        focusable: "false",
                                        className: "h-6 w-6",
                                        stroke: "currentColor",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        children: /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("path", {
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            strokeWidth: "2",
                                            d: isMenuOpen ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16M4 18h16'
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("div", {
                            id: "mobile-menu",
                            hidden: !isMenuOpen,
                            className: "border-t border-border-subtle pb-4 pt-3 sm:hidden",
                            children: /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("div", {
                                className: "flex flex-col items-stretch gap-2",
                                children: renderLinks()
                            })
                        })
                    ]
                })
            })
        ]
    });
};
$e54f00686d3d1f8f$export$214ae410b202e65a.propTypes = {
    user: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).object,
    onLoggedOut: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).func.isRequired
};




var $iQhxf = parcelRequire("iQhxf");



parcelRequire("iQhxf");

function $b177856c1ebd6da4$var$UserInfo({ email: email, name: name, birthday: birthday }) {
    return /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("section", {
        className: "profile-panel",
        "aria-labelledby": "account-information-title",
        children: [
            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("h2", {
                id: "account-information-title",
                className: "mb-6 text-heading-md",
                children: "Account Information"
            }),
            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("dl", {
                className: "space-y-4",
                children: [
                    /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("dt", {
                                className: "text-label text-text-muted",
                                children: "Username"
                            }),
                            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("dd", {
                                className: "mt-1 break-words",
                                children: name
                            })
                        ]
                    }),
                    email && /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("dt", {
                                className: "text-label text-text-muted",
                                children: "Email"
                            }),
                            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("dd", {
                                className: "mt-1 break-words",
                                children: email
                            })
                        ]
                    }),
                    birthday && /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("dt", {
                                className: "text-label text-text-muted",
                                children: "Birthday"
                            }),
                            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("dd", {
                                className: "mt-1",
                                children: /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("time", {
                                    dateTime: birthday,
                                    children: birthday
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
$b177856c1ebd6da4$var$UserInfo.propTypes = {
    email: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).string,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).string.isRequired,
    birthday: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).string
};
var $b177856c1ebd6da4$export$2e2bcd8739ae039 = $b177856c1ebd6da4$var$UserInfo;



parcelRequire("iQhxf");


function $e95b5b4239c5dd38$var$FavoriteMovies({ favoriteMovies: favoriteMovies, isLoading: isLoading = false, error: error = '', hasFavoriteIds: hasFavoriteIds = false }) {
    return /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("section", {
        "aria-labelledby": "favorite-movies-title",
        children: [
            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("h2", {
                id: "favorite-movies-title",
                className: "mb-6 text-heading-md",
                children: "Favorite Movies"
            }),
            isLoading ? /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("p", {
                className: "library-notice",
                role: "status",
                children: "Loading favorite movies..."
            }) : error ? /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("p", {
                className: "library-notice",
                role: "alert",
                children: error
            }) : favoriteMovies.length === 0 ? /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("p", {
                className: "library-notice",
                role: "status",
                children: hasFavoriteIds ? 'Your favorite movies are not available in the current catalog.' : "You haven't added any favorite movies yet."
            }) : /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("div", {
                className: "movie-grid",
                children: favoriteMovies.map((movie)=>/*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $387be721b7eb71a7$export$9bd698419030e459), {
                        movie: movie,
                        headingLevel: 3
                    }, movie.id))
            })
        ]
    });
}
$e95b5b4239c5dd38$var$FavoriteMovies.propTypes = {
    favoriteMovies: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).array.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).bool,
    error: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).string,
    hasFavoriteIds: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).bool
};
var $e95b5b4239c5dd38$export$2e2bcd8739ae039 = $e95b5b4239c5dd38$var$FavoriteMovies;



parcelRequire("iQhxf");

function $0d50badd332ae5fc$var$UpdateUser({ handleSubmit: handleSubmit, username: username, setUsername: setUsername, usernameError: usernameError = '', password: password, setPassword: setPassword, email: email, setEmail: setEmail, birthday: birthday, setBirthday: setBirthday, birthdayRequired: birthdayRequired, isSaving: isSaving, success: success = '', error: error = '', passwordError: passwordError = '', setPasswordError: setPasswordError }) {
    return /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("section", {
        className: "profile-panel",
        "aria-labelledby": "update-account-title",
        children: [
            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("h2", {
                id: "update-account-title",
                className: "mb-6 text-heading-md",
                children: "Update Account"
            }),
            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("form", {
                onSubmit: handleSubmit,
                className: "space-y-4",
                "aria-busy": isSaving,
                "aria-describedby": error ? 'profile-update-error' : undefined,
                children: [
                    /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("label", {
                                htmlFor: "profile-username",
                                className: "form-label",
                                children: "Username:"
                            }),
                            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("input", {
                                id: "profile-username",
                                type: "text",
                                value: username,
                                onChange: (event)=>{
                                    setUsername(event.target.value);
                                },
                                className: "form-input",
                                required: true,
                                placeholder: "Enter Username",
                                autoComplete: "username",
                                "aria-invalid": usernameError ? true : undefined,
                                "aria-describedby": usernameError ? 'profile-username-error' : undefined
                            }),
                            usernameError && /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("p", {
                                id: "profile-username-error",
                                className: "mt-2 text-body-sm text-text-muted",
                                role: "alert",
                                children: usernameError
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("label", {
                                htmlFor: "profile-password",
                                className: "form-label",
                                children: "Password (optional)"
                            }),
                            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("input", {
                                id: "profile-password",
                                type: "password",
                                value: password,
                                onChange: (event)=>{
                                    setPassword(event.target.value);
                                    setPasswordError('');
                                },
                                className: "form-input",
                                placeholder: "Leave blank to keep your password",
                                autoComplete: "new-password",
                                "aria-invalid": passwordError ? true : undefined,
                                "aria-describedby": passwordError ? 'profile-password-help profile-password-error' : 'profile-password-help'
                            }),
                            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("p", {
                                id: "profile-password-help",
                                className: "mt-2 text-body-sm text-text-muted",
                                children: "Leave blank to keep your password. New passwords need at least 8 characters and may not exceed 72 UTF-8 bytes. An unchanged legacy password shorter than 8 characters is also accepted."
                            }),
                            passwordError && /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("p", {
                                id: "profile-password-error",
                                className: "mt-2 text-body-sm text-text-muted",
                                role: "alert",
                                children: passwordError
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("label", {
                                htmlFor: "profile-email",
                                className: "form-label",
                                children: "Email:"
                            }),
                            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("input", {
                                id: "profile-email",
                                type: "email",
                                value: email,
                                onChange: (event)=>setEmail(event.target.value),
                                className: "form-input",
                                required: true,
                                placeholder: "Enter Email",
                                autoComplete: "email"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("label", {
                                htmlFor: "profile-birthday",
                                className: "form-label",
                                children: "Birthday:"
                            }),
                            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("input", {
                                id: "profile-birthday",
                                type: "date",
                                value: birthday,
                                onChange: (event)=>setBirthday(event.target.value),
                                className: "form-input",
                                required: birthdayRequired,
                                autoComplete: "bday"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("button", {
                        type: "submit",
                        disabled: isSaving,
                        className: "button button-primary",
                        children: isSaving ? 'Saving...' : 'Save Changes'
                    })
                ]
            }),
            success && /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("p", {
                className: "mt-4 text-text-secondary",
                role: "status",
                children: success
            }),
            error && /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("p", {
                id: "profile-update-error",
                className: "mt-4 text-text-secondary",
                role: "alert",
                children: error
            })
        ]
    });
}
$0d50badd332ae5fc$var$UpdateUser.propTypes = {
    handleSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).func.isRequired,
    username: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).string.isRequired,
    setUsername: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).func.isRequired,
    usernameError: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).string,
    password: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).string.isRequired,
    setPassword: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).func.isRequired,
    email: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).string.isRequired,
    setEmail: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).func.isRequired,
    birthday: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).string.isRequired,
    setBirthday: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).func.isRequired,
    birthdayRequired: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).bool.isRequired,
    isSaving: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).bool.isRequired,
    success: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).string,
    error: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).string,
    passwordError: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).string,
    setPasswordError: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).func.isRequired
};
var $0d50badd332ae5fc$export$2e2bcd8739ae039 = $0d50badd332ae5fc$var$UpdateUser;




const $047b5d17bcedb2e5$var$toDateInputValue = (value)=>{
    if (!value) return '';
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? '' : date.toISOString().slice(0, 10);
};
const $047b5d17bcedb2e5$var$emptyUser = {
    Username: '',
    Email: '',
    Birthday: '',
    FavoriteMovies: []
};
const $047b5d17bcedb2e5$export$b378b4d12a0dcbde = ({ movies: movies, isLoadingMovies: isLoadingMovies = false, movieError: movieError = '' })=>{
    const { user: user, token: token, updateUser: updateUser, logout: logout, handleApiError: handleApiError } = (0, $32487ffaa9d71536$export$fdc397e486fa83e7)();
    const currentUser = user || $047b5d17bcedb2e5$var$emptyUser;
    const hasUser = Boolean(user);
    const [username, setUsername] = (0, $iQhxf.useState)(currentUser.Username);
    const [usernameError, setUsernameError] = (0, $iQhxf.useState)('');
    const [password, setPassword] = (0, $iQhxf.useState)('');
    const [passwordError, setPasswordError] = (0, $iQhxf.useState)('');
    const [email, setEmail] = (0, $iQhxf.useState)(currentUser.Email || '');
    // The API preserves omitted birthdays, so require a date only for accounts that already have one.
    const [birthdayWasSaved] = (0, $iQhxf.useState)(()=>Boolean(currentUser.Birthday || currentUser.BirthDate));
    const [birthday, setBirthday] = (0, $iQhxf.useState)($047b5d17bcedb2e5$var$toDateInputValue(currentUser.Birthday || currentUser.BirthDate));
    const [showModal, setShowModal] = (0, $iQhxf.useState)(false);
    const [success, setSuccess] = (0, $iQhxf.useState)('');
    const [error, setError] = (0, $iQhxf.useState)('');
    const [isSaving, setIsSaving] = (0, $iQhxf.useState)(false);
    const [isDeleting, setIsDeleting] = (0, $iQhxf.useState)(false);
    const [deleteError, setDeleteError] = (0, $iQhxf.useState)('');
    const savingPending = (0, $iQhxf.useRef)(false);
    const deletionPending = (0, $iQhxf.useRef)(false);
    const dialog = (0, $iQhxf.useRef)(null);
    const cancelButton = (0, $iQhxf.useRef)(null);
    const deleteTrigger = (0, $iQhxf.useRef)(null);
    // Keep keyboard focus inside the delete dialog and restore it when closed.
    (0, $iQhxf.useEffect)(()=>{
        if (!showModal || !hasUser) return;
        const root = document.getElementById('root');
        const wasInert = root?.hasAttribute('inert');
        const previousOverflow = document.body.style.overflow;
        root?.setAttribute('inert', '');
        document.body.style.overflow = 'hidden';
        const focusable = ()=>Array.from(dialog.current?.querySelectorAll('button:not(:disabled)') || []);
        const focusInside = ()=>(focusable()[0] || dialog.current)?.focus();
        cancelButton.current?.focus();
        const containFocus = (event)=>{
            if (!dialog.current?.contains(event.target)) focusInside();
        };
        const handleKeyDown = (event)=>{
            if (event.key === 'Escape') {
                event.preventDefault();
                if (!deletionPending.current) setShowModal(false);
            }
            if (event.key === 'Tab') {
                const controls = focusable();
                const first = controls[0];
                const last = controls[controls.length - 1];
                if (!first) {
                    event.preventDefault();
                    dialog.current?.focus();
                } else if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog.current)) {
                    event.preventDefault();
                    last.focus();
                } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === dialog.current)) {
                    event.preventDefault();
                    first.focus();
                }
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        document.addEventListener('focusin', containFocus);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
            document.removeEventListener('focusin', containFocus);
            if (!wasInert) root?.removeAttribute('inert');
            document.body.style.overflow = previousOverflow;
            if (deleteTrigger.current?.isConnected) deleteTrigger.current.focus();
        };
    }, [
        showModal,
        hasUser
    ]);
    (0, $iQhxf.useEffect)(()=>{
        if (showModal && isDeleting) dialog.current?.focus();
    }, [
        showModal,
        isDeleting
    ]);
    (0, $iQhxf.useEffect)(()=>{
        setUsername(currentUser.Username);
        setPassword('');
        setPasswordError('');
        setEmail(currentUser.Email || '');
        setBirthday($047b5d17bcedb2e5$var$toDateInputValue(currentUser.Birthday || currentUser.BirthDate));
    }, [
        currentUser
    ]);
    const favoriteMovies = (0, $iQhxf.useMemo)(()=>movies.filter((movie)=>currentUser.FavoriteMovies?.includes(movie.id)), [
        movies,
        currentUser.FavoriteMovies
    ]);
    // Validate profile edits and map API field errors back to the form.
    const handleSubmit = async (event)=>{
        event.preventDefault();
        if (savingPending.current || deletionPending.current) return;
        setUsernameError('');
        setPasswordError('');
        setError('');
        setSuccess('');
        // The minimum applies to changed names; unchanged legacy usernames remain valid.
        if (username !== currentUser.Username && username.length < 5) {
            setUsernameError('A changed username must contain at least 5 characters.');
            event.currentTarget.querySelector('#profile-username')?.focus();
            return;
        }
        // The API enforces the replacement-password minimum; this client checks its UTF-8 byte ceiling.
        if (password && new TextEncoder().encode(password).length > 72) {
            setPasswordError('Password must not exceed 72 UTF-8 bytes.');
            event.currentTarget.querySelector('#profile-password')?.focus();
            return;
        }
        savingPending.current = true;
        setIsSaving(true);
        // Omit blank birthday/password fields so the API can preserve existing values.
        const updates = {
            Username: username,
            Email: email
        };
        if (birthday) updates.Birthday = birthday;
        if (password) updates.Password = password;
        try {
            const updatedUser = await (0, $a3d754e15ed774ee$export$644d8ea042df96a6).updateUser(currentUser.Username, updates, token);
            if (updatedUser.Username !== currentUser.Username) {
                logout('Your username was changed. Please sign in again.');
                return;
            }
            updateUser(updatedUser);
            setSuccess('Update successful.');
        } catch (requestError) {
            if (!handleApiError(requestError)) {
                const usernameIssue = requestError.errors?.find((issue)=>issue.path === 'Username');
                const passwordIssue = requestError.errors?.find((issue)=>issue.path === 'Password');
                if (usernameIssue) setUsernameError(usernameIssue.msg.includes('at least 5') ? 'A changed username must contain at least 5 characters.' : 'Changed usernames must use ASCII letters and numbers only.');
                if (passwordIssue) setPasswordError(passwordIssue.msg.includes('72 UTF-8 bytes') ? 'Password must not exceed 72 UTF-8 bytes.' : 'A new password must contain at least 8 characters. Leave blank to keep your existing password.');
                if (!usernameIssue && !passwordIssue) setError('Update unsuccessful. Please try again.');
            }
        } finally{
            savingPending.current = false;
            setIsSaving(false);
        }
    };
    const handleDeleteUser = async ()=>{
        if (deletionPending.current || savingPending.current) return;
        deletionPending.current = true;
        setDeleteError('');
        setIsDeleting(true);
        try {
            await (0, $a3d754e15ed774ee$export$644d8ea042df96a6).deleteUser(currentUser.Username, token);
            logout();
        } catch (requestError) {
            if (!handleApiError(requestError)) setDeleteError('Account deletion unsuccessful. Please try again.');
        } finally{
            deletionPending.current = false;
            setIsDeleting(false);
        }
    };
    if (!user) return null;
    return /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("div", {
        className: "space-y-8",
        children: [
            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("h1", {
                className: "text-heading-lg-mobile sm:text-heading-lg",
                children: "My Profile"
            }),
            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("div", {
                className: "grid items-start gap-6 lg:grid-cols-2",
                children: [
                    /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $b177856c1ebd6da4$export$2e2bcd8739ae039), {
                        name: currentUser.Username,
                        email: currentUser.Email,
                        birthday: $047b5d17bcedb2e5$var$toDateInputValue(currentUser.Birthday || currentUser.BirthDate)
                    }),
                    /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $0d50badd332ae5fc$export$2e2bcd8739ae039), {
                        handleSubmit: handleSubmit,
                        setUsername: (value)=>{
                            setUsername(value);
                            setUsernameError('');
                        },
                        usernameError: usernameError,
                        setPassword: setPassword,
                        setEmail: setEmail,
                        setBirthday: setBirthday,
                        username: username,
                        password: password,
                        email: email,
                        birthday: birthday,
                        isSaving: isSaving,
                        success: success,
                        error: error,
                        passwordError: passwordError,
                        setPasswordError: setPasswordError,
                        birthdayRequired: birthdayWasSaved
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $e95b5b4239c5dd38$export$2e2bcd8739ae039), {
                favoriteMovies: favoriteMovies,
                isLoading: isLoadingMovies,
                error: movieError,
                hasFavoriteIds: Boolean(currentUser.FavoriteMovies?.length)
            }),
            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("section", {
                className: "profile-panel border-danger bg-danger-subtle",
                "aria-labelledby": "danger-zone-title",
                children: [
                    /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("h2", {
                        id: "danger-zone-title",
                        className: "mb-4 text-heading-md",
                        children: "Danger Zone"
                    }),
                    /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("p", {
                        className: "mb-6 text-text-secondary",
                        children: "Deleting your account permanently removes your account information and favorites."
                    }),
                    /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("button", {
                        ref: deleteTrigger,
                        type: "button",
                        className: "button button-danger",
                        disabled: isSaving,
                        onClick: ()=>{
                            setDeleteError('');
                            setShowModal(true);
                        },
                        children: "Delete Account"
                    })
                ]
            }),
            showModal && /*#__PURE__*/ (0, $6b69b237a3b768b7$exports.createPortal)(/*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("div", {
                className: "profile-dialog-backdrop",
                children: [
                    /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("div", {
                        className: "absolute inset-0 bg-canvas opacity-90",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("div", {
                        ref: dialog,
                        role: "dialog",
                        "aria-modal": "true",
                        "aria-labelledby": "delete-account-title",
                        "aria-describedby": deleteError ? 'delete-account-description delete-account-error' : 'delete-account-description',
                        "aria-busy": isDeleting,
                        tabIndex: -1,
                        className: "surface-elevated relative max-h-[calc(100dvh-32px)] w-full max-w-md overflow-y-auto p-6 sm:p-8",
                        children: [
                            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("h2", {
                                id: "delete-account-title",
                                className: "mb-4 text-heading-md",
                                children: "Delete Account"
                            }),
                            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("p", {
                                id: "delete-account-description",
                                className: "mb-6 text-text-secondary",
                                children: "Delete your account permanently? This action cannot be undone."
                            }),
                            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("div", {
                                className: "flex flex-col gap-3 sm:flex-row sm:justify-end",
                                children: [
                                    /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("button", {
                                        ref: cancelButton,
                                        type: "button",
                                        className: "button button-secondary",
                                        disabled: isDeleting,
                                        onClick: ()=>setShowModal(false),
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("button", {
                                        type: "button",
                                        className: "button button-danger",
                                        onClick: handleDeleteUser,
                                        disabled: isDeleting,
                                        children: isDeleting ? 'Deleting...' : 'Delete Account'
                                    })
                                ]
                            }),
                            deleteError && /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("p", {
                                id: "delete-account-error",
                                role: "alert",
                                className: "mt-4 text-text-secondary",
                                children: deleteError
                            })
                        ]
                    })
                ]
            }), document.body)
        ]
    });
};
$047b5d17bcedb2e5$export$b378b4d12a0dcbde.propTypes = {
    movies: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).array.isRequired,
    isLoadingMovies: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).bool,
    movieError: (0, (/*@__PURE__*/$parcel$interopDefault($c76bdfd2befe6dfd$exports))).string
};





const $7dc78890c7af40de$var$MainView = ()=>{
    const [movies, setMovies] = (0, $iQhxf.useState)([]);
    const [filter, setFilter] = (0, $iQhxf.useState)('');
    const [isLoading, setIsLoading] = (0, $iQhxf.useState)(false);
    const [movieError, setMovieError] = (0, $iQhxf.useState)('');
    const { user: user, token: token, logout: logout, handleApiError: handleApiError } = (0, $32487ffaa9d71536$export$fdc397e486fa83e7)();
    // Load and normalize the authenticated user's movie catalog.
    (0, $iQhxf.useEffect)(()=>{
        const controller = new AbortController();
        if (!token) {
            setMovies([]);
            setIsLoading(false);
            setMovieError('');
            return ()=>controller.abort();
        }
        setIsLoading(true);
        setMovieError('');
        (0, $a3d754e15ed774ee$export$644d8ea042df96a6).getMovies(token, controller.signal).then((data)=>{
            if (!Array.isArray(data)) throw new Error('The movie service returned an invalid response.');
            const moviesFromApi = data.map((movie)=>({
                    id: movie._id,
                    title: movie.Title,
                    description: movie.Description,
                    genre: movie.Genre?.Name || 'Unknown',
                    director: movie.Director?.Name || 'Unknown',
                    image: movie.ImagePath
                }));
            if (!controller.signal.aborted) setMovies(moviesFromApi);
        }).catch((error)=>{
            if (controller.signal.aborted) return;
            if (!handleApiError(error)) {
                setMovieError('Movies could not be loaded. Please try again later.');
                setMovies([]);
            }
        }).finally(()=>{
            if (!controller.signal.aborted) setIsLoading(false);
        });
        return ()=>controller.abort();
    }, [
        token,
        handleApiError
    ]);
    const filteredMovies = movies.filter((movie)=>movie.title.toLowerCase().includes(filter.toLowerCase()));
    return /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)((0, $872c5e169d87e980$export$9ba4e89fdfa1fc54), {
        children: [
            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $e54f00686d3d1f8f$export$214ae410b202e65a), {
                user: user,
                onLoggedOut: logout
            }),
            /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("main", {
                id: "main-content",
                tabIndex: -1,
                className: "page-container py-6",
                children: /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)((0, $872c5e169d87e980$export$3565eb3d00ca5a74), {
                    children: [
                        /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $872c5e169d87e980$export$e7b0ac011bb776c6), {
                            path: "/signup",
                            element: /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $ff32bd79773053fb$exports.Fragment), {
                                children: user ? /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $872c5e169d87e980$export$444b3ab0cb9aec40), {
                                    to: "/"
                                }) : /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $ced35e7a829a5b3d$export$25f3896ea1e09820), {})
                            })
                        }),
                        /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $872c5e169d87e980$export$e7b0ac011bb776c6), {
                            path: "/login",
                            element: /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $ff32bd79773053fb$exports.Fragment), {
                                children: user ? /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $872c5e169d87e980$export$444b3ab0cb9aec40), {
                                    to: "/"
                                }) : /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $13fdb569d35102c2$export$1582048ca8384970), {})
                            })
                        }),
                        /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $872c5e169d87e980$export$e7b0ac011bb776c6), {
                            path: "/profile",
                            element: /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $ff32bd79773053fb$exports.Fragment), {
                                children: !user ? /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $872c5e169d87e980$export$444b3ab0cb9aec40), {
                                    to: "/login",
                                    replace: true
                                }) : /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $047b5d17bcedb2e5$export$b378b4d12a0dcbde), {
                                    movies: movies,
                                    isLoadingMovies: isLoading,
                                    movieError: movieError
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $872c5e169d87e980$export$e7b0ac011bb776c6), {
                            path: "/movies/:movieId",
                            element: /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $ff32bd79773053fb$exports.Fragment), {
                                children: !user ? /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $872c5e169d87e980$export$444b3ab0cb9aec40), {
                                    to: "/login",
                                    replace: true
                                }) : isLoading ? /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("p", {
                                    className: "library-notice",
                                    role: "status",
                                    children: "Loading movies..."
                                }) : movieError ? /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("div", {
                                    className: "library-notice",
                                    role: "alert",
                                    children: [
                                        /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("p", {
                                            children: movieError
                                        }),
                                        /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $872c5e169d87e980$export$a6c7ac8248d6e38a), {
                                            to: "/",
                                            className: "button button-secondary mt-4",
                                            children: "Back to Movies"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $c23f257bef54ec96$export$78d497080ea8f89a), {
                                    movies: movies
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $872c5e169d87e980$export$e7b0ac011bb776c6), {
                            path: "/",
                            element: /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $ff32bd79773053fb$exports.Fragment), {
                                children: !user ? /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $872c5e169d87e980$export$444b3ab0cb9aec40), {
                                    to: "/login",
                                    replace: true
                                }) : /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("section", {
                                    "aria-labelledby": "movie-library-title",
                                    children: [
                                        /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("h1", {
                                            id: "movie-library-title",
                                            className: "text-heading-lg-mobile sm:text-heading-lg",
                                            children: "Movie Library"
                                        }),
                                        /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsxs)("div", {
                                            role: "search",
                                            "aria-label": "Movie library",
                                            className: "my-6 max-w-md",
                                            children: [
                                                /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("label", {
                                                    htmlFor: "movie-search",
                                                    className: "form-label",
                                                    children: "Search movies"
                                                }),
                                                /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("input", {
                                                    id: "movie-search",
                                                    type: "search",
                                                    placeholder: "Search by title...",
                                                    value: filter,
                                                    onChange: (event)=>setFilter(event.target.value),
                                                    className: "form-input"
                                                })
                                            ]
                                        }),
                                        isLoading ? /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("p", {
                                            className: "library-notice",
                                            role: "status",
                                            children: "Loading movies..."
                                        }) : movieError ? /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("p", {
                                            className: "library-notice",
                                            role: "alert",
                                            children: movieError
                                        }) : movies.length === 0 ? /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("p", {
                                            className: "library-notice",
                                            role: "status",
                                            children: "No movies are available."
                                        }) : filteredMovies.length === 0 ? /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("p", {
                                            className: "library-notice",
                                            role: "status",
                                            children: "No movies match your search. Try another title."
                                        }) : /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("div", {
                                            className: "movie-grid",
                                            children: filteredMovies.map((movie)=>/*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $387be721b7eb71a7$export$9bd698419030e459), {
                                                    movie: movie
                                                }, movie.id))
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $7dc78890c7af40de$export$2e2bcd8739ae039 = $7dc78890c7af40de$var$MainView;





// Surface a missing public API configuration as soon as the application starts.
(0, $70f8926b82fcac0e$export$4d28219d42798a75)();
const $01e6cce961898ab7$var$MyFlixApplication = ()=>{
    return /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $32487ffaa9d71536$export$c7dacf3845253dcf), {
        children: /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)("div", {
            className: "app-shell",
            children: /*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)((0, $7dc78890c7af40de$export$2e2bcd8739ae039), {})
        })
    });
};
const $01e6cce961898ab7$var$container = document.querySelector('#root');
const $01e6cce961898ab7$var$root = (0, $7d799523f5abb734$export$882461b6382ed46c)($01e6cce961898ab7$var$container);
$01e6cce961898ab7$var$root.render(/*#__PURE__*/ (0, $ff32bd79773053fb$exports.jsx)($01e6cce961898ab7$var$MyFlixApplication, {}));


//# sourceMappingURL=repo.a340011c.js.map
